<template>
  <div class="base_color">
    <div id="container">
      <div class="crossBox"><van-icon @click="close" class="cross" name="cross" /></div>
      <div class="clause" id="clause" ref="scrollDom">
        <div>
            <p style="margin-top:0px; margin-bottom:0px; text-align:center; widows:0; orphans:0; font-size:15px">
                <span style="font-family:'黑体'; font-weight:bold">个人信息</span>
                <span style="font-family:'黑体'; font-weight:bold">保护政策</span>
            </p>
            <p style="text-align:right; widows:0; orphans:0; font-size:10.5px">
                <span style="font-family:'宋体'">版本更新日期：2022年【8】月【18】日</span>
            </p>
            <p style="text-align:right; widows:0; orphans:0; font-size:10.5px">
                <span style="font-family:'宋体'">版本生效日期：2022年【8】月【18】日</span>
            </p>
            <p style="margin-top:0px; margin-bottom:0px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                <span style="font-family:Calibri">&#xa0;</span>
            </p>
            <p style="margin-top:0px; margin-bottom:0px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                <span style="font-family:'宋体'; font-weight:bold">概述</span>
            </p>
            <p style="margin-top:0px; margin-bottom:0px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                <span style="font-family:'宋体'">大数（以下简称</span>
                <span style="font-family:Calibri">“</span>
                <span style="font-family:'宋体'">我们</span>
                <span style="font-family:Calibri">”</span>
                <span style="font-family:'宋体'">）是</span>
                <span style="font-family:'宋体'">深圳</span>
                <span style="font-family:'宋体'">市大数融资担保有限</span>
                <span style="font-family:'宋体'">公司及其</span>
                <span style="font-family:'宋体'">关联公司的</span>
                <span style="font-family:'宋体'">总称</span>
                <span style="font-family:'宋体'">。我们使用</span>
                <span style="font-family:Calibri">“</span>
                <span style="font-family:'宋体'">大数</span>
                <span style="font-family:Calibri">”</span>
                <span style="font-family:'宋体'">品牌</span>
                <span style="font-family:'宋体'">，</span>
                <span style="font-family:'宋体'">致力于以数字信贷科技解决方案助力银行业金融机构</span>
                <span style="font-family:'宋体'">践行</span>
                <span style="font-family:'宋体'">普惠金融，为普惠金融客群及合作机构创造价值。</span>
            </p>
            <p style="margin-top:0px; margin-bottom:0px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                <span style="font-family:'宋体';">本个人</span>
                <span style="font-family:'宋体';">信息保护</span>
                <span style="font-family:'宋体';">政策（下称“本</span>
                <span style="font-family:'宋体';">政策</span>
                <span style="font-family:'宋体';">”）仅</span>
                <span style="font-family:'宋体';">适用于</span>
                <span style="font-family:'宋体';">我们</span>
                <span style="font-family:'宋体';">通过</span>
                <span style="font-family:'宋体';">合作</span>
                <span style="font-family:'宋体';">平台</span>
                <span style="font-family:'宋体';">向您提供</span>
                <span style="font-family:'宋体';">的</span>
                <span style="font-family:'宋体';">各项</span>
                <span style="font-family:'宋体';">产品和服务（</span>
                <span style="font-family:'宋体';">以下简称</span>
                <span style="font-family:Calibri;">“</span>
                <span style="font-family:'宋体';">大数</span>
                <span style="font-family:'宋体';">服务</span>
                <span style="font-family:Calibri;">”</span>
                <span style="font-family:'宋体';">）</span>
                <span style="font-family:'宋体';">，</span>
                <span style="font-family:'宋体';">合作平台的个人信息保护政策以合作平台运营方</span>
                <span style="font-family:'宋体';">向您</span>
                <span style="font-family:'宋体';">展示的为准</span>
                <span style="font-family:'宋体'">。</span>
            </p>
            <p style="margin-top:0px; margin-bottom:0px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                <span style="font-family:Calibri">&#xa0;</span>
            </p>
            <p style="margin-top:0px; margin-bottom:0px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                <span style="font-family:'宋体'; font-weight:bold">如您对本</span>
                <span style="font-family:'宋体'; font-weight:bold">政策有任何疑问</span>
                <span style="font-family:'宋体'; font-weight:bold">、</span>
                <span style="font-family:'宋体'; font-weight:bold">意见或建议，您可通过以下联系方式与我们联系：</span>
            </p>
            <p style="margin-top:0px; margin-bottom:0px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                <span style="font-family:'宋体'">公司</span>
                <span style="font-family:'宋体'">名称：深圳市大数融资担保</span>
                <span style="font-family:'宋体'">有限公司</span>
            </p>
            <p style="margin-top:0px; margin-bottom:0px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                <span style="font-family:'宋体'">联系电话</span>
                <span style="font-family:'宋体'">：</span>
                <span style="font-family:Calibri; font-weight:bold">400-081-9969</span>
            </p>
            <p style="margin-top:0px; margin-bottom:0px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                <span style="font-family:'宋体'">电子邮件</span>
                <span style="font-family:'宋体'">：</span>
                <span style="font-family:'宋体'">【</span>
                <span style="font-family:Calibri; font-weight:bold;">privacy@dashuf.com</span>
                <span style="font-family:'宋体'">】</span>
            </p>
            <p style="margin-top:0px; margin-bottom:0px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                <span style="font-family:'宋体'">注册地址</span>
                <span style="font-family:'宋体'">：</span>
                <span style="font-family:'宋体'">深圳市前海深港合作区南山街道</span>
                <span style="font-family:'宋体'">自贸西街</span>
                <span style="font-family:Calibri; font-weight:bold">18</span>
                <span style="font-family:'宋体'">号前海香</span>
                <span style="font-family:'宋体'">缤</span>
                <span style="font-family:'宋体'">大厦</span>
                <span style="font-family:Calibri; font-weight:bold">702</span>
                <span style="font-family:'宋体'">、</span>
                <span style="font-family:Calibri; font-weight:bold">703</span>
                <span style="font-family:'宋体'">、</span>
                <span style="font-family:Calibri; font-weight:bold">703A</span>
                <span style="font-family:'宋体'">、</span>
                <span style="font-family:Calibri; font-weight:bold">705</span>
                <span style="font-family:Calibri">&#xa0;</span>
            </p>
            <p style="margin-top:0px; margin-bottom:0px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                <span style="font-family:'宋体'">办公地址</span>
                <span style="font-family:'宋体'">：</span>
                <span style="font-family:'宋体'">深圳市南山区科发路</span>
                <span style="font-family:Calibri;  font-weight:bold">19</span>
                <span style="font-family:'宋体'">号华润置地大厦</span>
                <span style="font-family:Calibri; font-weight:bold">D</span>
                <span style="font-family:'宋体'">座</span>
                <span style="font-family:Calibri;font-weight:bold">23</span>
                <span style="font-family:'宋体'">层</span>
            </p>
            <p style="margin-top:0px; margin-bottom:0px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                <span style="font-family:Calibri">&#xa0;</span>
            </p>
            <p style="margin-top:0px; margin-bottom:0px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                <span style="font-family:'宋体'; font-weight:bold">【引言】</span>
            </p>
            <p style="margin-top:0px; margin-right:9.75px; margin-bottom:0px; text-indent:21.75px; font-size:10.5px; background-color:#ffffff">
                <span style="font-family:'宋体'">欢迎您使用我们的产品和服务！我们深知个人信息对您的重要性，</span>
                <span style="font-family:'宋体'">并</span>
                <span style="font-family:'宋体'">会尽</span>
                <span style="font-family:'宋体'">全力</span>
                <span style="font-family:'宋体'">保护您的个人信息安全可靠。</span>
                <span style="font-family:'宋体'">我们</span>
                <span style="font-family:'宋体'">致力于维护您对我们的信任，恪守权责一致、目的明确、选择同意、最小必要</span>
                <span style="font-family:'宋体'">、</span>
                <span style="font-family:'宋体'">确保安全、主体参与</span>
                <span style="font-family:'宋体'">和</span>
                <span style="font-family:'宋体'">公开透明原则，保护您的个人信息。同时</span>
                <span style="font-family:'宋体'">，</span>
                <span style="font-family:'宋体'">我们承诺</span>
                <span style="font-family:'宋体'">严格</span>
                <span style="font-family:'宋体'">遵守法律法规规定，</span>
                <span style="font-family:'宋体'">按</span>
                <span style="font-family:'宋体'">业界成熟的安全标准，采取相应的安全措施来保护您的个人信息。</span>
            </p>
            <p style="margin-top:0px; margin-right:9.75px; margin-bottom:0px; text-indent:21.75px; font-size:10.5px; background-color:#ffffff">
                <span style="font-family:'宋体'">为此</span>
                <span style="font-family:'宋体'">，</span>
                <span style="font-family:'宋体'">我们制定了</span>
                <span style="font-family:'宋体'">《</span>
                <span style="font-family:'宋体'">个人</span>
                <span style="font-family:'宋体'">信息保护政策》</span>
                <span style="font-family:'宋体'">（下称</span>
                <span style="font-family:'宋体'">“</span>
                <span style="font-family:'宋体'">本政策</span>
                <span style="font-family:'宋体'">”</span>
                <span style="font-family:'宋体'">），</span>
                <span style="font-family:'宋体'">帮助您充分了解在您使用我们产品和服务的过程中，我们会如何收集、使用、共享、存储和保护您的个人信息以及您可以如何</span>
                <span style="font-family:'宋体'; text-decoration:underline">管理</span>
                <span style="font-family:'宋体'">您的个人信息，以便您更好地作出适当的选择。</span>
            </p>
            <p style="margin-top:0px; margin-right:9.75px; margin-bottom:0px; text-indent:21.75px; font-size:10.5px; background-color:#ffffff">
                <span style="font-family:'宋体'">在您开始使用我们的产品和服务前，请您务必先仔细阅读和理解本政策，特别应重点阅读我们以</span>
                <span style="font-family:'宋体'; font-weight:bold; text-decoration:underline">粗体</span>
                <span style="font-weight:bold; text-decoration:underline">/</span>
                <span style="font-family:'宋体'; font-weight:bold; text-decoration:underline">粗体下划线</span>
                <span style="font-family:'宋体'">标识的条款，</span>
                <span style="font-family:'宋体'; font-weight:bold; text-decoration:underline">确保您充分理解和同意之后再开始使用</span>
                <span style="font-family:'宋体'">。本政策中涉及的专业词汇，我们尽量以简明通俗的表述向您解释，以便于您理解。</span>
            </p>
            <p style="margin-top:0px; margin-right:9.75px; margin-bottom:0px; text-indent:21.75px; font-size:10.5px; background-color:#ffffff">
                <span style="font-family:Tahoma">&#xa0;</span>
            </p>
            <p style="margin-top:0px; margin-right:9.75px; margin-bottom:0px; font-size:10.5px; background-color:#ffffff">
                <span style="font-family:'宋体'; font-weight:bold">本政策</span>
                <span style="font-family:'宋体'; font-weight:bold">将</span>
                <span style="font-family:'宋体'; font-weight:bold">帮助您了解</span>
                <span style="font-family:'宋体'; font-weight:bold">以下</span>
                <span style="font-family:'宋体'; font-weight:bold">内容：</span>
            </p>
            <div style="margin-right:9.75px; background-color:#ffffff">
                <p style="margin-top:0px; margin-left:21px; margin-bottom:0px; text-indent:-21px; font-size:10.5px">
                    <span style="font-family:'宋体'">一、</span>
                    <span style="font-family:'宋体'">定义</span>
                </p>
            </div>
            <div style="margin-right:9.75px; background-color:#ffffff">
                <p style="margin-top:0px; margin-left:21px; margin-bottom:0px; text-indent:-21px; font-size:10.5px">
                    <span style="font-family:'宋体'">二、</span>
                    <span style="font-family:'宋体'">我们</span>
                    <span style="font-family:'宋体'">收集</span>
                    <span style="font-family:'宋体'">、使用个人信息的目的及范围</span>
                </p>
            </div>
            <div style="margin-right:9.75px; background-color:#ffffff">
                <p style="margin-top:0px; margin-left:21px; margin-bottom:0px; text-indent:-21px; font-size:10.5px">
                    <span style="font-family:'宋体'">三、</span>
                    <span style="font-family:'宋体'">我们</span>
                    <span style="font-family:'宋体'">如何收集</span>
                    <span style="font-family:'宋体'">您</span>
                    <span style="font-family:'宋体'">的</span>
                    <span style="font-family:'宋体'">个人</span>
                    <span style="font-family:'宋体'">信息</span>
                </p>
            </div>
            <div style="margin-right:9.75px; background-color:#ffffff">
                <p style="margin-top:0px; margin-left:21px; margin-bottom:0px; text-indent:-21px; font-size:10.5px">
                    <span style="font-family:'宋体'">四、</span>
                    <span style="font-family:'宋体'">我们</span>
                    <span style="font-family:'宋体'">如何适用</span>
                    <span style="font-family:Tahoma">COOKIES</span>
                    <span style="font-family:'宋体'">和</span>
                    <span style="font-family:'宋体'">同类技术</span>
                </p>
            </div>
            <div style="margin-right:9.75px; background-color:#ffffff">
                <p style="margin-top:0px; margin-left:21px; margin-bottom:0px; text-indent:-21px; font-size:10.5px">
                    <span style="font-family:'宋体'">五、</span>
                    <span style="font-family:'宋体'">我们</span>
                    <span style="font-family:'宋体'">如何</span>
                    <span style="font-family:'宋体'">委托处理、</span>
                    <span style="font-family:'宋体'">共享、转让、公开</span>
                    <span style="font-family:'宋体'">披露个人</span>
                    <span style="font-family:'宋体'">信息</span>
                </p>
            </div>
            <div style="margin-right:9.75px; background-color:#ffffff">
                <p style="margin-top:0px; margin-left:21px; margin-bottom:0px; text-indent:-21px; font-size:10.5px">
                    <span style="font-family:'宋体'">六、</span>
                    <span style="font-family:'宋体'">我们</span>
                    <span style="font-family:'宋体'">如何存储个人信息</span>
                </p>
            </div>
            <div style="margin-right:9.75px; background-color:#ffffff">
                <p style="margin-top:0px; margin-left:21px; margin-bottom:0px; text-indent:-21px; font-size:10.5px">
                    <span style="font-family:'宋体'">七、</span>
                    <span style="font-family:'宋体'">我们</span>
                    <span style="font-family:'宋体'">如何保护个人信息</span>
                </p>
            </div>
            <div style="margin-right:9.75px; background-color:#ffffff">
                <p style="margin-top:0px; margin-left:21px; margin-bottom:0px; text-indent:-21px; font-size:10.5px">
                    <span style="font-family:'宋体'">八、</span>
                    <span style="font-family:'宋体'">您</span>
                    <span style="font-family:'宋体'">的权利</span>
                </p>
            </div>
            <div style="margin-right:9.75px; background-color:#ffffff">
                <p style="margin-top:0px; margin-left:21px; margin-bottom:0px; text-indent:-21px; font-size:10.5px">
                    <span style="font-family:'宋体'">九、</span>
                    <span style="font-family:'宋体'">我们</span>
                    <span style="font-family:'宋体'">如何处理</span>
                    <span style="font-family:'宋体'">未成年人</span>
                    <span style="font-family:'宋体'">的个人信息</span>
                </p>
            </div>
            <div style="margin-right:9.75px; background-color:#ffffff">
                <p style="margin-top:0px; margin-left:21px; margin-bottom:0px; text-indent:-21px; font-size:10.5px">
                    <span style="font-family:'宋体'">十、</span>
                    <span style="font-family:'宋体'">本政策</span>
                    <span style="font-family:'宋体'">如何更新</span>
                </p>
            </div>
            <div style="margin-right:9.75px; background-color:#ffffff">
                <p style="margin-top:0px; margin-left:21px; margin-bottom:0px; text-indent:-21px; font-size:10.5px">
                    <span style="font-family:'宋体'">十一、</span>
                    <span style="font:7px 'Times New Roman'">&#xa0;&#xa0;</span>
                    <span style="font-family:'宋体'">如何</span>
                    <span style="font-family:'宋体'">联系我们</span>
                </p>
            </div>
            <p style="margin-top:0px; margin-bottom:0px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                <span style="font-family:Calibri">&#xa0;</span>
            </p>
            <p style="margin-top:0px; margin-left:21px; margin-bottom:0px; text-indent:-21px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                <span style="font-family:'宋体'; font-weight:bold">一、</span>
                <span style="font:7px 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;</span>
                <span style="font-family:'宋体'; font-weight:bold">定义</span>
            </p>
            <p style="margin-top:0px; margin-left:21px; margin-bottom:0px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                <span style="font-family:'宋体'; font-weight:bold">大数</span>
                <span style="font-family:Calibri; font-weight:bold">/</span>
                <span style="font-family:'宋体'; font-weight:bold">我们</span>
                <span style="font-family:'宋体'; font-weight:bold">：</span>
                <span style="font-family:'宋体'">指</span>
                <span style="font-family:'宋体'">深圳市大数融资担保</span>
                <span style="font-family:'宋体'">有限公司</span>
                <span style="font-family:'宋体'">及其</span>
                <span style="font-family:'宋体'">关联公司。</span>
            </p>
            <p style="margin-top:0px; margin-bottom:0px; text-indent:21.1px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                <span style="font-family:'宋体'; font-weight:bold">关联公司</span>
                <span style="font-family:'宋体'; font-weight:bold">：</span>
                <span style="font-family:'宋体'">指</span>
                <span style="font-family:'宋体'">深圳大数信科技术有限公司</span>
                <span style="font-family:'宋体'">、深圳前海</span>
                <span style="font-family:'宋体'">大数信息服务有限</span>
                <span style="font-family:'宋体'">公司</span>
                <span style="font-family:'宋体'">、深圳前海</span>
                <span style="font-family:'宋体'">大</span>
                <span style="font-family:'宋体'">衍</span>
                <span style="font-family:'宋体'">信息</span>
                <span style="font-family:'宋体'">科技有限公司、武汉融生融资担保有限公司、</span>
                <span style="font-family:'宋体'">深圳市</span>
                <span style="font-family:'宋体'">半刻</span>
                <span style="font-family:'宋体'">信息</span>
                <span style="font-family:'宋体'">科技</span>
                <span style="font-family:'宋体'">有限公司、深圳前海大道金融服务有限公司。</span>
            </p>
            <p style="margin-top:0px; margin-right:9.65px; margin-bottom:0px; text-indent:21px; text-align:justify; font-size:10.5px; background-color:#ffffff">
                <span style="font-family:'宋体'; font-weight:bold">合作</span>
                <span style="font-family:'宋体'; font-weight:bold">平台：</span>
                <span style="font-family:'宋体'">指我们与之</span>
                <span style="font-family:'宋体'">联合推出</span>
                <span style="font-family:'宋体'">有关</span>
                <span style="font-family:'宋体'">网络产品的平台，包括但不限于</span>
                <span style="font-family:'宋体'">各类网站</span>
                <span style="font-family:'宋体'">、</span>
                <span style="font-family:'宋体'">APP、</span>
                <span style="font-family:'宋体'">小程序、微信公众号、</span>
                <span style="font-family:'宋体'">H5页面。</span>
            </p>
            <p style="margin-top:0px; margin-right:9.65px; margin-bottom:0px; text-indent:21px; text-align:justify; font-size:10.5px; background-color:#ffffff">
                <span style="font-family:'宋体'; font-weight:bold">放款机构</span>
                <span style="font-family:'宋体'; font-weight:bold">：</span>
                <span style="font-family:'宋体'">指与</span>
                <span style="font-family:'宋体'">我们</span>
                <span style="font-family:'宋体'">进行</span>
                <span style="font-family:'宋体'">合作，</span>
                <span style="font-family:'宋体'">实际向</span>
                <span style="font-family:'宋体'">您提供</span>
                <span style="font-family:'宋体'">贷款</span>
                <span style="font-family:'宋体'">的</span>
                <span style="font-family:'宋体'">具有</span>
                <span style="font-family:'宋体'">放款资质</span>
                <span style="font-family:'宋体'">的机构</span>
                <span style="font-family:'宋体'">，比如</span>
                <span style="font-family:'宋体'">银行和</span>
                <span style="font-family:'宋体'">消费金融公司。</span>
            </p>
            <p style="margin-top:0px; margin-right:9.75px; margin-bottom:0px; text-indent:21px; font-size:10.5px; background-color:#ffffff">
                <span style="font-family:'宋体'; font-weight:bold">个人信息：</span>
                <span style="font-family:'宋体'">指以电子或者其他方式记录的</span>
                <span style="font-family:'宋体'">与已识别或者可识别的自然人有关的</span>
                <span style="font-family:'宋体'">各种信息</span>
                <span style="font-family:'宋体'">，不包括匿名化处理后的信息</span>
                <span style="font-family:'宋体'">。</span>
            </p>
            <p style="margin-top:0px; margin-right:9.75px; margin-bottom:0px; font-size:10.5px; background-color:#ffffff">
                <span style="font-family:'宋体'">&#xa0;</span>
                <span style="font-family:'宋体'"></span>
                <span style="font-family:'宋体'; font-weight:bold">个人敏感信息：</span>
                <span style="font-family:'宋体'">指</span>
                <span style="font-family:'宋体'">一旦</span>
                <span style="font-family:'宋体'">泄露</span>
                <span style="font-family:'宋体'">或者非法使用，可能</span>
                <span style="font-family:'宋体'">导致</span>
                <span style="font-family:'宋体'">个人受到歧视或者人身、财产受到严重危害</span>
                <span style="font-family:'宋体'">的</span>
                <span style="font-family:'宋体'">个人信息，包括</span>
                <span style="font-family:'宋体'; font-weight:bold">种族、民族、宗教信仰、个人</span>
                <span style="font-family:'宋体'; font-weight:bold">生物</span>
                <span style="font-family:'宋体'; font-weight:bold">特征、医疗健康、金融账户、个人行踪</span>
                <span style="font-family:'宋体'">等</span>
                <span style="font-family:'宋体'">信息</span>
                <span style="font-family:'宋体'">（我们将在本政策中对具体个人敏感信息以</span>
                <span style="font-family:'宋体'; font-weight:bold">粗体</span>
                <span style="font-family:'宋体'">进行显著标识）。</span>
            </p>
            <p style="margin-top:0px; margin-right:9.75px; margin-bottom:0px; font-size:10.5px; background-color:#ffffff">
                <span style="font-family:'宋体'">&#xa0;</span>
                <span style="font-family:'宋体'"></span>
                <span style="font-family:'宋体'; font-weight:bold">未成年人</span>
                <span style="font-family:'宋体'">：指不满十</span>
                <span style="font-family:'宋体'">八</span>
                <span style="font-family:'宋体'">周岁的</span>
                <span style="font-family:'宋体'">自然人</span>
                <span style="font-family:'宋体'">。</span>
            </p>
            <p style="margin-top:0px; margin-left:21px; margin-bottom:0px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                <span style="font-family:Calibri">&#xa0;</span>
            </p>
            <p style="margin-top:0px; margin-left:21px; margin-bottom:0px; text-indent:-21px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                <span style="font-family:'宋体'">二、</span>
                <span style="font:7px 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;</span>
                <span style="font-family:'宋体'; font-weight:bold">我们</span>
                <span style="font-family:'宋体'; font-weight:bold">收集</span>
                <span style="font-family:'宋体'; font-weight:bold">、使用个人信息的目的及范围</span>
            </p>
            <p style="margin-top:0px; margin-bottom:0px; text-indent:21px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                <span style="font-family:'宋体'">为符合</span>
                <span style="font-family:'宋体'">国家</span>
                <span style="font-family:'宋体'">法律</span>
                <span style="font-family:'宋体'">法规规定</span>
                <span style="font-family:'宋体'">和</span>
                <span style="font-family:'宋体'">实现本政策所述的</span>
                <span style="font-family:'宋体'">下述业务</span>
                <span style="font-family:'宋体'">功能，我们会</span>
                <span style="font-family:'宋体'">在</span>
                <span style="font-family:'宋体'">遵循合法、正当、必要原则的前提下，</span>
                <span style="font-family:'宋体'">收集</span>
                <span style="font-family:'宋体'">和使用您在使用大数</span>
                <span style="font-family:'宋体'">服务</span>
                <span style="font-family:'宋体'">过程中主动提供</span>
                <span style="font-family:'宋体'">和</span>
                <span style="font-family:'宋体'">因使用大数</span>
                <span style="font-family:'宋体'">服务而产生或需向</span>
                <span style="font-family:'宋体'">第三方</span>
                <span style="font-family:'宋体'">收集的下述</span>
                <span style="font-family:'宋体'">个人信息</span>
                <span style="font-family:'宋体'">。</span>
            </p>
            <ol type="1" style="margin:0px; padding-left:0px">
                <li style="margin-left:34.91px; text-align:justify; widows:0; orphans:0; padding-left:4.09px; font-family:Tahoma; font-size:10.5px; font-weight:bold">
                    <span style="font-family:'宋体'">1.账号注册与</span>
                    <span style="font-family:'宋体'">登录</span>
                </li>
            </ol>
            <p style="margin-top:0px; margin-bottom:0px; text-indent:21px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                <span style="font-family:'宋体'">当您选择</span>
                <span style="font-family:'宋体'">注册大数</span>
                <span style="font-family:'宋体'">合作</span>
                <span style="font-family:'宋体'">平台账号时，您</span>
                <span style="font-family:'宋体'">可能</span>
                <span style="font-family:'宋体'">需要主动向我们提供您</span>
                <span style="font-family:'宋体'">本人</span>
                <span style="font-family:'宋体'">的</span>
                <span style="font-family:'宋体'; font-weight:bold">手机号码</span>
                <span style="font-family:'宋体'">和</span>
                <span style="font-family:'宋体'">拟</span>
                <span style="font-family:'宋体'">设置</span>
                <span style="font-family:'宋体'">的</span>
                <span style="font-family:'宋体'; font-weight:bold">登陆</span>
                <span style="font-family:'宋体'; font-weight:bold">密码</span>
                <span style="font-family:'宋体'">，我们将通过向您提供的</span>
                <span style="font-family:'宋体'">手机号</span>
                <span style="font-family:'宋体'">发送验证短信并收集您反馈的验证码的方式验证是您本人操作。</span>
                <span style="font-family:'宋体'; font-weight:bold">手机号码</span>
                <span style="font-family:'宋体'">、</span>
                <span style="font-family:'宋体'; font-weight:bold">登陆</span>
                <span style="font-family:'宋体'; font-weight:bold">密码</span>
                <span style="font-family:'宋体'">和</span>
                <span style="font-family:'宋体'; font-weight:bold">验证码</span>
                <span style="font-family:'宋体'">为必要信息，如果您不提供，您将无法完成注册。当您</span>
                <span style="font-family:'宋体'">登陆</span>
                <span style="font-family:'宋体'">大数</span>
                <span style="font-family:'宋体'">合作平台</span>
                <span style="font-family:'宋体'">时，您需要主动向我们提供您本人的</span>
                <span style="font-family:'宋体'; font-weight:bold">手机号</span>
                <span style="font-family:'宋体'">和</span>
                <span style="font-family:'宋体'; font-weight:bold">登录密码</span>
                <span style="font-family:'宋体'">，用于登陆</span>
                <span style="font-family:'宋体'">并</span>
                <span style="font-family:'宋体'">验证是您本人操作。</span>
            </p>
            <ol start="2" type="1" style="margin:0px; padding-left:0px">
                <li style="margin-left:34.91px; text-align:justify; widows:0; orphans:0; padding-left:4.09px; font-family:Tahoma; font-size:10.5px; font-weight:bold">
                    <span style="font-family:'宋体'">2.身份</span>
                    <span style="font-family:'宋体'">识别</span>
                    <span style="font-family:'宋体'">与实名</span>
                    <span style="font-family:'宋体'">认证</span>
                </li>
            </ol>
            <p style="margin-top:0px; margin-bottom:0px; text-indent:21px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                <span style="font-family:'宋体'">为了识别</span>
                <span style="font-family:'宋体'">您的身份，以及</span>
                <span style="font-family:'宋体'">履行国家</span>
                <span style="font-family:'宋体'">法律法规规定的反洗钱和</span>
                <span style="font-family:'宋体'">实名认证义务</span>
                <span style="font-family:'宋体'">，</span>
                <span style="font-family:'宋体'">您</span>
                <span style="font-family:'宋体'">需要</span>
                <span style="font-family:'宋体'">向我们</span>
                <span style="font-family:'宋体'">提供您的</span>
                <span style="font-family:'宋体'; font-weight:bold">真实姓名</span>
                <span style="font-family:'宋体'">、</span>
                <span style="font-family:'宋体'; font-weight:bold">身份证件</span>
                <span style="font-family:'宋体'; font-weight:bold">信息</span>
                <span style="font-family:'宋体'">（</span>
                <span style="font-family:'宋体'; font-weight:bold">身份证号码</span>
                <span style="font-family:'宋体'; font-weight:bold">、户籍地址、民族、</span>
                <span style="font-family:'宋体'; font-weight:bold">发证机关</span>
                <span style="font-family:'宋体'; font-weight:bold">、有效期、</span>
                <span style="font-family:'宋体'; font-weight:bold">身份证</span>
                <span style="font-family:'宋体'; font-weight:bold">正反面影像</span>
                <span style="font-family:'宋体'">）</span>
                <span style="font-family:'宋体'">。除了完成身份</span>
                <span style="font-family:'宋体'">识别和实名制管理外</span>
                <span style="font-family:'宋体'">，</span>
                <span style="font-family:'宋体'">为了防范欺诈风险，保障账号安全，您</span>
                <span style="font-family:'宋体'">还</span>
                <span style="font-family:'宋体'">需要进行</span>
                <span style="font-family:'宋体'">多重</span>
                <span style="font-family:'宋体'">身份</span>
                <span style="font-family:'宋体'">综合</span>
                <span style="font-family:'宋体'">认证，</span>
                <span style="font-family:'宋体'">您可能要</span>
                <span style="font-family:'宋体'">向我们提供</span>
                <span style="font-family:'宋体'">您</span>
                <span style="font-family:'宋体'">的</span>
                <span style="font-family:'宋体'; font-weight:bold">人脸</span>
                <span style="font-family:'宋体'; font-weight:bold">照片</span>
                <span style="font-family:Tahoma; font-weight:bold">/</span>
                <span style="font-family:'宋体'; font-weight:bold">视频、</span>
                <span style="font-family:'宋体'">开户行名称</span>
                <span style="font-family:'宋体'">、</span>
                <span style="font-family:'宋体'; font-weight:bold">银行卡号、</span>
                <span style="font-family:'宋体'; font-weight:bold">手</span>
                <span style="font-family:'宋体'; font-weight:bold">机号</span>
                <span style="font-family:'宋体'; font-weight:bold">、验证码</span>
                <span style="font-family:'宋体'">、</span>
                <span style="font-family:'宋体'">证件类型、</span>
                <span style="font-family:'宋体'; font-weight:bold">证件号码</span>
                <span style="font-family:'宋体'">、</span>
                <span style="font-family:'宋体'">持卡人</span>
                <span style="font-family:'宋体'">姓名</span>
                <span style="font-family:'宋体'">。</span>
                <span style="font-family:'宋体'">为了</span>
                <span style="font-family:'宋体'">准确</span>
                <span style="font-family:'宋体'">有效完成身份认证，您同意我们将前述身份识别信息提交给第三方</span>
                <span style="font-family:'宋体'">身份</span>
                <span style="font-family:'宋体'">验证机构。</span>
                <span style="font-family:'宋体'">前述</span>
                <span style="font-family:'宋体'">信息</span>
                <span style="font-family:'宋体'">为</span>
                <span style="font-family:'宋体'">必要信息，</span>
                <span style="font-family:'宋体'">如果</span>
                <span style="font-family:'宋体'">您不提供，您将可能无法完成身份认证。</span>
            </p>
            <ol start="3" type="1" style="margin:0px; padding-left:0px">
                <li style="margin-left:34.91px; text-align:justify; widows:0; orphans:0; padding-left:4.09px; font-family:Tahoma; font-size:10.5px; font-weight:bold">
                    <span style="font-family:'宋体'">3.与您进行</span>
                    <span style="font-family:'宋体'">联系</span>
                    <span style="font-family:'宋体'">、还款</span>
                    <span style="font-family:'宋体'">提醒和逾期债务追索</span>
                </li>
            </ol>
            <p style="margin-top:0px; margin-bottom:0px; text-indent:21px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                <span style="font-family:'宋体'">为了</span>
                <span style="font-family:'宋体'">方便</span>
                <span style="font-family:'宋体'">联系</span>
                <span style="font-family:'宋体'">您</span>
                <span style="font-family:'宋体'">、</span>
                <span style="font-family:'宋体'">为您提供还款提醒服务</span>
                <span style="font-family:'宋体'">和</span>
                <span style="font-family:'宋体'">向您追索逾期债务，</span>
                <span style="font-family:'宋体'">以及</span>
                <span style="font-family:'宋体'">在</span>
                <span style="font-family:'宋体'">无法</span>
                <span style="font-family:'宋体'">有效与</span>
                <span style="font-family:'宋体'">您</span>
                <span style="font-family:'宋体'">取得联系时的特定情况下联系您</span>
                <span style="font-family:'宋体'">的紧急</span>
                <span style="font-family:'宋体'">联系人，我们将收集并使用您的联系方式（</span>
                <span style="font-family:'宋体'; font-weight:bold">电话</span>
                <span style="font-family:'宋体'; font-weight:bold">号码</span>
                <span style="font-family:'宋体'">和</span>
                <span style="font-family:'宋体'">即时通信</span>
                <span style="font-family:'宋体'">账号）</span>
                <span style="font-family:'宋体'">、</span>
                <span style="font-family:'宋体'; font-weight:bold">居住地址信息</span>
                <span style="font-family:'宋体'">和</span>
                <span style="font-family:'宋体'; font-weight:bold">紧急</span>
                <span style="font-family:'宋体'; font-weight:bold">联系人信息</span>
                <span style="font-family:'宋体'">（</span>
                <span style="font-family:'宋体'">姓名、</span>
                <span style="font-family:'宋体'">与您</span>
                <span style="font-family:'宋体'">的</span>
                <span style="font-family:'宋体'">关系</span>
                <span style="font-family:'宋体'">以及</span>
                <span style="font-family:'宋体'; font-weight:bold">电话</span>
                <span style="font-family:'宋体'; font-weight:bold">号码</span>
                <span style="font-family:'宋体'">）</span>
                <span style="font-family:'宋体'">。</span>
            </p>
            <p style="margin-top:0px; margin-bottom:0px; text-indent:21px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                <span style="font-family:'宋体'; font-weight:bold; text-decoration:underline">请您确保您</span>
                <span style="font-family:'宋体'; font-weight:bold; text-decoration:underline">在向我们提供</span>
                <span style="font-family:'宋体'; font-weight:bold; text-decoration:underline">您</span>
                <span style="font-family:'宋体'; font-weight:bold; text-decoration:underline">的</span>
                <span style="font-family:'宋体'; font-weight:bold; text-decoration:underline">紧急</span>
                <span style="font-family:'宋体'; font-weight:bold; text-decoration:underline">联系人信息时已经获得</span>
                <span style="font-family:'宋体'; font-weight:bold; text-decoration:underline">他们</span>
                <span style="font-family:'宋体'; font-weight:bold; text-decoration:underline">的同意，以便我们或</span>
                <span style="font-family:'宋体'; font-weight:bold; text-decoration:underline">我们</span>
                <span style="font-family:'宋体'; font-weight:bold; text-decoration:underline">的合作方可以通过您提供的联系方式进行联系</span>
                <span style="font-family:'宋体'; font-weight:bold; text-decoration:underline">。如您</span>
                <span style="font-family:'宋体'; font-weight:bold; text-decoration:underline">向我们提供您的</span>
                <span style="font-family:'宋体'; font-weight:bold; text-decoration:underline">紧急</span>
                <span style="font-family:'宋体'; font-weight:bold; text-decoration:underline">联系人</span>
                <span style="font-family:'宋体'; font-weight:bold; text-decoration:underline">信息</span>
                <span style="font-family:'宋体'; font-weight:bold; text-decoration:underline">的行为未经过</span>
                <span style="font-family:'宋体'; font-weight:bold; text-decoration:underline">紧急</span>
                <span style="font-family:'宋体'; font-weight:bold; text-decoration:underline">联系人本人的</span>
                <span style="font-family:'宋体'; font-weight:bold; text-decoration:underline">同意</span>
                <span style="font-family:'宋体'; font-weight:bold; text-decoration:underline">，我们</span>
                <span style="font-family:'宋体'; font-weight:bold; text-decoration:underline">与其</span>
                <span style="font-family:'宋体'; font-weight:bold; text-decoration:underline">联系所发生的风险及责任将由您负责承担。</span>
            </p>
            <ol start="4" type="1" style="margin:0px; padding-left:0px">
                <li style="margin-left:34.91px; text-align:justify; widows:0; orphans:0; padding-left:4.09px; font-family:Tahoma; font-size:10.5px; font-weight:bold">
                    <span style="font-family:'宋体'">4.资格</span>
                    <span style="font-family:'宋体'">、信用</span>
                    <span style="font-family:'宋体'">、</span>
                    <span style="font-family:'宋体'">偿付能力</span>
                    <span style="font-family:'宋体'">评估，确定</span>
                    <span style="font-family:'宋体'">授信</span>
                    <span style="font-family:'宋体'">额度</span>
                    <span style="font-family:'宋体'">以及借款产品推荐服务</span>
                </li>
            </ol>
            <p style="margin-top:0px; margin-bottom:0px; text-indent:21px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                <span style="font-family:'宋体'">为了</span>
                <span style="font-family:'宋体'">准确</span>
                <span style="font-family:'宋体'">评估</span>
                <span style="font-family:'宋体'">您的</span>
                <span style="font-family:'宋体'">贷款</span>
                <span style="font-family:'宋体'">和担保资格、信用及偿付能力</span>
                <span style="font-family:'宋体'">、确定授信额度，为您推荐合适的借款产品</span>
                <span style="font-family:'宋体'">，也为了维护您、我们</span>
                <span style="font-family:'宋体'">及放款机构的</span>
                <span style="font-family:'宋体'">合法权益，更为了防止您的贷款资金被不法分子获取、</span>
                <span style="font-family:'宋体'">防范</span>
                <span style="font-family:'宋体'">欺诈风险</span>
                <span style="font-family:'宋体'">、</span>
                <span style="font-family:'宋体'">保障您的资金安全，您同意我们</span>
                <span style="font-family:'宋体'">根据</span>
                <span style="font-family:'宋体'">不同的产品或服务需要，分别或</span>
                <span style="font-family:'宋体'">同时收集</span>
                <span style="font-family:'宋体'">您的</span>
                <span style="font-family:'宋体'">如下</span>
                <span style="font-family:'宋体'">信息</span>
                <span style="font-family:'宋体'">（</span>
                <span style="font-family:'宋体'; font-weight:bold; text-decoration:underline">具体</span>
                <span style="font-family:'宋体'; font-weight:bold; text-decoration:underline">以</span>
                <span style="font-family:'宋体'; font-weight:bold; text-decoration:underline">您选择</span>
                <span style="font-family:'宋体'; font-weight:bold; text-decoration:underline">的相应产品或服务页面向您展示，并需要您主动填写</span>
                <span style="font-family:'宋体'; font-weight:bold; text-decoration:underline">，</span>
                <span style="font-family:'宋体'; font-weight:bold; text-decoration:underline">或者</span>
                <span style="font-family:'宋体'; font-weight:bold; text-decoration:underline">需要您</span>
                <span style="font-family:'宋体'; font-weight:bold; text-decoration:underline">单独提供授权进行</span>
                <span style="font-family:'宋体'; font-weight:bold; text-decoration:underline">收集</span>
                <span style="font-family:'宋体'; font-weight:bold; text-decoration:underline">的为准</span>
                <span style="font-family:'宋体'">）</span>
                <span style="font-family:'宋体'">：</span>
            </p>
            <p style="margin-top:0px; margin-bottom:0px; text-indent:21px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                <span style="font-family:'宋体'">（</span>
                <span style="font-family:Tahoma">1</span>
                <span style="font-family:'宋体'">）</span>
                <span style="font:7px 'Times New Roman'"></span>
                <span style="font-family:'宋体'">您</span>
                <span style="font-family:'宋体'">的婚姻状况</span>
                <span style="font-family:'宋体'">信息（婚姻</span>
                <span style="font-family:'宋体'">状态</span>
                <span style="font-family:'宋体'">及其</span>
                <span style="font-family:'宋体'">证明文件</span>
                <span style="font-family:'宋体'">）</span>
                <span style="font-family:'宋体'">、配偶信息（</span>
                <span style="font-family:'宋体'">姓名、</span>
                <span style="font-family:'宋体'; font-weight:bold">身份证号</span>
                <span style="font-family:'宋体'">、</span>
                <span style="font-family:'宋体'; font-weight:bold">电话号码</span>
                <span style="font-family:'宋体'">、</span>
                <span style="font-family:'宋体'; font-weight:bold">财产信息</span>
                <span style="font-family:'宋体'">）</span>
                <span style="font-family:'宋体'">；</span>
            </p>
            <p style="margin-top:0px; margin-left:49.65px; margin-bottom:0px; text-indent:-28.65px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                <span style="font-family:'宋体'">（</span>
                <span style="font-family:Tahoma">2</span>
                <span style="font-family:'宋体'">）</span>
                <span style="font:7px 'Times New Roman'"></span>
                <span style="font-family:'宋体'">您</span>
                <span style="font-family:'宋体'">的教育</span>
                <span style="font-family:'宋体'">信息：学历</span>
                <span style="font-family:'宋体'">、学位、毕业院校</span>
                <span style="font-family:'宋体'">；</span>
            </p>
            <p style="margin-top:0px; margin-bottom:0px; text-indent:21px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                <span style="font-family:'宋体'">（</span>
                <span style="font-family:Tahoma">3</span>
                <span style="font-family:'宋体'">）</span>
                <span style="font:7px 'Times New Roman'"></span>
                <span style="font-family:'宋体'">您</span>
                <span style="font-family:'宋体'">的工作信息：</span>
                <span style="font-family:'宋体'">个人</span>
                <span style="font-family:'宋体'">职业（</span>
                <span style="font-family:'宋体'">企业主</span>
                <span style="font-family:Tahoma">/</span>
                <span style="font-family:'宋体'">上班族</span>
                <span style="font-family:'宋体'">）</span>
                <span style="font-family:'宋体'">、</span>
                <span style="font-family:'宋体'">职位、单位名称、</span>
                <span style="font-family:'宋体'">单位</span>
                <span style="font-family:'宋体'">成立日期、单位地址、</span>
                <span style="font-family:'宋体'">工作</span>
                <span style="font-family:'宋体'">经历</span>
                <span style="font-family:'宋体'">、工作</span>
                <span style="font-family:'宋体'">单位电话、单位人事部联系信息（</span>
                <span style="font-family:'宋体'">姓名</span>
                <span style="font-family:'宋体'">、</span>
                <span style="font-family:'宋体'; font-weight:bold">电话号码</span>
                <span style="font-family:'宋体'">）</span>
                <span style="font-family:'宋体'">；</span>
            </p>
            <p style="margin-top:0px; margin-bottom:0px; text-indent:21px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                <span style="font-family:'宋体'">（</span>
                <span style="font-family:Tahoma">4</span>
                <span style="font-family:'宋体'">）</span>
                <span style="font:7px 'Times New Roman'"></span>
                <span style="font-family:'宋体'; font-weight:bold">您</span>
                <span style="font-family:'宋体'; font-weight:bold">的财产信息：</span>
                <span style="font-family:'宋体'; font-weight:bold">持股</span>
                <span style="font-family:'宋体'; font-weight:bold">信</span>
                <span style="font-family:'宋体'; font-weight:bold">息</span>
                <span style="font-family:'宋体'; font-weight:bold">、社保</span>
                <span style="font-family:'宋体'; font-weight:bold">信息、公积金</span>
                <span style="font-family:'宋体'; font-weight:bold">信息</span>
                <span style="font-family:'宋体'; font-weight:bold">、房产信息、车辆信息、寿险保单信息、信用卡</span>
                <span style="font-family:'宋体'; font-weight:bold">信息</span>
                <span style="font-family:'宋体'; font-weight:bold">、车贷信息、</span>
                <span style="font-family:'宋体'; font-weight:bold">以及前述</span>
                <span style="font-family:'宋体'; font-weight:bold">财产信息的影像</span>
                <span style="font-family:'宋体'; font-weight:bold">证明</span>
                <span style="font-family:'宋体'; font-weight:bold">资料</span>
                <span style="font-family:'宋体'">；</span>
            </p>
            <p style="margin-top:0px; margin-left:49.65px; margin-bottom:0px; text-indent:-28.65px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                <span style="font-family:'宋体'">（</span>
                <span style="font-family:Tahoma">5</span>
                <span style="font-family:'宋体'">）</span>
                <span style="font:7px 'Times New Roman'"></span>
                <span style="font-family:'宋体'">您</span>
                <span style="font-family:'宋体'">的</span>
                <span style="font-family:'宋体'; font-weight:bold">居住地址</span>
                <span style="font-family:'宋体'; font-weight:bold">信息</span>
                <span style="font-family:'宋体'">；</span>
            </p>
            <p style="margin-top:0px; margin-bottom:0px; text-indent:21px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                <span style="font-family:'宋体'">（</span>
                <span style="font-family:Tahoma">6</span>
                <span style="font-family:'宋体'">）</span>
                <span style="font:7px 'Times New Roman'"></span>
                <span style="font-family:'宋体'">您</span>
                <span style="font-family:'宋体'">的</span>
                <span style="font-family:'宋体'; font-weight:bold">征信</span>
                <span style="font-family:'宋体'; font-weight:bold">信息</span>
                <span style="font-family:'宋体'">、</span>
                <span style="font-family:'宋体'">所投资</span>
                <span style="font-family:'宋体'">企业工商信息、</span>
                <span style="font-family:'宋体'; font-weight:bold">所投资企业纳税和发票信息</span>
                <span style="font-family:'宋体'">、</span>
                <span style="font-family:'宋体'">司法</span>
                <span style="font-family:'宋体'">信息、行政处罚信息、</span>
                <span style="font-family:'宋体'">航旅</span>
                <span style="font-family:'宋体'">信息、</span>
                <span style="font-family:'宋体'">设备</span>
                <span style="font-family:'宋体'">信息、</span>
                <span style="font-family:'宋体'; font-weight:bold">第三方</span>
                <span style="font-family:'宋体'; font-weight:bold">借贷信息</span>
                <span style="font-family:'宋体'">、</span>
                <span style="font-family:'宋体'">第三方</span>
                <span style="font-family:'宋体'">信用评分</span>
                <span style="font-family:Tahoma">/</span>
                <span style="font-family:'宋体'">标签信息；</span>
            </p>
            <p style="margin-top:0px; margin-bottom:0px; text-indent:21px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                <span style="font-family:'宋体'">（</span>
                <span style="font-family:Tahoma">7</span>
                <span style="font-family:'宋体'">）</span>
                <span style="font:7px 'Times New Roman'"></span>
                <span style="font-family:'宋体'">电话</span>
                <span style="font-family:'宋体'">核验期间的</span>
                <span style="font-family:'宋体'; font-weight:bold">录音</span>
                <span style="font-family:'宋体'; font-weight:bold">信息</span>
                <span style="font-family:'宋体'">：</span>
                <span style="font-family:'宋体'">我们</span>
                <span style="font-family:'宋体'">将通过</span>
                <span style="font-family:'宋体'">电话</span>
                <span style="font-family:'宋体'">与</span>
                <span style="font-family:'宋体'">您</span>
                <span style="font-family:'宋体'">核验</span>
                <span style="font-family:'宋体'">您所填写</span>
                <span style="font-family:'宋体'">和</span>
                <span style="font-family:'宋体'">提交的</span>
                <span style="font-family:'宋体'">有关信息</span>
                <span style="font-family:'宋体'">，</span>
                <span style="font-family:'宋体'">并对</span>
                <span style="font-family:'宋体'">通话进行</span>
                <span style="font-family:'宋体'">全程录音；</span>
            </p>
            <p style="margin-top:0px; margin-bottom:0px; text-indent:21px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                <span style="font-family:'宋体'">（</span>
                <span style="font-family:Tahoma">8</span>
                <span style="font-family:'宋体'">）</span>
                <span style="font:7px 'Times New Roman'"></span>
                <span style="font-family:'宋体'">视频面签</span>
                <span style="font-family:'宋体'">期间的</span>
                <span style="font-family:'宋体'; font-weight:bold">录音、录像</span>
                <span style="font-family:'宋体'; font-weight:bold">信息</span>
                <span style="font-family:'宋体'">：</span>
                <span style="font-family:'宋体'">在您</span>
                <span style="font-family:'宋体'">使用视频面签服务期间，</span>
                <span style="font-family:'宋体'">我们</span>
                <span style="font-family:'宋体'">将</span>
                <span style="font-family:'宋体'">全程</span>
                <span style="font-family:'宋体'">开启您所使用的</span>
                <span style="font-family:'宋体'">终端</span>
                <span style="font-family:'宋体'">设备</span>
                <span style="font-family:'宋体'">（您</span>
                <span style="font-family:'宋体'">自己的设备或我们服务网点的设备</span>
                <span style="font-family:'宋体'">）</span>
                <span style="font-family:'宋体'">的</span>
                <span style="font-family:'宋体'">通话</span>
                <span style="font-family:'宋体'">功能和</span>
                <span style="font-family:'宋体'">摄像</span>
                <span style="font-family:'宋体'">功能，</span>
                <span style="font-family:'宋体'">并保存在此期间</span>
                <span style="font-family:'宋体'">记录的</span>
                <span style="font-family:'宋体'">录音</span>
                <span style="font-family:'宋体'">和录像</span>
                <span style="font-family:'宋体'">。</span>
            </p>
            <p style="margin-top:0px; margin-bottom:0px; text-indent:21px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                <span style="font-family:'宋体'; font-weight:bold; text-decoration:underline">您</span>
                <span style="font-family:'宋体'; font-weight:bold; text-decoration:underline">同意我们在收集上述信息</span>
                <span style="font-family:'宋体'; font-weight:bold; text-decoration:underline">后</span>
                <span style="font-family:'宋体'; font-weight:bold; text-decoration:underline">，</span>
                <span style="font-family:'宋体'; font-weight:bold; text-decoration:underline">通过相应的信息</span>
                <span style="font-family:'宋体'; font-weight:bold; text-decoration:underline">系统和算法进行内部数据分析，形成用户画像</span>
                <span style="font-family:'宋体'; font-weight:bold; text-decoration:underline">和</span>
                <span style="font-family:'宋体'; font-weight:bold; text-decoration:underline">信用评分，以确定您的授信额度，并向您推荐</span>
                <span style="font-family:'宋体'; font-weight:bold; text-decoration:underline">合适</span>
                <span style="font-family:'宋体'; font-weight:bold; text-decoration:underline">的贷款产品。</span>
            </p>
            <ol start="5" type="1" style="margin:0px; padding-left:0px">
                <li style="margin-left:34.91px; text-align:justify; widows:0; orphans:0; padding-left:4.09px; font-family:Tahoma; font-size:10.5px; font-weight:bold">
                    <span style="font-family:'宋体'">5.服务</span>
                    <span style="font-family:'宋体'">网点推荐</span>
                    <span style="font-family:'宋体'">和</span>
                    <span style="font-family:'宋体'">反欺诈</span>
                </li>
            </ol>
            <p style="margin-top:0px; margin-bottom:0px; text-indent:21px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                <span style="font-family:'宋体'">为了确认</span>
                <span style="font-family:'宋体'">您</span>
                <span style="font-family:'宋体'">是否</span>
                <span style="font-family:'宋体'">在我们的服务所准入</span>
                <span style="font-family:'宋体'">的区域</span>
                <span style="font-family:'宋体'">，</span>
                <span style="font-family:'宋体'">给您就近推荐</span>
                <span style="font-family:'宋体'">线下服务网点，</span>
                <span style="font-family:'宋体'">以及防范</span>
                <span style="font-family:'宋体'">欺诈风险，</span>
                <span style="font-family:'宋体'">您</span>
                <span style="font-family:'宋体'">同意我们收集您的</span>
                <span style="font-family:'宋体'; font-weight:bold">具体位置信息</span>
                <span style="font-family:'宋体'">，并</span>
                <span style="font-family:'宋体'">授权</span>
                <span style="font-family:'宋体'">开启</span>
                <span style="font-family:'宋体'">位置权限</span>
                <span style="font-family:'宋体'">。</span>
            </p>
            <p style="margin-top:0px; margin-bottom:0px; text-indent:21px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                <span style="font-family:'宋体'">为了满足特定放款机构的反欺诈要求，我们可能会收集您的</span>
                <span style="font-family:Tahoma">IP</span>
                <span style="font-family:'宋体'">、设备信息。</span>
            </p>
            <ol start="6" type="1" style="margin:0px; padding-left:0px">
                <li style="margin-left:34.91px; text-align:justify; widows:0; orphans:0; padding-left:4.09px; font-family:Tahoma; font-size:10.5px; font-weight:bold">
                    <span style="font-family:'宋体'">6.借款、担保及配套</span>
                    <span style="font-family:'宋体'">合同</span>
                    <span style="font-family:'宋体'">文本</span>
                    <span style="font-family:'宋体'">签署</span>
                </li>
            </ol>
            <p style="margin-top:0px; margin-bottom:0px; text-indent:21px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                <span style="font-family:'宋体'">为了完成贷款</span>
                <span style="font-family:'宋体'">、担保</span>
                <span style="font-family:'宋体'">及</span>
                <span style="font-family:'宋体'">配套合同</span>
                <span style="font-family:'宋体'">文本</span>
                <span style="font-family:'宋体'">的签订，</span>
                <span style="font-family:'宋体'">根据</span>
                <span style="font-family:'宋体'">不同</span>
                <span style="font-family:'宋体'">的</span>
                <span style="font-family:'宋体'">放款机构的要求，您需要进行</span>
                <span style="font-family:'宋体'">银行</span>
                <span style="font-family:'宋体'">账户开立、绑定、还款操作，</span>
                <span style="font-family:'宋体'">放款机构</span>
                <span style="font-family:'宋体'">和我们将收集您的</span>
                <span style="font-family:'宋体'; font-weight:bold">真实姓名、身份证信息、银行卡信息</span>
                <span style="font-family:'宋体'">（</span>
                <span style="font-family:'宋体'; font-weight:bold">持卡人姓名</span>
                <span style="font-family:'宋体'; font-weight:bold">、开户行、卡号、预留手机号、手机验证码</span>
                <span style="font-family:'宋体'; font-weight:bold">、</span>
                <span style="font-family:'宋体'; font-weight:bold">银行卡正反面影像</span>
                <span style="font-family:'宋体'">）</span>
                <span style="font-family:'宋体'">、</span>
                <span style="font-family:'宋体'; font-weight:bold">手机号码</span>
                <span style="font-family:'宋体'; font-weight:bold">、验证码</span>
                <span style="font-family:'宋体'; font-weight:bold">、电子邮箱</span>
                <span style="font-family:'宋体'; font-weight:bold">、电子签名</span>
                <span style="font-family:'宋体'">，</span>
                <span style="font-family:'宋体'">并对您的身份信息和银行账户信息进行验证。</span>
            </p>
            <ol start="7" type="1" style="margin:0px; padding-left:0px">
                <li style="margin-left:34.91px; text-align:justify; widows:0; orphans:0; padding-left:4.09px; font-family:Tahoma; font-size:10.5px; font-weight:bold">
                    <span style="font-family:'宋体'">7.贷后管理</span>
                </li>
            </ol>
            <p style="margin-top:0px; margin-bottom:0px; text-indent:21px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                <span style="font-family:'宋体'">为了为您</span>
                <span style="font-family:'宋体'">提供查账还款</span>
                <span style="font-family:'宋体'">服务、</span>
                <span style="font-family:'宋体'">查询</span>
                <span style="font-family:'宋体'">您</span>
                <span style="font-family:'宋体'">的借贷历史和</span>
                <span style="font-family:'宋体'">处理</span>
                <span style="font-family:'宋体'">纠纷，</span>
                <span style="font-family:'宋体'">我们和</span>
                <span style="font-family:'宋体'">我们合作的</span>
                <span style="font-family:'宋体'">放款机构</span>
                <span style="font-family:'宋体'">将收集您的</span>
                <span style="font-family:'宋体'; font-weight:bold">贷款</span>
                <span style="font-family:'宋体'; font-weight:bold">信息</span>
                <span style="font-family:'宋体'">，包括</span>
                <span style="font-family:'宋体'; font-weight:bold">评估</span>
                <span style="font-family:'宋体'; font-weight:bold">结果、</span>
                <span style="font-family:'宋体'; font-weight:bold">订单号</span>
                <span style="font-family:'宋体'; font-weight:bold">、</span>
                <span style="font-family:'宋体'; font-weight:bold">放款</span>
                <span style="font-family:'宋体'; font-weight:bold">机构、贷款金额、</span>
                <span style="font-family:'宋体'; font-weight:bold">贷款</span>
                <span style="font-family:'宋体'; font-weight:bold">利率</span>
                <span style="font-family:'宋体'; font-weight:bold">、</span>
                <span style="font-family:'宋体'; font-weight:bold">贷款期限、每月还款金额、剩余本金</span>
                <span style="font-family:'宋体'; font-weight:bold">、已还本息</span>
                <span style="font-family:'宋体'; font-weight:bold">、逾期天数、</span>
                <span style="font-family:'宋体'; font-weight:bold">逾期</span>
                <span style="font-family:'宋体'; font-weight:bold">金额</span>
                <span style="font-family:'宋体'; font-weight:bold">、</span>
                <span style="font-family:'宋体'; font-weight:bold">应还本金</span>
                <span style="font-family:'宋体'; font-weight:bold">、</span>
                <span style="font-family:'宋体'; font-weight:bold">应还利息、应还评审费、</span>
                <span style="font-family:'宋体'; font-weight:bold">应还</span>
                <span style="font-family:'宋体'; font-weight:bold">担保费、应还其他费用、已还评审费、已还担保费</span>
                <span style="font-family:'宋体'; font-weight:bold">和</span>
                <span style="font-family:'宋体'; font-weight:bold">已还其他费用</span>
                <span style="font-family:'宋体'">。</span>
            </p>
            <ol start="8" type="1" style="margin:0px; padding-left:0px">
                <li style="margin-left:34.91px; text-align:justify; widows:0; orphans:0; padding-left:4.09px; font-family:Tahoma; font-size:10.5px; font-weight:bold">
                    <span style="font-family:'宋体'">8.客户服务</span>
                    <span style="font-family:'宋体'">与投诉处理</span>
                </li>
            </ol>
            <p style="margin-top:0px; margin-bottom:0px; text-indent:21px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                <span style="font-family:'宋体'">为了</span>
                <span style="font-family:'宋体'">及时</span>
                <span style="font-family:'宋体'">为您</span>
                <span style="font-family:'宋体'">提供客户服务</span>
                <span style="font-family:'宋体'">和</span>
                <span style="font-family:'宋体'">响应您的疑问、</span>
                <span style="font-family:'宋体'">建议</span>
                <span style="font-family:'宋体'">、</span>
                <span style="font-family:'宋体'">意见</span>
                <span style="font-family:'宋体'">和投诉，</span>
                <span style="font-family:'宋体'">我们</span>
                <span style="font-family:'宋体'">的</span>
                <span style="font-family:'宋体'">工作</span>
                <span style="font-family:'宋体'">人员</span>
                <span style="font-family:'宋体'">可能</span>
                <span style="font-family:'宋体'">会收集您的</span>
                <span style="font-family:'宋体'; font-weight:bold">姓名</span>
                <span style="font-family:'宋体'; font-weight:bold">、身份证</span>
                <span style="font-family:'宋体'; font-weight:bold">号码</span>
                <span style="font-family:'宋体'; font-weight:bold">、</span>
                <span style="font-family:'宋体'; font-weight:bold">手机号码</span>
                <span style="font-family:'宋体'">，用以</span>
                <span style="font-family:'宋体'">核验</span>
                <span style="font-family:'宋体'">您的身份。</span>
                <span style="font-family:'宋体'">当您</span>
                <span style="font-family:'宋体'">需要我们提供与您交易</span>
                <span style="font-family:'宋体'">信息相关的客服和售后服务时，我们的客服人员会</span>
                <span style="font-family:'宋体'">查询</span>
                <span style="font-family:'宋体'">您的</span>
                <span style="font-family:'宋体'; font-weight:bold">贷款</span>
                <span style="font-family:'宋体'; font-weight:bold">信息</span>
                <span style="font-family:'宋体'">。</span>
                <span style="font-family:'宋体'">同时</span>
                <span style="font-family:'宋体'">，为了保证服务质量，我们可能会对</span>
                <span style="font-family:'宋体'">您</span>
                <span style="font-family:'宋体'">与我们的</span>
                <span style="font-family:'宋体'">客服</span>
                <span style="font-family:'宋体'">人员的通话进行录音</span>
                <span style="font-family:'宋体'">，</span>
                <span style="font-family:'宋体'">并对您</span>
                <span style="font-family:'宋体'">所提</span>
                <span style="font-family:'宋体'">的</span>
                <span style="font-family:'宋体'">要求</span>
                <span style="font-family:'宋体'">、</span>
                <span style="font-family:'宋体'">疑问</span>
                <span style="font-family:'宋体'">、</span>
                <span style="font-family:'宋体'">建议</span>
                <span style="font-family:'宋体'">、</span>
                <span style="font-family:'宋体'">意见和</span>
                <span style="font-family:'宋体'">投诉内容</span>
                <span style="font-family:'宋体'">进行</span>
                <span style="font-family:'宋体'">记录</span>
                <span style="font-family:'宋体'">。</span>
            </p>
            <p style="margin-top:0px; margin-bottom:0px; text-indent:21px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                <span style="font-family:Tahoma">&#xa0;</span>
            </p>
            <p style="margin-top:0px; margin-left:21px; margin-bottom:0px; text-indent:-21px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                <span style="font-family:'宋体'; font-weight:bold">三、</span>
                <span style="font:7px 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;</span>
                <span style="font-family:'宋体'; font-weight:bold">我们</span>
                <span style="font-family:'宋体'; font-weight:bold">如何收集</span>
                <span style="font-family:'宋体'; font-weight:bold">您</span>
                <span style="font-family:'宋体'; font-weight:bold">的</span>
                <span style="font-family:'宋体'; font-weight:bold">个人</span>
                <span style="font-family:'宋体'; font-weight:bold">信息</span>
            </p>
            <p style="margin-top:0px; margin-left:21px; margin-bottom:0px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                <span style="font-family:'宋体'">我们</span>
                <span style="font-family:'宋体'">会通过如下渠道</span>
                <span style="font-family:'宋体'">收集</span>
                <span style="font-family:'宋体'">您的个人信息</span>
                <span style="font-family:'宋体'">：</span>
            </p>
            <ol type="1" style="margin:0px; padding-left:0px">
                <li style="text-indent:21px; text-align:justify; widows:0; orphans:0; font-family:Calibri; font-size:10.5px; list-style-position:inside; -aw-list-padding-sml:8.03px">
                    <span style="font:7px 'Times New Roman'; -aw-list-padding-sml:8.03px">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;</span>
                    <span style="font-family:'宋体';">1.您</span>
                    <span style="font-family:'宋体';">直接提供的信息：</span>
                    <span style="font-family:'宋体'">我们</span>
                    <span style="font-family:'宋体'">可能会收集您</span>
                    <span style="font-family:'宋体'">在</span>
                    <span style="font-family:'宋体'">大数</span>
                    <span style="font-family:'宋体'">合作</span>
                    <span style="font-family:'宋体'">平台</span>
                    <span style="font-family:'宋体'">注册账号、</span>
                    <span style="font-family:'宋体'">申请或使用</span>
                    <span style="font-family:'宋体'">大数服务时</span>
                    <span style="font-family:'宋体'">填写</span>
                    <span style="font-family:'宋体'">，通过现场</span>
                    <span style="font-family:'宋体'">交谈、电话</span>
                    <span style="font-family:'宋体'">、</span>
                    <span style="font-family:'宋体'">视频或其他联系方式与我们联系</span>
                    <span style="font-family:'宋体'">时所提供</span>
                    <span style="font-family:'宋体'">的信息，以及您在使用我们服务过程中产生的与您的交易和活动有关的信息。</span>
                </li>
                <li style="text-indent:21px; text-align:justify; widows:0; orphans:0; font-family:Calibri; font-size:10.5px; list-style-position:inside; -aw-list-padding-sml:8.03px">
                    <span style="font:7px 'Times New Roman'; -aw-list-padding-sml:8.03px">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;</span>
                    <span style="font-family:'宋体'; font-weight:bold">2.我们</span>
                    <span style="font-family:'宋体'; font-weight:bold">主动收集的信息：</span>
                    <span style="font-family:'宋体'">在</span>
                    <span style="font-family:'宋体'">您使用大数</span>
                    <span style="font-family:'宋体'">合作</span>
                    <span style="font-family:'宋体'">平台过程中，我们会</span>
                    <span style="font-family:'宋体'">通过</span>
                    <span>COOKIES</span>
                    <span style="font-family:'宋体'">等</span>
                    <span style="font-family:'宋体'">自动收集工具收集您的设备</span>
                    <span style="font-family:'宋体'">信息</span>
                    <span style="font-family:'宋体'">以及与我们的服务相关的日志信息</span>
                    <span style="font-family:'宋体'">，</span>
                    <span style="font-family:'宋体'">并可能会通过搜索</span>
                    <span style="font-family:'宋体'">引擎等</span>
                    <span style="font-family:'宋体'">公开</span>
                    <span style="font-family:'宋体'">渠道</span>
                    <span style="font-family:'宋体'">对您提供的部分信息进行验证</span>
                    <span style="font-family:'宋体'">。</span>
                </li>
                <li style="text-indent:21px; text-align:justify; widows:0; orphans:0; font-family:Calibri; font-size:10.5px; font-weight:bold; list-style-position:inside; -aw-list-padding-sml:7.87px">
                    <span style="font:7px 'Times New Roman'; -aw-list-padding-sml:7.87px">&#xa0;&#xa0;&#xa0;&#xa0;</span>
                    <span style="font-family:'宋体'">3.我们</span>
                    <span style="font-family:'宋体'">会采用</span>
                    <span style="font-family:'宋体'">一些</span>
                    <span style="font-family:'宋体'">第三方</span>
                    <span style="font-family:'宋体'">接口</span>
                    <span style="font-family:'宋体'">或</span>
                    <span>SDK</span>
                    <span style="font-family:'宋体'">收集您的信息：</span>
                </li>
            </ol>
            <p style="margin-top:0px; margin-bottom:0px; text-indent:21px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                <span style="font-family:'宋体'">为了</span>
                <span style="font-family:'宋体'">实现特定</span>
                <span style="font-family:'宋体'">业务</span>
                <span style="font-family:'宋体'">功能，我们</span>
                <span style="font-family:'宋体'">会</span>
                <span style="font-family:'宋体'">使用</span>
                <span style="font-family:'宋体'">部分</span>
                <span style="font-family:'宋体'">第三方插件或</span>
                <span style="font-family:Calibri">SDK</span>
                <span style="font-family:'宋体'">等</span>
                <span style="font-family:'宋体'">工具</span>
                <span style="font-family:'宋体'">，并可能</span>
                <span style="font-family:'宋体'">与</span>
                <span style="font-family:'宋体'">该等</span>
                <span style="font-family:'宋体'">第三方共享实现特定功能所必须的信息，具体</span>
                <span style="font-family:'宋体'">情形</span>
                <span style="font-family:'宋体'">如下：</span>
            </p>
            <table cellspacing="0" cellpadding="0" style="border-collapse:collapse">
                <tr>
                    <td style="width:24.65px; border-style:solid; border-width:0.75px; padding-right:5.03px; padding-left:5.03px; vertical-align:middle">
                        <p style="margin-top:0px; margin-bottom:0px; text-align:center; widows:0; orphans:0; font-size:10.5px">
                            <span style="font-family:'宋体'; font-weight:bold">序号</span>
                        </p>
                    </td>
                    <td style="border-style:solid; border-width:0.75px; padding-right:5.03px; padding-left:5.03px; vertical-align:middle">
                        <p style="margin-top:0px; margin-bottom:0px; text-align:center; widows:0; orphans:0; font-size:10.5px">
                            <span style="font-family:'宋体'; font-weight:bold">第三方工具</span>
                            <span style="font-family:'宋体'; font-weight:bold">名称</span>
                        </p>
                    </td>
                    <td style=" border-style:solid; border-width:0.75px; padding-right:5.03px; padding-left:5.03px; vertical-align:middle">
                        <p style="margin-top:0px; margin-bottom:0px; text-align:center; widows:0; orphans:0; font-size:10.5px">
                            <span style="font-family:'宋体'; font-weight:bold">第三方</span>
                            <span style="font-family:'宋体'; font-weight:bold">主体名称</span>
                        </p>
                    </td>
                    <td style="border-style:solid; border-width:0.75px; padding-right:5.03px; padding-left:5.03px; vertical-align:middle">
                        <p style="margin-top:0px; margin-bottom:0px; text-align:center; widows:0; orphans:0; font-size:10.5px">
                            <span style="font-family:'宋体'; font-weight:bold">共享个人</span>
                            <span style="font-family:'宋体'; font-weight:bold">信息</span>
                            <span style="font-family:'宋体'; font-weight:bold">字段</span>
                        </p>
                    </td>
                    <td style="border-style:solid; border-width:0.75px; padding-right:5.03px; padding-left:5.03px; vertical-align:middle">
                        <p style="margin-top:0px; margin-bottom:0px; text-align:center; widows:0; orphans:0; font-size:10.5px">
                            <span style="font-family:'宋体'; font-weight:bold">功能</span>
                            <span style="font-family:'宋体'; font-weight:bold">和目的</span>
                        </p>
                    </td>
                </tr>
                <tr>
                    <td style="width:24.65px; border-style:solid; border-width:0.75px; padding-right:5.03px; padding-left:5.03px; vertical-align:middle">
                        <p style="margin-top:0px; margin-bottom:0px; text-align:center; widows:0; orphans:0; font-size:10.5px">
                            <span style="font-family:Calibri">1</span>
                        </p>
                    </td>
                    <td style="width:45.9px; border-style:solid; border-width:0.75px; padding-right:5.03px; padding-left:5.03px; vertical-align:middle">
                        <p style="margin-top:0px; margin-bottom:0px; text-align:center; widows:0; orphans:0; font-size:10.5px">
                            <span style="font-family:'宋体'">银联验证接口</span>
                        </p>
                    </td>
                    <td style="width:130.95px; border-style:solid; border-width:0.75px; padding-right:5.03px; padding-left:5.03px; vertical-align:middle">
                        <p style="margin-top:0px; margin-bottom:0px; text-align:center; widows:0; orphans:0; font-size:10.5px">
                            <span style="font-family:'宋体'">上海资信有限公司</span>
                        </p>
                    </td>
                    <td style="width:109.7px; border-style:solid; border-width:0.75px; padding-right:5.03px; padding-left:5.03px; vertical-align:middle">
                        <p style="margin-top:0px; margin-bottom:0px; text-align:center; widows:0; orphans:0; font-size:10.5px">
                            <span style="font-family:'宋体'">姓名、身份证号、手机号、银行卡号、密码</span>
                        </p>
                    </td>
                    <td style="width:60.1px; border-style:solid; border-width:0.75px; padding-right:5.03px; padding-left:5.03px; vertical-align:middle">
                        <p style="margin-top:0px; margin-bottom:0px; text-align:center; widows:0; orphans:0; font-size:10.5px">
                            <span style="font-family:'宋体'">征信授权</span>
                        </p>
                    </td>
                </tr>
                <tr>
                    <td style="width:24.65px; border-style:solid; border-width:0.75px; padding-right:5.03px; padding-left:5.03px; vertical-align:middle">
                        <p style="margin-top:0px; margin-bottom:0px; text-align:center; widows:0; orphans:0; font-size:10.5px">
                            <span style="font-family:Calibri">2</span>
                        </p>
                    </td>
                    <td style="width:45.9px; border-style:solid; border-width:0.75px; padding-right:5.03px; padding-left:5.03px; vertical-align:middle">
                        <p style="margin-top:0px; margin-bottom:0px; text-align:center; widows:0; orphans:0; font-size:10.5px">
                            <span style="font-family:Calibri">E</span>
                            <span style="font-family:'宋体'">签宝接口</span>
                        </p>
                    </td>
                    <td style="width:130.95px; border-style:solid; border-width:0.75px; padding-right:5.03px; padding-left:5.03px; vertical-align:middle">
                        <p style="margin-top:0px; margin-bottom:0px; text-align:center; widows:0; orphans:0; font-size:10.5px">
                            <span style="font-family:'宋体'">杭州天谷信息科技有限公司</span>
                        </p>
                    </td>
                    <td style="width:109.7px; border-style:solid; border-width:0.75px; padding-right:5.03px; padding-left:5.03px; vertical-align:middle">
                        <p style="margin-top:0px; margin-bottom:0px; text-align:center; widows:0; orphans:0; font-size:10.5px">
                            <span style="font-family:'宋体'">姓名、身份证号、手机号</span>
                        </p>
                    </td>
                    <td style="width:60.1px; border-style:solid; border-width:0.75px; padding-right:5.03px; padding-left:5.03px; vertical-align:middle">
                        <p style="margin-top:0px; margin-bottom:0px; text-align:center; widows:0; orphans:0; font-size:10.5px">
                            <span style="font-family:'宋体'">身份认证</span>
                        </p>
                    </td>
                </tr>
                <tr>
                    <td style="width:24.65px; border-style:solid; border-width:0.75px; padding-right:5.03px; padding-left:5.03px; vertical-align:middle">
                        <p style="margin-top:0px; margin-bottom:0px; text-align:center; widows:0; orphans:0; font-size:10.5px">
                            <span style="font-family:Calibri">3</span>
                        </p>
                    </td>
                    <td style="width:45.9px; border-style:solid; border-width:0.75px; padding-right:5.03px; padding-left:5.03px; vertical-align:middle">
                        <p style="margin-top:0px; margin-bottom:0px; text-align:center; widows:0; orphans:0; font-size:10.5px">
                            <span style="font-family:'宋体'">四要素验证接口</span>
                        </p>
                    </td>
                    <td style="width:130.95px; border-style:solid; border-width:0.75px; padding-right:5.03px; padding-left:5.03px; vertical-align:middle">
                        <p style="margin-top:0px; margin-bottom:0px; text-align:center; widows:0; orphans:0; font-size:10.5px">
                            <span style="font-family:'宋体'">网银在线（北京）科技有限公司</span>
                            <span style="font-family:'宋体'">、</span>
                            <span style="font-family:'宋体'">中金支付有限公司</span>
                            <span style="font-family:'宋体'">、</span>
                            <span style="font-family:'宋体'">通联支付网络服务股份有限公司</span>
                            <span style="font-family:'宋体'">、</span>
                            <span style="font-family:'宋体'">深圳时光数据科技有限公司</span>
                        </p>
                    </td>
                    <td style="width:109.7px; border-style:solid; border-width:0.75px; padding-right:5.03px; padding-left:5.03px; vertical-align:middle">
                        <p style="margin-top:0px; margin-bottom:0px; text-align:center; widows:0; orphans:0; font-size:10.5px">
                            <span style="font-family:'宋体'">姓名、身份证号、手机号、银行卡号</span>
                        </p>
                    </td>
                    <td style="width:60.1px; border-style:solid; border-width:0.75px; padding-right:5.03px; padding-left:5.03px; vertical-align:middle">
                        <p style="margin-top:0px; margin-bottom:0px; text-align:center; widows:0; orphans:0; font-size:10.5px">
                            <span style="font-family:'宋体'">银行卡</span>
                            <span style="font-family:'宋体'">绑定</span>
                        </p>
                    </td>
                </tr>
                <tr>
                    <td style="width:24.65px; border-style:solid; border-width:0.75px; padding-right:5.03px; padding-left:5.03px; vertical-align:middle">
                        <p style="margin-top:0px; margin-bottom:0px; text-align:center; widows:0; orphans:0; font-size:10.5px">
                            <span style="font-family:Calibri">4</span>
                        </p>
                    </td>
                    <td style="width:45.9px; border-style:solid; border-width:0.75px; padding-right:5.03px; padding-left:5.03px; vertical-align:middle">
                        <p style="margin-top:0px; margin-bottom:0px; text-align:center; widows:0; orphans:0; font-size:10.5px">
                            <span style="font-family:'宋体'">短信</span>
                            <span style="font-family:'宋体'">接口</span>
                        </p>
                    </td>
                    <td style="width:130.95px; border-style:solid; border-width:0.75px; padding-right:5.03px; padding-left:5.03px; vertical-align:middle">
                        <p style="margin-top:0px; margin-bottom:0px; text-align:center; widows:0; orphans:0; font-size:10.5px">
                            <span style="font-family:'宋体'">上海大汉三通通信股份有限公司</span>
                        </p>
                    </td>
                    <td style="width:109.7px; border-style:solid; border-width:0.75px; padding-right:5.03px; padding-left:5.03px; vertical-align:middle">
                        <p style="margin-top:0px; margin-bottom:0px; text-align:center; widows:0; orphans:0; font-size:10.5px">
                            <span style="font-family:'宋体'">姓名、手机号、银行卡号</span>
                        </p>
                    </td>
                    <td style="width:60.1px; border-style:solid; border-width:0.75px; padding-right:5.03px; padding-left:5.03px; vertical-align:middle">
                        <p style="margin-top:0px; margin-bottom:0px; text-align:center; widows:0; orphans:0; font-size:10.5px">
                            <span style="font-family:'宋体'">身份认证、信息提醒</span>
                        </p>
                    </td>
                </tr>
                <tr>
                    <td style="width:24.65px; border-style:solid; border-width:0.75px; padding-right:5.03px; padding-left:5.03px; vertical-align:middle">
                        <p style="margin-top:0px; margin-bottom:0px; text-align:center; widows:0; orphans:0; font-size:10.5px">
                            <span style="font-family:Calibri">5</span>
                        </p>
                    </td>
                    <td style="width:45.9px; border-style:solid; border-width:0.75px; padding-right:5.03px; padding-left:5.03px; vertical-align:middle">
                        <p style="margin-top:0px; margin-bottom:0px; text-align:center; widows:0; orphans:0; font-size:10.5px">
                            <span style="font-family:Calibri">OCR</span>
                            <span style="font-family:'宋体'">识别</span>
                            <span style="font-family:Calibri">SDK</span>
                        </p>
                    </td>
                    <td style="width:130.95px; border-style:solid; border-width:0.75px; padding-right:5.03px; padding-left:5.03px; vertical-align:middle">
                        <p style="margin-top:0px; margin-bottom:0px; text-align:center; widows:0; orphans:0; font-size:10.5px">
                            <span style="font-family:'宋体'">深圳市商汤科技有限公司</span>
                        </p>
                    </td>
                    <td style="width:109.7px; border-style:solid; border-width:0.75px; padding-right:5.03px; padding-left:5.03px; vertical-align:middle">
                        <p style="margin-top:0px; margin-bottom:0px; text-align:center; widows:0; orphans:0; font-size:10.5px">
                            <span style="font-family:'宋体'">姓名、身份证号、民族、户籍地址、户籍详细地址、发证机关、证件有效期</span>
                        </p>
                    </td>
                    <td style="width:60.1px; border-style:solid; border-width:0.75px; padding-right:5.03px; padding-left:5.03px; vertical-align:middle">
                        <p style="margin-top:0px; margin-bottom:0px; text-align:center; widows:0; orphans:0; font-size:10.5px">
                            <span style="font-family:'宋体'">风控审批</span>
                        </p>
                    </td>
                </tr>
                <tr>
                    <td style="width:24.65px; border-style:solid; border-width:0.75px; padding-right:5.03px; padding-left:5.03px; vertical-align:middle">
                        <p style="margin-top:0px; margin-bottom:0px; text-align:center; widows:0; orphans:0; font-size:10.5px">
                            <span style="font-family:Calibri">6</span>
                        </p>
                    </td>
                    <td style="width:45.9px; border-style:solid; border-width:0.75px; padding-right:5.03px; padding-left:5.03px; vertical-align:middle">
                        <p style="margin-top:0px; margin-bottom:0px; text-align:center; widows:0; orphans:0; font-size:10.5px">
                            <span style="font-family:'宋体'">人脸识别接口</span>
                        </p>
                    </td>
                    <td style="width:130.95px; border-style:solid; border-width:0.75px; padding-right:5.03px; padding-left:5.03px; vertical-align:middle">
                        <p style="margin-top:0px; margin-bottom:0px; text-align:center; widows:0; orphans:0; font-size:10.5px">
                            <span style="font-family:'宋体'">深圳市商汤科技有限公司</span>
                        </p>
                    </td>
                    <td style="width:109.7px; border-style:solid; border-width:0.75px; padding-right:5.03px; padding-left:5.03px; vertical-align:middle">
                        <p style="margin-top:0px; margin-bottom:0px; text-align:center; widows:0; orphans:0; font-size:10.5px">
                            <span style="font-family:'宋体'">人脸图片、视频</span>
                        </p>
                    </td>
                    <td style="width:60.1px; border-style:solid; border-width:0.75px; padding-right:5.03px; padding-left:5.03px; vertical-align:middle">
                        <p style="margin-top:0px; margin-bottom:0px; text-align:center; widows:0; orphans:0; font-size:10.5px">
                            <span style="font-family:'宋体'">身份认证</span>
                        </p>
                    </td>
                </tr>
            </table>
            <p style="margin-top:0px; margin-bottom:0px; text-indent:21px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                <span style="font-family:Calibri">&#xa0;</span>
            </p>
            <p style="margin-top:0px; margin-bottom:0px; text-indent:21px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                <span style="font-family:'宋体'">除此之外</span>
                <span style="font-family:'宋体'">，</span>
                <span style="font-family:'宋体'">我们</span>
                <span style="font-family:'宋体'">会使用</span>
                <span style="font-family:'宋体'">第三方</span>
                <span style="font-family:'宋体'">提供</span>
                <span style="font-family:'宋体'">的插件</span>
                <span style="font-family:'宋体'">或</span>
                <span style="font-family:Calibri; font-weight:bold;">SDK</span>
                <span style="font-family:'宋体'">满足</span>
                <span style="font-family:'宋体'">我们</span>
                <span style="font-family:'宋体'">的</span>
                <span style="font-family:'宋体'">部分业务功能，该类</span>
                <span style="font-family:'宋体'">插件</span>
                <span style="font-family:'宋体'">或</span>
                <span style="font-family:Calibri; font-weight:bold">SDK</span>
                <span style="font-family:'宋体'">仅</span>
                <span style="font-family:'宋体'">为我们的技术</span>
                <span style="font-family:'宋体'">服务</span>
                <span style="font-family:'宋体'">提供方，我们不会向其共享您的任何</span>
                <span style="font-family:'宋体'">个人</span>
                <span style="font-family:'宋体'">信息，具体情况如下：</span>
            </p>
            <table cellspacing="0" cellpadding="0" style="border-collapse:collapse">
                <tr>
                    <td style="width:31.5px; border-style:solid; border-width:0.75px; padding-right:5.03px; padding-left:5.03px; vertical-align:top">
                        <p style="margin-top:0px; margin-bottom:0px; text-align:center; widows:0; orphans:0; font-size:10.5px">
                            <span style="font-family:'宋体'; font-weight:bold">序号</span>
                        </p>
                    </td>
                    <td style="width:102.6px; border-style:solid; border-width:0.75px; padding-right:5.03px; padding-left:5.03px; vertical-align:top">
                        <p style="margin-top:0px; margin-bottom:0px; text-align:center; widows:0; orphans:0; font-size:10.5px">
                            <span style="font-family:'宋体'; font-weight:bold">第三方工具</span>
                            <span style="font-family:'宋体'; font-weight:bold">名称</span>
                        </p>
                    </td>
                    <td style="width:130.95px; border-style:solid; border-width:0.75px; padding-right:5.03px; padding-left:5.03px; vertical-align:top">
                        <p style="margin-top:0px; margin-bottom:0px; text-align:center; widows:0; orphans:0; font-size:10.5px">
                            <span style="font-family:'宋体'; font-weight:bold">第三方</span>
                            <span style="font-family:'宋体'; font-weight:bold">主体名称</span>
                        </p>
                    </td>
                    <td style="width:106.55px; border-style:solid; border-width:0.75px; padding-right:5.03px; padding-left:5.03px; vertical-align:top">
                        <p style="margin-top:0px; margin-bottom:0px; text-align:center; widows:0; orphans:0; font-size:10.5px">
                            <span style="font-family:'宋体'; font-weight:bold">实现</span>
                            <span style="font-family:'宋体'; font-weight:bold">的功能</span>
                        </p>
                    </td>
                </tr>
                <tr>
                    <td style="width:31.5px; border-style:solid; border-width:0.75px; padding-right:5.03px; padding-left:5.03px; vertical-align:top">
                        <p style="margin-top:0px; margin-bottom:0px; text-indent:10.5px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                            <span style="font-family:Calibri">1</span>
                        </p>
                    </td>
                    <td style="width:102.6px; border-style:solid; border-width:0.75px; padding-right:5.03px; padding-left:5.03px; vertical-align:middle">
                        <p style="margin-top:0px; margin-bottom:0px; text-align:center; widows:0; orphans:0; font-size:10.5px">
                            <span style="font-family:'宋体'">百度地图</span>
                            <span style="font-family:Calibri; font-weight:bold;">SDK</span>
                        </p>
                    </td>
                    <td style="width:130.95px; border-style:solid; border-width:0.75px; padding-right:5.03px; padding-left:5.03px; vertical-align:middle">
                        <p style="margin-top:0px; margin-bottom:0px; text-align:center; widows:0; orphans:0; font-size:10.5px">
                            <span style="font-family:'宋体'">北京</span>
                            <span style="font-family:'宋体'">百度网讯科技有限公司</span>
                        </p>
                    </td>
                    <td style="width:106.55px; border-style:solid; border-width:0.75px; padding-right:5.03px; padding-left:5.03px; vertical-align:top">
                        <p style="margin-top:0px; margin-bottom:0px; text-align:center; widows:0; orphans:0; font-size:10.5px">
                            <span style="font-family:'宋体'">位置定位</span>
                        </p>
                    </td>
                </tr>
            </table>
            <p style="margin-top:0px; margin-bottom:0px; text-indent:21px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                <span style="font-family:Calibri">&#xa0;</span>
            </p>
            <ol start="4" type="1" style="margin:0px; padding-left:0px">
                <li style="text-indent:21px; text-align:justify; widows:0; orphans:0; font-family:Calibri; font-size:10.5px; font-weight:bold; list-style-position:inside; -aw-list-padding-sml:7.87px">
                    <span style="font:7px 'Times New Roman'; -aw-list-padding-sml:7.87px">&#xa0;&#xa0;&#xa0;&#xa0;</span>
                    <span style="font-family:'宋体'">4.我们</span>
                    <span style="font-family:'宋体'">从</span>
                    <span style="font-family:'宋体'">第三方取得</span>
                    <span style="font-family:'宋体'">的信息：</span>
                    <span style="font-family:'宋体'; font-weight:normal">在</span>
                    <span style="font-family:'宋体'; font-weight:normal">取得您同意</span>
                    <span style="font-family:'宋体'; font-weight:normal">的</span>
                    <span style="font-family:'宋体'; font-weight:normal">前提下，我们可能</span>
                    <span style="font-family:'宋体'; font-weight:normal">从依法</span>
                    <span style="font-family:'宋体'; font-weight:normal">设立的征信机构</span>
                    <span style="font-family:'宋体'; font-weight:normal">和其他</span>
                    <span style="font-family:'宋体'; font-weight:normal">依法设立并</span>
                    <span style="font-family:'宋体'; font-weight:normal">合法</span>
                    <span style="font-family:'宋体'; font-weight:normal">留存您相关信息的第三方</span>
                    <span style="font-family:'宋体'; font-weight:normal">数据服务</span>
                    <span style="font-family:'宋体'; font-weight:normal">机构获取您的相关信息</span>
                    <span style="font-family:'宋体'; font-weight:normal">，</span>
                    <span style="font-family:'宋体'; font-weight:normal">主要包括</span>
                    <span style="font-family:'宋体'; font-weight:normal">您的</span>
                    <span style="font-family:'宋体'">信用报告</span>
                    <span style="font-family:'宋体'; font-weight:normal">、您</span>
                    <span style="font-family:'宋体'; font-weight:normal">所投资</span>
                    <span style="font-family:'宋体'; font-weight:normal">企业工商信息</span>
                    <span style="font-family:'宋体'; font-weight:normal">以及</span>
                    <span style="font-family:'宋体'; font-weight:normal">您的</span>
                    <span style="font-family:'宋体'; font-weight:normal">司法</span>
                    <span style="font-family:'宋体'; font-weight:normal">信息、行政处罚信息、</span>
                    <span style="font-family:'宋体'; font-weight:normal">航旅</span>
                    <span style="font-family:'宋体'; font-weight:normal">信息、</span>
                    <span style="font-family:'宋体'; font-weight:normal">设</span>
                    <span style="font-family:'宋体'; font-weight:normal">备</span>
                    <span style="font-family:'宋体'; font-weight:normal">信息、</span>
                    <span style="font-family:'宋体'; font-weight:normal">第三方</span>
                    <span style="font-family:'宋体'">借贷信息</span>
                    <span style="font-family:'宋体'; font-weight:normal">、</span>
                    <span style="font-family:'宋体'; font-weight:normal">第三方</span>
                    <span style="font-family:'宋体'; font-weight:normal">信用评分</span>
                    <span style="font-family:Tahoma; font-weight:normal">/</span>
                    <span style="font-family:'宋体'; font-weight:normal">标签信息，</span>
                    <span style="font-family:'宋体'; font-weight:normal">并可能从合作平台的运营方获取您所投资企业的</span>
                    <span style="font-family:'宋体'">纳税</span>
                    <span style="font-family:'宋体'">和发票信息</span>
                    <span style="font-family:'宋体'; font-weight:normal">。</span>
                </li>
                <li style="margin-left:34.13px; text-align:justify; widows:0; orphans:0; padding-left:4.87px; font-family:Calibri; font-size:10.5px; font-weight:bold">
                    <span style="font-family:'宋体'">5.设备权限</span>
                    <span style="font-family:'宋体'">调用</span>
                </li>
            </ol>
            <p style="margin-top:0px; margin-bottom:0px; text-indent:21px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                <span style="font-family:'宋体'">在</span>
                <span style="font-family:'宋体'">向您提供服务的过程中，为了实现特定的产品功能，我们会向您的设备系统申请调用以下设备</span>
                <span style="font-family:'宋体'">权限，</span>
                <span style="font-family:'宋体'">申请前我们会征询您的同意，您可以选择</span>
                <span style="font-family:Calibri">“</span>
                <span style="font-family:'宋体'">允许</span>
                <span style="font-family:Calibri">”</span>
                <span style="font-family:'宋体'">或者</span>
                <span style="font-family:Calibri">“</span>
                <span style="font-family:'宋体'">禁止</span>
                <span style="font-family:Calibri">”</span>
                <span style="font-family:'宋体'">权限</span>
                <span style="font-family:'宋体'">申请</span>
                <span style="font-family:'宋体'">。</span>
                <span style="font-family:'宋体'">申请成功后，您可以随时进入手机</span>
                <span style="font-family:Calibri">“</span>
                <span style="font-family:'宋体'">设置</span>
                <span style="font-family:Calibri">-</span>
                <span style="font-family:'宋体'">权限管理</span>
                <span style="font-family:Calibri">”</span>
                <span style="font-family:'宋体'">中</span>
                <span style="font-family:'宋体'">关闭相应权限，权限关闭</span>
                <span style="font-family:'宋体'">后</span>
                <span style="font-family:'宋体'">有关产品功能可能无法正常使用，请您理解：</span>
            </p>
            <table cellspacing="0" cellpadding="0" style="margin-left:21.05px; border-collapse:collapse">
                <tr>
                    <td style="width:71.85px; border-style:solid; border-width:0.75px; padding-right:5.03px; padding-left:5.03px; vertical-align:top">
                        <p style="margin-top:0px; margin-bottom:0px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                            <span style="font-family:'宋体'; font-weight:bold">权限名称</span>
                        </p>
                    </td>
                    <td style="width:62.45px; border-style:solid; border-width:0.75px; padding-right:5.03px; padding-left:5.03px; vertical-align:top">
                        <p style="margin-top:0px; margin-bottom:0px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                            <span style="font-family:'宋体'; font-weight:bold">设备</span>
                            <span style="font-family:'宋体'; font-weight:bold">类型</span>
                        </p>
                    </td>
                    <td style="width:152.2px; border-style:solid; border-width:0.75px; padding-right:5.03px; padding-left:5.03px; vertical-align:top">
                        <p style="margin-top:0px; margin-bottom:0px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                            <span style="font-family:'宋体'; font-weight:bold">业务</span>
                            <span style="font-family:'宋体'; font-weight:bold">功能</span>
                        </p>
                    </td>
                    <td style="width:64.05px; border-style:solid; border-width:0.75px; padding-right:5.03px; padding-left:5.03px; vertical-align:top">
                        <p style="margin-top:0px; margin-bottom:0px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                            <span style="font-family:'宋体'; font-weight:bold">是否可以关闭</span>
                        </p>
                    </td>
                </tr>
                <tr>
                    <td style="width:71.85px; border-style:solid; border-width:0.75px; padding-right:5.03px; padding-left:5.03px; vertical-align:top">
                        <p style="margin-top:0px; margin-bottom:0px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                            <span style="font-family:'宋体'">相机</span>
                            <span style="font-family:'宋体'">权限</span>
                        </p>
                    </td>
                    <td style="width:62.45px; border-style:solid; border-width:0.75px; padding-right:5.03px; padding-left:5.03px; vertical-align:top">
                        <p style="margin-top:0px; margin-bottom:0px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                            <span style="font-family:'宋体'">安卓</span>
                            <span style="font-family:'宋体'">、</span>
                            <span style="font-family:Calibri;font-weight:bold">IOS</span>
                        </p>
                    </td>
                    <td style="width:152.2px; border-style:solid; border-width:0.75px; padding-right:5.03px; padding-left:5.03px; vertical-align:top">
                        <p style="margin-top:0px; margin-bottom:0px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                            <span style="font-family:'宋体'">在身份证上传</span>
                            <span style="font-family:'宋体'">、人脸识别</span>
                            <span style="font-family:'宋体'">、</span>
                            <span style="font-family:'宋体'">视频面签</span>
                            <span style="font-family:'宋体'">、影像资料</span>
                            <span style="font-family:'宋体'">上传</span>
                            <span style="font-family:'宋体'">环节</span>
                            <span style="font-family:'宋体'">调用</span>
                        </p>
                    </td>
                    <td style="width:64.05px; border-style:solid; border-width:0.75px; padding-right:5.03px; padding-left:5.03px; vertical-align:top">
                        <p style="margin-top:0px; margin-bottom:0px; text-align:center; widows:0; orphans:0; font-size:10.5px">
                            <span style="font-family:'宋体'">是</span>
                        </p>
                    </td>
                </tr>
                <tr>
                    <td style="width:71.85px; border-style:solid; border-width:0.75px; padding-right:5.03px; padding-left:5.03px; vertical-align:top">
                        <p style="margin-top:0px; margin-bottom:0px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                            <span style="font-family:'宋体'">相册</span>
                            <span style="font-family:'宋体'">权限</span>
                        </p>
                    </td>
                    <td style="width:62.45px; border-style:solid; border-width:0.75px; padding-right:5.03px; padding-left:5.03px; vertical-align:top">
                        <p style="margin-top:0px; margin-bottom:0px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                            <span style="font-family:'宋体'">安卓</span>
                            <span style="font-family:'宋体'">、</span>
                            <span style="font-family:Calibri;font-weight:bold">IOS</span>
                        </p>
                    </td>
                    <td style="width:152.2px; border-style:solid; border-width:0.75px; padding-right:5.03px; padding-left:5.03px; vertical-align:top">
                        <p style="margin-top:0px; margin-bottom:0px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                            <span style="font-family:'宋体'">在身份证上传、影像资料上传环节</span>
                            <span style="font-family:'宋体'">调用</span>
                        </p>
                    </td>
                    <td style="width:64.05px; border-style:solid; border-width:0.75px; padding-right:5.03px; padding-left:5.03px; vertical-align:top">
                        <p style="margin-top:0px; margin-bottom:0px; text-align:center; widows:0; orphans:0; font-size:10.5px">
                            <span style="font-family:'宋体'">是</span>
                        </p>
                    </td>
                </tr>
                <tr>
                    <td style="width:71.85px; border-style:solid; border-width:0.75px; padding-right:5.03px; padding-left:5.03px; vertical-align:top">
                        <p style="margin-top:0px; margin-bottom:0px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                            <span style="font-family:'宋体'">定位</span>
                            <span style="font-family:'宋体'">权限</span>
                        </p>
                    </td>
                    <td style="width:62.45px; border-style:solid; border-width:0.75px; padding-right:5.03px; padding-left:5.03px; vertical-align:top">
                        <p style="margin-top:0px; margin-bottom:0px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                            <span style="font-family:'宋体'">安卓</span>
                            <span style="font-family:'宋体'">、</span>
                            <span style="font-family:Calibri;font-weight:bold">IOS</span>
                        </p>
                    </td>
                    <td style="width:152.2px; border-style:solid; border-width:0.75px; padding-right:5.03px; padding-left:5.03px; vertical-align:top">
                        <p style="margin-top:0px; margin-bottom:0px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                            <span style="font-family:'宋体'">业务</span>
                            <span style="font-family:'宋体'">风控、</span>
                            <span style="font-family:'宋体'">确定</span>
                            <span style="font-family:'宋体'">服务网点环节调用</span>
                        </p>
                    </td>
                    <td style="width:64.05px; border-style:solid; border-width:0.75px; padding-right:5.03px; padding-left:5.03px; vertical-align:top">
                        <p style="margin-top:0px; margin-bottom:0px; text-align:center; widows:0; orphans:0; font-size:10.5px">
                            <span style="font-family:'宋体'">是</span>
                        </p>
                    </td>
                </tr>
                <tr>
                    <td style="width:71.85px; border-style:solid; border-width:0.75px; padding-right:5.03px; padding-left:5.03px; vertical-align:top">
                        <p style="margin-top:0px; margin-bottom:0px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                            <span style="font-family:'宋体'">麦克风</span>
                            <span style="font-family:'宋体'">权限</span>
                        </p>
                    </td>
                    <td style="width:62.45px; border-style:solid; border-width:0.75px; padding-right:5.03px; padding-left:5.03px; vertical-align:top">
                        <p style="margin-top:0px; margin-bottom:0px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                            <span style="font-family:'宋体'">安卓</span>
                            <span style="font-family:'宋体'">、</span>
                            <span style="font-family:Calibri;font-weight:bold">IOS</span>
                        </p>
                    </td>
                    <td style="width:152.2px; border-style:solid; border-width:0.75px; padding-right:5.03px; padding-left:5.03px; vertical-align:top">
                        <p style="margin-top:0px; margin-bottom:0px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                            <span style="font-family:'宋体'">视频面签</span>
                            <span style="font-family:'宋体'">环节调用</span>
                        </p>
                    </td>
                    <td style="width:64.05px; border-style:solid; border-width:0.75px; padding-right:5.03px; padding-left:5.03px; vertical-align:top">
                        <p style="margin-top:0px; margin-bottom:0px; text-align:center; widows:0; orphans:0; font-size:10.5px">
                            <span style="font-family:'宋体'">是</span>
                        </p>
                    </td>
                </tr>
            </table>
            <p style="margin-top:0px; margin-bottom:0px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                <span style="font-family:Calibri">&#xa0;</span>
            </p>
            <ol start="6" type="1" style="margin:0px; padding-left:0px">
                <li style="text-indent:21px; text-align:justify; widows:0; orphans:0; font-family:Calibri; font-size:10.5px; font-weight:bold; list-style-position:inside; -aw-list-padding-sml:1.32px">
                    <span style="font:7px 'Times New Roman'; -aw-list-padding-sml:1.32px"></span>
                    <span style="font-family:'宋体'">6.在</span>
                    <span style="font-family:'宋体'">法律法规允许的情况下，我们</span>
                    <span style="font-family:'宋体'">可能</span>
                    <span style="font-family:'宋体'">会</span>
                    <span style="font-family:'宋体'">在以下情形</span>
                    <span style="font-family:'宋体'">中收集并使用您的</span>
                    <span style="font-family:'宋体'">个人</span>
                    <span style="font-family:'宋体'">信息</span>
                    <span style="font-family:'宋体'">而无需征得</span>
                    <span style="font-family:'宋体'">您的授权</span>
                    <span style="font-family:'宋体'">或</span>
                    <span style="font-family:'宋体'">同意：</span>
                </li>
            </ol>
            <p style="margin-top:0px; margin-left:49.65px; margin-bottom:0px; text-indent:-28.65px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                <span style="font-family:'宋体'">（</span>
                <span style="font-family:Calibri">1</span>
                <span style="font-family:'宋体'">）</span>
                <span style="font:7px 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;</span>
                <span style="font-family:'宋体'">与</span>
                <span style="font-family:'宋体'">我们</span>
                <span style="font-family:'宋体'">履行</span>
                <span style="font-family:'宋体'">法律</span>
                <span style="font-family:'宋体'">法规</span>
                <span style="font-family:'宋体'">规定的义务相关的；</span>
            </p>
            <p style="margin-top:0px; margin-left:49.65px; margin-bottom:0px; text-indent:-28.65px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                <span style="font-family:'宋体'">（</span>
                <span style="font-family:Calibri">2</span>
                <span style="font-family:'宋体'">）</span>
                <span style="font:7px 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;</span>
                <span style="font-family:'宋体'">与</span>
                <span style="font-family:'宋体'">国家安全、国防安全</span>
                <span style="font-family:'宋体'">直接</span>
                <span style="font-family:'宋体'">相关的；</span>
            </p>
            <p style="margin-top:0px; margin-left:49.65px; margin-bottom:0px; text-indent:-28.65px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                <span style="font-family:'宋体'">（</span>
                <span style="font-family:Calibri">3</span>
                <span style="font-family:'宋体'">）</span>
                <span style="font:7px 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;</span>
                <span style="font-family:'宋体'">与</span>
                <span style="font-family:'宋体'">公共安全、</span>
                <span style="font-family:'宋体'">公共</span>
                <span style="font-family:'宋体'">卫生、重大公共利益</span>
                <span style="font-family:'宋体'">直接</span>
                <span style="font-family:'宋体'">相关的；</span>
            </p>
            <p style="margin-top:0px; margin-left:49.65px; margin-bottom:0px; text-indent:-28.65px; widows:0; orphans:0; font-size:10.5px">
                <span style="font-family:'宋体'">（</span>
                <span style="font-family:Calibri">4</span>
                <span style="font-family:'宋体'">）</span>
                <span style="font:7px 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;</span>
                <span style="font-family:'宋体'">为订立或者履行个人作为一方当事人的合同所必需</span>
                <span style="font-family:'宋体'">；</span>
            </p>
            <p style="margin-top:0px; margin-left:49.65px; margin-bottom:0px; text-indent:-28.65px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                <span style="font-family:'宋体'">（</span>
                <span style="font-family:Calibri">5</span>
                <span style="font-family:'宋体'">）</span>
                <span style="font:7px 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;</span>
                <span style="font-family:'宋体'">与</span>
                <span style="font-family:'宋体'">刑事侦查、起诉、审判和判决执行等直接相关的</span>
                <span style="font-family:'宋体'">；</span>
            </p>
            <p style="margin-top:0px; margin-bottom:0px; text-indent:21px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                <span style="font-family:'宋体'">（</span>
                <span style="font-family:Calibri">6</span>
                <span style="font-family:'宋体'">）</span>
                <span style="font:7px 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;</span>
                <span style="font-family:'宋体'">出于</span>
                <span style="font-family:'宋体'">维护</span>
                <span style="font-family:'宋体'">您</span>
                <span style="font-family:'宋体'">和其他个人的</span>
                <span style="font-family:'宋体'">生命</span>
                <span style="font-family:'宋体'">、财产等重大合法权益但又很难得到您本人授权同意的；</span>
            </p>
            <p style="margin-top:0px; margin-bottom:0px; text-indent:21px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                <span style="font-family:'宋体'">（</span>
                <span style="font-family:Calibri">7</span>
                <span style="font-family:'宋体'">）</span>
                <span style="font:7px 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;</span>
                <span style="font-family:'宋体'">从合法</span>
                <span style="font-family:'宋体'">公开披露的</span>
                <span style="font-family:'宋体'">信息</span>
                <span style="font-family:'宋体'">中收集</span>
                <span style="font-family:'宋体'">您</span>
                <span style="font-family:'宋体'">的个人信息的；</span>
            </p>
            <p style="margin-top:0px; margin-bottom:0px; text-indent:21px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                <span style="font-family:'宋体'">（</span>
                <span style="font-family:Calibri">8</span>
                <span style="font-family:'宋体'">）</span>
                <span style="font:7px 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;</span>
                <span style="font-family:'宋体'">用于</span>
                <span style="font-family:'宋体'">维护所提供的</span>
                <span style="font-family:'宋体'">产品</span>
                <span style="font-family:'宋体'">或服务的安全稳定运行</span>
                <span style="font-family:'宋体'">所必需</span>
                <span style="font-family:'宋体'">的，如发现、处置产品或服务的故障；</span>
            </p>
            <p style="margin-top:0px; margin-bottom:0px; text-indent:21px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                <span style="font-family:'宋体'">（</span>
                <span style="font-family:Calibri">9</span>
                <span style="font-family:'宋体'">）</span>
                <span style="font:7px 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;</span>
                <span style="font-family:'宋体'">法律</span>
                <span style="font-family:'宋体'">法规</span>
                <span style="font-family:'宋体'">或</span>
                <span style="font-family:'宋体'">国家标准</span>
                <span style="font-family:'宋体'">规定</span>
                <span style="font-family:'宋体'">的其他情形。</span>
            </p>
            <p style="margin-top:0px; margin-left:21px; margin-bottom:0px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                <span style="font-family:Calibri">&#xa0;</span>
            </p>
            <div style="margin-right:9.75px; background-color:#ffffff">
                <p style="margin-top:0px; margin-left:21px; margin-bottom:0px; text-indent:-21px; font-size:10.5px">
                    <span style="font-family:'宋体'; font-weight:bold">四、</span>
                    <span style="font-family:'宋体'; font-weight:bold">我们</span>
                    <span style="font-family:'宋体'; font-weight:bold">如何</span>
                    <span style="font-family:'宋体'; font-weight:bold">使</span>
                    <span style="font-family:'宋体'; font-weight:bold">用</span>
                    <span style="font-family:Tahoma; font-weight:bold">COOKIES</span>
                    <span style="font-family:'宋体'; font-weight:bold">和</span>
                    <span style="font-family:'宋体'; font-weight:bold">同类技术</span>
                </p>
            </div>
            <ol type="1" style="margin:0px; padding-left:0px">
                <li style="text-indent:21px; text-align:justify; font-family:Calibri; font-size:10.5px; background-color:#ffffff; list-style-position:inside; -aw-list-padding-sml:8.03px">
                    <span style="font:7px 'Times New Roman'; -aw-list-padding-sml:8.03px">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;</span>
                    <span style="font-family:'宋体'">1.当您使用大数</span>
                    <span style="font-family:'宋体'">合作</span>
                    <span style="font-family:'宋体'">平台时，我们使用</span>
                    <span style="font-family:Tahoma; font-weight:bold">COOKIES</span>
                    <span style="font-family:'宋体'">和其他类似技术来记录您的设备信息及与我们的服务相关的日志信息。</span>
                </li>
                <li style="text-indent:21px; text-align:justify; font-family:Calibri; font-size:10.5px; background-color:#ffffff; list-style-position:inside; -aw-list-padding-sml:8.03px">
                    <span style="font:7px 'Times New Roman'; -aw-list-padding-sml:8.03px">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;</span>
                    <span style="font-family:'宋体'">2.请您理解，我们</span>
                    <span style="font-family:'宋体'">合作</span>
                    <span style="font-family:'宋体'">平台中的许多</span>
                    <span style="font-family:Tahoma; font-weight:bold">COOKIES</span>
                    <span style="font-family:'宋体'">起着至关重要的作用：例如，当您登录我们账号时，</span>
                    <span style="font-family:Tahoma; font-weight:bold">COOKIES</span>
                    <span style="font-family:'宋体'">记录着您的账号信息，使您省去重复输入注册信息等步骤，或帮助您判断您的账户安全。其它的</span>
                    <span style="font-family:Tahoma; font-weight:bold">COOKIES</span>
                    <span style="font-family:'宋体'">帮助我们了解您使用我们</span>
                    <span style="font-family:'宋体'">合作</span>
                    <span style="font-family:'宋体'">平台的方式，从而使我们改进线上工作。对此我们使用相关的分析工具分析我们</span>
                    <span style="font-family:'宋体'">合作</span>
                    <span style="font-family:'宋体'">平台的加载时间、访客使用的方式，以及我们</span>
                    <span style="font-family:'宋体'">合作</span>
                    <span style="font-family:'宋体'">平台的访客查看最多的信息。它们还帮助我们发现我们</span>
                    <span style="font-family:'宋体'">合作</span>
                    <span style="font-family:'宋体'">平台中没有达到预期效果的部分，促使我们采取修复措施，为您打造更好用的平台。</span>
                </li>
                <li style="text-indent:21px; text-align:justify; font-family:Calibri; font-size:10.5px; background-color:#ffffff; list-style-position:inside; -aw-list-padding-sml:8.03px">
                    <span style="font:7px 'Times New Roman'; -aw-list-padding-sml:8.03px">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;</span>
                    <span style="font-family:'宋体'">3.大部分</span>
                    <span style="font-family:'宋体'">受欢迎的网络浏览器都允许您管理</span>
                    <span style="font-family:Tahoma; font-weight:bold">COOKIES</span>
                    <span style="font-family:'宋体'">。您可以选择接受或拒绝所有</span>
                    <span style="font-family:Tahoma; font-weight:bold">COOKIES</span>
                    <span style="font-family:'宋体'">，或拒绝具体类别的</span>
                    <span style="font-family:Tahoma; font-weight:bold">COOKIES</span>
                    <span style="font-family:'宋体'">。如果您关闭</span>
                    <span style="font-family:Tahoma; font-weight:bold">COOKIES</span>
                    <span style="font-family:'宋体'">后，您仍可以使用我们</span>
                    <span style="font-family:'宋体'">合作</span>
                    <span style="font-family:'宋体'">平台的部分内容，但有些有用部分将不能使用，并且，将可能导致我们无法全部或部分提供产品或服务，或影响您获取产品或服务的等级、数量和类型</span>
                    <span style="font-family:'宋体'">。</span>
                </li>
            </ol>
            <p style="margin-top:0px; margin-left:21px; margin-bottom:0px; text-align:justify; font-size:10.5px; background-color:#ffffff">
                <span style="font-family:Calibri">&#xa0;</span>
            </p>
            <p style="margin-top:0px; margin-left:21px; margin-bottom:0px; text-indent:-21px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                <span style="font-family:'宋体'; font-weight:bold">五、</span>
                <span style="font:7px 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;</span>
                <span style="font-family:'宋体'; font-weight:bold">我们</span>
                <span style="font-family:'宋体'; font-weight:bold">如何</span>
                <span style="font-family:'宋体'; font-weight:bold">委托</span>
                <span style="font-family:'宋体'; font-weight:bold">处理</span>
                <span style="font-family:'宋体'; font-weight:bold">、</span>
                <span style="font-family:'宋体'; font-weight:bold">共享、转让、公开</span>
                <span style="font-family:'宋体'; font-weight:bold">披露个人</span>
                <span style="font-family:'宋体'; font-weight:bold">信息</span>
            </p>
            <ol type="1" style="margin:0px; padding-left:0px">
                <li style="margin-left:34.91px; text-align:justify; widows:0; orphans:0; padding-left:4.09px; font-family:Tahoma; font-size:10.5px; font-weight:bold">
                    <span style="font-family:'宋体'">1.委托处理</span>
                </li>
            </ol>
            <p style="margin-top:0px; margin-bottom:0px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                <span style="font-family:'宋体'"></span>
                <span style="font-family:'宋体'">大数服务</span>
                <span style="font-family:'宋体'">中的</span>
                <span style="font-family:'宋体'">具体功能</span>
                <span style="font-family:'宋体'">可能</span>
                <span style="font-family:'宋体'">由</span>
                <span style="font-family:'宋体'">大数</span>
                <span style="font-family:'宋体'">体系</span>
                <span style="font-family:'宋体'">内的不同</span>
                <span style="font-family:'宋体'">实体</span>
                <span style="font-family:'宋体'">负责，</span>
                <span style="font-family:'宋体'">除此之外</span>
                <span style="font-family:'宋体'">，</span>
                <span style="font-family:'宋体'">我们未</span>
                <span style="font-family:'宋体'">委托第三方公司、组织</span>
                <span style="font-family:'宋体'">或</span>
                <span style="font-family:'宋体'">个人处理您的个人信息。</span>
            </p>
            <ol start="2" type="1" style="margin:0px; padding-left:0px">
                <li style="margin-left:34.91px; text-align:justify; widows:0; orphans:0; padding-left:4.09px; font-family:Tahoma; font-size:10.5px; font-weight:bold">
                    <span style="font-family:'宋体'">2.共享</span>
                </li>
            </ol>
            <p style="margin-top:0px; margin-bottom:0px; text-indent:21px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                <span style="font-family:'宋体'">我们不会与任何公司、组织或个人分享您的个人信息</span>
                <span style="font-family:'宋体'">，</span>
                <span style="font-family:'宋体'">但</span>
                <span style="font-family:'宋体'">以下情况</span>
                <span style="font-family:'宋体'">除外：</span>
            </p>
            <p style="margin-top:0px; margin-left:57px; margin-bottom:0px; text-indent:-36px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                <span style="font-family:'宋体'">（</span>
                <span style="font-family:Tahoma">1</span>
                <span style="font-family:'宋体'">）</span>
                <span style="font:7px 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;</span>
                <span style="font-family:'宋体'">事先</span>
                <span style="font-family:'宋体'">获得您的明确同意的；</span>
            </p>
            <p style="margin-top:0px; margin-left:57px; margin-bottom:0px; text-indent:-36px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                <span style="font-family:'宋体'">（</span>
                <span style="font-family:Tahoma">2</span>
                <span style="font-family:'宋体'">）</span>
                <span style="font:7px 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;</span>
                <span style="font-family:'宋体'">根据法律</span>
                <span style="font-family:'宋体'">法规规定，</span>
                <span style="font-family:'宋体'">或者</span>
                <span style="font-family:'宋体'">政府主管部门</span>
                <span style="font-family:'宋体'">、</span>
                <span style="font-family:'宋体'">司法机关的强制</span>
                <span style="font-family:'宋体'">要求必须对外</span>
                <span style="font-family:'宋体'">共享的；</span>
            </p>
            <p style="margin-top:0px; margin-bottom:0px; text-indent:21px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                <span style="font-family:'宋体'; font-weight:bold">（</span>
                <span style="font-family:Tahoma; font-weight:bold">3</span>
                <span style="font-family:'宋体'; font-weight:bold">）</span>
                <span style="font:7px 'Times New Roman'"></span>
                <span style="font-family:'宋体'; font-weight:bold; text-decoration:underline">为了</span>
                <span style="font-family:'宋体'; font-weight:bold; text-decoration:underline">实现</span>
                <span style="font-family:'宋体'; font-weight:bold; text-decoration:underline">本政策所述</span>
                <span style="font-family:'宋体'; font-weight:bold; text-decoration:underline">的某些业务功能和目的，我们</span>
                <span style="font-family:'宋体'; font-weight:bold; text-decoration:underline">可能</span>
                <span style="font-family:'宋体'; font-weight:bold; text-decoration:underline">会与特定的合作伙伴共享您的</span>
                <span style="font-family:'宋体'; font-weight:bold; text-decoration:underline">一些</span>
                <span style="font-family:'宋体'; font-weight:bold; text-decoration:underline">个人信息，具体</span>
                <span style="font-family:'宋体'; font-weight:bold; text-decoration:underline">如下</span>
                <span style="font-family:'宋体'; font-weight:bold; text-decoration:underline">：</span>
            </p>
            <p style="margin-top:0px; margin-bottom:0px; text-indent:21px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                <span style="font-family:Tahoma">①</span>
                <span style="font:7px 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;</span>
                <span style="font-family:'宋体'; font-weight:bold; text-decoration:underline">放款机构</span>
                <span style="font-family:'宋体'; font-weight:bold">：</span>
                <span style="font-family:'宋体'">为</span>
                <span style="font-family:'宋体'">方便放款机构</span>
                <span style="font-family:'宋体'">对您</span>
                <span style="font-family:'宋体'">进行授信</span>
                <span style="font-family:'宋体'">评估</span>
                <span style="font-family:'宋体'">、确定</span>
                <span style="font-family:'宋体'">放款额度</span>
                <span style="font-family:'宋体'">及履行有关监管要求，我们</span>
                <span style="font-family:'宋体'">会根据放款机构</span>
                <span style="font-family:'宋体'">的</span>
                <span style="font-family:'宋体'">要求</span>
                <span style="font-family:'宋体'">，</span>
                <span style="font-family:'宋体'">与其</span>
                <span style="font-family:'宋体'">共享</span>
                <span style="font-family:'宋体'">根据</span>
                <span style="font-family:'宋体'">本政策向我们提供的</span>
                <span style="font-family:'宋体'">部分</span>
                <span style="font-family:'宋体'">个人信息</span>
                <span style="font-family:'宋体'">（</span>
                <span style="font-family:'宋体'; font-weight:bold">具体</span>
                <span style="font-family:'宋体'; font-weight:bold">以您所选择</span>
                <span style="font-family:'宋体'; font-weight:bold">的</span>
                <span style="font-family:'宋体'; font-weight:bold">产品对应的放款机构的具体要求为准</span>
                <span style="font-family:'宋体'">）</span>
                <span style="font-family:'宋体'">及我们</span>
                <span style="font-family:'宋体'">对您</span>
                <span style="font-family:'宋体'">的个人信用评分信息</span>
                <span style="font-family:'宋体'">；</span>
            </p>
            <p style="margin-top:0px; margin-bottom:0px; text-indent:21px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                <span style="font-family:Tahoma">②</span>
                <span style="font:7px 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;</span>
                <span style="font-family:'宋体'; font-weight:bold; text-decoration:underline">征信机构</span>
                <span style="font-family:'宋体'; font-weight:bold; text-decoration:underline">和</span>
                <span style="font-family:'宋体'; font-weight:bold; text-decoration:underline">第三方</span>
                <span style="font-family:'宋体'; font-weight:bold; text-decoration:underline">数据服务</span>
                <span style="font-family:'宋体'; font-weight:bold; text-decoration:underline">机构</span>
                <span style="font-family:'宋体'; font-weight:bold">：</span>
                <span style="font-family:'宋体'">为了对您所</span>
                <span style="font-family:'宋体'">提供的各类信息进行验证</span>
                <span style="font-family:'宋体'">，</span>
                <span style="font-family:'宋体'">获取</span>
                <span style="font-family:'宋体'">您</span>
                <span style="font-family:'宋体'">的</span>
                <span style="font-family:'宋体'; font-weight:bold">信用</span>
                <span style="font-family:'宋体'; font-weight:bold">报告</span>
                <span style="font-family:'宋体'">及其他第三方信用评分</span>
                <span style="font-family:Tahoma">/</span>
                <span style="font-family:'宋体'">标签</span>
                <span style="font-family:'宋体'">，</span>
                <span style="font-family:'宋体'">我们可能</span>
                <span style="font-family:'宋体'">在</span>
                <span style="font-family:'宋体'">取得</span>
                <span style="font-family:'宋体'">您的</span>
                <span style="font-family:'宋体'">同意</span>
                <span style="font-family:'宋体'">的前提下，</span>
                <span style="font-family:'宋体'">将您</span>
                <span style="font-family:'宋体'">的</span>
                <span style="font-family:'宋体'; font-weight:bold">真实姓名、身份证号</span>
                <span style="font-family:'宋体'; font-weight:bold">、</span>
                <span style="font-family:'宋体'; font-weight:bold">电话号码</span>
                <span style="font-family:'宋体'; font-weight:bold">及</span>
                <span style="font-family:'宋体'; font-weight:bold">贷款逾期信息</span>
                <span style="font-family:'宋体'">提供</span>
                <span style="font-family:'宋体'">给征信机构及第三方数据服务</span>
                <span style="font-family:'宋体'">机构（涉及</span>
                <span style="font-family:'宋体'">的具体</span>
                <span style="font-family:'宋体'">机构</span>
                <span style="font-family:'宋体'">名称</span>
                <span style="font-family:'宋体'">和</span>
                <span style="font-family:'宋体'">信息类型将在</span>
                <span style="font-family:'宋体'">单独</span>
                <span style="font-family:'宋体'">向您</span>
                <span style="font-family:'宋体'">征求</span>
                <span style="font-family:'宋体'">同意时</span>
                <span style="font-family:'宋体'">逐一</span>
                <span style="font-family:'宋体'">列出</span>
                <span style="font-family:'宋体'">）；</span>
            </p>
            <p style="margin-top:0px; margin-bottom:0px; text-indent:21px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                <span style="font-family:Tahoma">③</span>
                <span style="font:7px 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;</span>
                <span style="font-family:'宋体'; font-weight:bold; text-decoration:underline">身份</span>
                <span style="font-family:'宋体'; font-weight:bold; text-decoration:underline">验证机构：</span>
                <span style="font-family:'宋体'">为了</span>
                <span style="font-family:'宋体'">对您的身份进行识别和认证，我们</span>
                <span style="font-family:'宋体'">可能</span>
                <span style="font-family:'宋体'">会</span>
                <span style="font-family:'宋体'">向具有相应</span>
                <span style="font-family:'宋体'">资质和能力的</span>
                <span style="font-family:'宋体'">第三方身份验证机构提供</span>
                <span style="font-family:'宋体'">您的</span>
                <span style="font-family:'宋体'; font-weight:bold">身份</span>
                <span style="font-family:'宋体'; font-weight:bold">信息</span>
                <span style="font-family:'宋体'; font-weight:bold">、</span>
                <span style="font-family:'宋体'; font-weight:bold">人脸照片</span>
                <span style="font-family:Tahoma; font-weight:bold">/</span>
                <span style="font-family:'宋体'; font-weight:bold">视频或银行卡</span>
                <span style="font-family:'宋体'; font-weight:bold">信息</span>
                <span style="font-family:'宋体'">；</span>
            </p>
            <p style="margin-top:0px; margin-bottom:0px; text-indent:21px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                <span style="font-family:Tahoma">④</span>
                <span style="font:7px 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;</span>
                <span style="font-family:'宋体'; font-weight:bold; text-decoration:underline">第三方推介</span>
                <span style="font-family:'宋体'; font-weight:bold; text-decoration:underline">服务机构：</span>
                <span style="font-family:'宋体'">为了履行我们与第三方</span>
                <span style="font-family:'宋体'">推介</span>
                <span style="font-family:'宋体'">服务机构的协议</span>
                <span style="font-family:'宋体'">（主要</span>
                <span style="font-family:'宋体'">是服务费用的结算</span>
                <span style="font-family:'宋体'">）</span>
                <span style="font-family:'宋体'">，</span>
                <span style="font-family:'宋体'">我们将</span>
                <span style="font-family:'宋体'">向</span>
                <span style="font-family:'宋体'">向您</span>
                <span style="font-family:'宋体'">推荐</span>
                <span style="font-family:'宋体'">使用大数服务</span>
                <span style="font-family:'宋体'">的第三方推介服务机构共享您的</span>
                <span style="font-family:'宋体'; font-weight:bold">贷款</span>
                <span style="font-family:'宋体'; font-weight:bold">信息</span>
                <span style="font-family:'宋体'">；</span>
            </p>
            <p style="margin-top:0px; margin-bottom:0px; text-indent:21px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                <span style="font-family:Tahoma; font-weight:bold">⑤</span>
                <span style="font:7px 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;</span>
                <span style="font-family:'宋体'; font-weight:bold; text-decoration:underline">不良资产处置</span>
                <span style="font-family:'宋体'; font-weight:bold; text-decoration:underline">机构</span>
                <span style="font-family:'宋体'; font-weight:bold">：</span>
                <span style="font-family:'宋体'">当您违反与我们的约定或您的</span>
                <span style="font-family:'宋体'">债务</span>
                <span style="font-family:'宋体'">发生逾期时</span>
                <span style="font-family:'宋体'">，</span>
                <span style="font-family:'宋体'">我们可能将我们对您享有的特定债权转让给</span>
                <span style="font-family:'宋体'">我们</span>
                <span style="font-family:'宋体'">合作的不良资产处置机构，</span>
                <span style="font-family:'宋体'">为</span>
                <span style="font-family:'宋体'">履行债权转让义务，我们</span>
                <span style="font-family:'宋体'">可能</span>
                <span style="font-family:'宋体'">向该等机构</span>
                <span style="font-family:'宋体'">披露</span>
                <span style="font-family:'宋体'">您</span>
                <span style="font-family:'宋体'">的</span>
                <span style="font-family:'宋体'; font-weight:bold">真实姓名</span>
                <span style="font-family:'宋体'">、</span>
                <span style="font-family:'宋体'; font-weight:bold">身份证</span>
                <span style="font-family:'宋体'; font-weight:bold">信息</span>
                <span style="font-family:'宋体'">、</span>
                <span style="font-family:'宋体'; font-weight:bold">电话号码</span>
                <span style="font-family:'宋体'">、</span>
                <span style="font-family:'宋体'; font-weight:bold">居住地址</span>
                <span style="font-family:'宋体'; font-weight:bold">、</span>
                <span style="font-family:'宋体'; font-weight:bold">紧急联系人信息</span>
                <span style="font-family:'宋体'">以及</span>
                <span style="font-family:'宋体'; font-weight:bold">贷款</span>
                <span style="font-family:'宋体'; font-weight:bold">信息</span>
                <span style="font-family:'宋体'; font-weight:bold">、房</span>
                <span style="font-family:'宋体'; font-weight:bold">产信息</span>
                <span style="font-family:'宋体'">；</span>
            </p>
            <p style="margin-top:0px; margin-bottom:0px; text-indent:21px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                <span style="font-family:Tahoma">⑥</span>
                <span style="font:7px 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;</span>
                <span style="font-family:'宋体'; font-weight:bold; text-decoration:underline">债务催收机构</span>
                <span style="font-family:'宋体'; font-weight:bold; text-decoration:underline">：</span>
                <span style="font-family:'宋体'">当您违反与我们的约定时或您的</span>
                <span style="font-family:'宋体'">债务</span>
                <span style="font-family:'宋体'">发生逾期时，为维护我们及</span>
                <span style="font-family:Tahoma">/</span>
                <span style="font-family:'宋体'">或贷款人的合法权益，我们</span>
                <span style="font-family:'宋体'">可能</span>
                <span style="font-family:'宋体'">向我们合作的催收机构</span>
                <span style="font-family:'宋体'">、</span>
                <span style="font-family:'宋体'">律师事务所披露您</span>
                <span style="font-family:'宋体'">的</span>
                <span style="font-family:'宋体'; font-weight:bold">真实姓名</span>
                <span style="font-family:'宋体'">、</span>
                <span style="font-family:'宋体'; font-weight:bold">身份证</span>
                <span style="font-family:'宋体'; font-weight:bold">信息</span>
                <span style="font-family:'宋体'">、</span>
                <span style="font-family:'宋体'; font-weight:bold">电话号码</span>
                <span style="font-family:'宋体'">、</span>
                <span style="font-family:'宋体'; font-weight:bold">居住地址</span>
                <span style="font-family:'宋体'">、</span>
                <span style="font-family:'宋体'; font-weight:bold">紧急联系人信息</span>
                <span style="font-family:'宋体'">以及</span>
                <span style="font-family:'宋体'; font-weight:bold">贷款</span>
                <span style="font-family:'宋体'; font-weight:bold">信息</span>
                <span style="font-family:'宋体'; font-weight:bold">、房</span>
                <span style="font-family:'宋体'; font-weight:bold">产信息</span>
                <span style="font-family:'宋体'">。</span>
            </p>
            <p style="margin-top:0px; margin-bottom:0px; text-indent:21px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                <span style="font-family:'宋体'">对于我们</span>
                <span style="font-family:'宋体'">与之共享个人信息的</span>
                <span style="font-family:'宋体'">机构</span>
                <span style="font-family:'宋体'">，我们会</span>
                <span style="font-family:'宋体'">与其</span>
                <span style="font-family:'宋体'">签署严格的</span>
                <span style="font-family:'宋体'">保密</span>
                <span style="font-family:'宋体'">协议</span>
                <span style="font-family:Tahoma">/</span>
                <span style="font-family:'宋体'">条款</span>
                <span style="font-family:'宋体'">，</span>
                <span style="font-family:'宋体'">要求</span>
                <span style="font-family:'宋体'">其按照我们</span>
                <span style="font-family:'宋体'">的</span>
                <span style="font-family:'宋体'">要求采取相关的保密和安全措施来处理</span>
                <span style="font-family:'宋体'">我们</span>
                <span style="font-family:'宋体'">共享的个人信息。在</span>
                <span style="font-family:'宋体'">涉及个人</span>
                <span style="font-family:'宋体'">敏感信息时，我们要求该等机构采用</span>
                <span style="font-family:'宋体'">脱敏</span>
                <span style="font-family:'宋体'">和加密技术</span>
                <span style="font-family:'宋体'">对</span>
                <span style="font-family:'宋体'">个人信息进行保护</span>
                <span style="font-family:'宋体'">，</span>
                <span style="font-family:'宋体'">从而更好地保护您的个人信息。</span>
            </p>
            <ol start="3" type="1" style="margin:0px; padding-left:0px">
                <li style="margin-left:34.91px; text-align:justify; widows:0; orphans:0; padding-left:4.09px; font-family:Tahoma; font-size:10.5px; font-weight:bold">
                    <span style="font-family:'宋体'">3.转让</span>
                </li>
            </ol>
            <p style="margin-top:0px; margin-left:21px; margin-bottom:0px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                <span style="font-family:'宋体'">除</span>
                <span style="font-family:'宋体'">以下情形外，我们不会将您的个人信息转让给任何公司、组织</span>
                <span style="font-family:'宋体'">或</span>
                <span style="font-family:'宋体'">个人</span>
                <span style="font-family:'宋体'">：</span>
            </p>
            <p style="margin-top:0px; margin-left:42.55px; margin-bottom:0px; text-indent:-26.8px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                <span style="font-family:'宋体'">（</span>
                <span style="font-family:Tahoma">1</span>
                <span style="font-family:'宋体'">）</span>
                <span style="font:7px 'Times New Roman'"></span>
                <span style="font-family:'宋体'">事先</span>
                <span style="font-family:'宋体'">获得您的明确同意的；</span>
            </p>
            <p style="margin-top:0px; margin-left:42.55px; margin-bottom:0px; text-indent:-26.8px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                <span style="font-family:'宋体'">（</span>
                <span style="font-family:Tahoma">2</span>
                <span style="font-family:'宋体'">）</span>
                <span style="font:7px 'Times New Roman'"></span>
                <span style="font-family:'宋体'">根据法律</span>
                <span style="font-family:'宋体'">法规规定，</span>
                <span style="font-family:'宋体'">或者</span>
                <span style="font-family:'宋体'">政府主管部门</span>
                <span style="font-family:'宋体'">、</span>
                <span style="font-family:'宋体'">司法机关的强制</span>
                <span style="font-family:'宋体'">要求必须对外转让</span>
                <span style="font-family:'宋体'">的；</span>
            </p>
            <p style="margin-top:0px; margin-bottom:0px; text-indent:15.75px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                <span style="font-family:'宋体'">（</span>
                <span style="font-family:Tahoma">3</span>
                <span style="font-family:'宋体'">）</span>
                <span style="font:7px 'Times New Roman'"></span>
                <span style="font-family:'宋体'">涉及</span>
                <span style="font-family:'宋体'">公司合并、分立、</span>
                <span style="font-family:'宋体'">解散</span>
                <span style="font-family:'宋体'">、资产或业务转让</span>
                <span style="font-family:'宋体'">、</span>
                <span style="font-family:'宋体'">破产清算</span>
                <span style="font-family:'宋体'">或</span>
                <span style="font-family:'宋体'">类似的交易时，若涉及到您的个人信息转让，我们会要求新持有您个人信息的公司、组织</span>
                <span style="font-family:'宋体'">或</span>
                <span style="font-family:'宋体'">个人继续</span>
                <span style="font-family:'宋体'">受</span>
                <span style="font-family:'宋体'">本政策的</span>
                <span style="font-family:'宋体'">约束</span>
                <span style="font-family:'宋体'">，否则我们将要求该等公司、组织或个人重新取得您的授权同意。</span>
            </p>
            <ol start="4" type="1" style="margin:0px; padding-left:0px">
                <li style="margin-left:34.91px; text-align:justify; widows:0; orphans:0; padding-left:4.09px; font-family:Tahoma; font-size:10.5px; font-weight:bold">
                    <span style="font-family:'宋体'">4.公开</span>
                    <span style="font-family:'宋体'">披露</span>
                </li>
            </ol>
            <p style="margin-top:0px; margin-left:21px; margin-bottom:0px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                <span style="font-family:'宋体'">除</span>
                <span style="font-family:'宋体'">以下情形外，我们不会公开披露您的个人信息：</span>
            </p>
            <p style="margin-top:0px; margin-left:49.65px; margin-bottom:0px; text-indent:-28.65px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                <span style="font-family:'宋体'">（</span>
                <span style="font-family:Tahoma">1</span>
                <span style="font-family:'宋体'">）</span>
                <span style="font:7px 'Times New Roman'"></span>
                <span style="font-family:'宋体'">事先</span>
                <span style="font-family:'宋体'">获得您的</span>
                <span style="font-family:'宋体'">明确</span>
                <span style="font-family:'宋体'">同意的；</span>
            </p>
            <p style="margin-top:0px; margin-bottom:0px; text-indent:21px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                <span style="font-family:'宋体'">（</span>
                <span style="font-family:Tahoma">2</span>
                <span style="font-family:'宋体'">）</span>
                <span style="font:7px 'Times New Roman'"></span>
                <span style="font-family:'宋体'">根据法律</span>
                <span style="font-family:'宋体'">法规规定，</span>
                <span style="font-family:'宋体'">或者</span>
                <span style="font-family:'宋体'">政府主管部门</span>
                <span style="font-family:'宋体'">、</span>
                <span style="font-family:'宋体'">司法机关的强制</span>
                <span style="font-family:'宋体'">要求必须</span>
                <span style="font-family:'宋体'">公开披露的</span>
                <span style="font-family:'宋体'">。</span>
                <span style="font-family:'宋体'">在符合法律法规的前提下，当我们收到上述披露信息的请求时，我们会要求必须出具与之相应的法律文件，如传票或调查函。我们坚信，对于要求我们提供的信息，应该在法律允许的范围内尽可能保持透明。我们对所有的请求都</span>
                <span style="font-family:'宋体'">将</span>
                <span style="font-family:'宋体'">进行慎重的审查，以确保其具备合法依据，且仅限于执法部门因特定调查目的且有合法权利获取的数据</span>
                <span style="font-family:'宋体'">。</span>
            </p>
            <p style="margin-top:0px; margin-bottom:0px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                <span style="font-family:Tahoma">&#xa0;</span>
            </p>
            <p style="margin-top:0px; margin-left:21px; margin-bottom:0px; text-indent:-21px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                <span style="font-family:'宋体'; font-weight:bold">六、</span>
                <span style="font:7px 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;</span>
                <span style="font-family:'宋体'; font-weight:bold">我们</span>
                <span style="font-family:'宋体'; font-weight:bold">如何存储个人信息</span>
            </p>
            <ol type="1" style="margin:0px; padding-left:0px">
                <li style="margin-left:34.13px; text-align:justify; widows:0; orphans:0; padding-left:4.87px; font-family:Calibri; font-size:10.5px; font-weight:bold">
                    <span style="font-family:'宋体'">1.存储地域</span>
                </li>
            </ol>
            <p style="margin-top:0px; margin-bottom:0px; text-indent:21px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                <span style="font-family:'宋体'; color:#333333">您的</span>
                <span style="font-family:'宋体'; color:#333333">所有</span>
                <span style="font-family:'宋体'; color:#333333">个人信息将储存于中华人民共和国境内，本政策项下，您的个人信息不涉及跨境传输。</span>
                <span style="font-family:'宋体'; color:#333333">若</span>
                <span style="font-family:'宋体'; color:#333333">将来涉及跨境传输且确需向境外机构传输您的个人信息，我们会按照法律、行政法规和相关监管部门的规定执行，</span>
                <span style="font-family:'宋体'; font-weight:bold; color:#333333">并在数据跨境传输前再次征求您的同意和允许或进行匿名化处理。</span>
                <span style="font-family:'宋体'; color:#333333">同时，我们确保会在政策中详细说明数据传输的地点和用途，让您随时了解个人信息的存储位置</span>
                <span style="font-family:'宋体'; color:#333333">，</span>
                <span style="font-family:'宋体'; color:#333333">且为</span>
                <span style="font-family:'宋体'; color:#333333">了</span>
                <span style="font-family:'宋体'; color:#333333">确保您的个人信息得到足够的保护，</span>
                <span style="font-family:'宋体'; color:#333333">我们</span>
                <span style="font-family:'宋体'; color:#333333">将会在跨境数据转移之前将您的个人信息采取如加密传输等安全技术措施</span>
                <span style="font-family:'宋体'; color:#333333">。</span>
            </p>
            <ol start="2" type="1" style="margin:0px; padding-left:0px">
                <li style="margin-left:34.13px; text-align:justify; widows:0; orphans:0; padding-left:4.87px; font-family:Calibri; font-size:10.5px; font-weight:bold">
                    <span style="font-family:'宋体'">2.存储</span>
                    <span style="font-family:'宋体'">期限</span>
                </li>
            </ol>
            <p style="margin-top:0px; margin-bottom:0px; text-indent:21px; font-size:10.5px; background-color:#ffffff">
                <span style="font-family:'宋体'; color:#333333">为保证您的合法权益，除法律法规另有规定外，您的个人信息保存期限将截至您</span>
                <span style="font-family:'宋体'; color:#333333">所使用的</span>
                <span style="font-family:'宋体'; color:#333333">产品或服务到期后</span>
                <span style="font-family:Helvetica; color:#333333">5</span>
                <span style="font-family:'宋体'; color:#333333">年</span>
                <span style="font-family:'宋体'; color:#333333">。当您的个人信息超出我们的保存期限后，我们</span>
                <span style="font-family:'宋体'; color:#333333">将</span>
                <span style="font-family:'宋体'; color:#333333">对您的个人信息进行删除或匿名化处理。</span>
            </p>
            <p style="margin-top:0px; margin-bottom:0px; text-indent:21px; font-size:10.5px; background-color:#ffffff">
                <span style="font-family:'宋体'; color:#333333">您</span>
                <span style="font-family:'宋体'; color:#333333">的</span>
                <span style="font-family:'宋体'; color:#333333">个人</span>
                <span style="font-family:'宋体'; color:#333333">信息经匿名化处理后可能形成可以使用</span>
                <span style="font-family:'宋体'; color:#333333">的</span>
                <span style="font-family:'宋体'; color:#333333">数据，我们对此类数据的</span>
                <span style="font-family:'宋体'; color:#333333">保存</span>
                <span style="font-family:'宋体'; color:#333333">及</span>
                <span style="font-family:'宋体'; color:#333333">使用</span>
                <span style="font-family:'宋体'; color:#333333">无需另行通知并征得您的同意。</span>
            </p>
            <p style="margin-top:0px; margin-bottom:0px; text-indent:21px; font-size:10.5px; background-color:#ffffff">
                <span style="font-family:Helvetica; color:#333333">&#xa0;</span>
            </p>
            <div style="margin-right:9.75px; background-color:#ffffff">
                <p style="margin-top:0px; margin-left:21px; margin-bottom:0px; text-indent:-21px; font-size:10.5px">
                    <span style="font-family:'宋体'; font-weight:bold">七、</span>
                    <span style="font-family:'宋体'; font-weight:bold">我们</span>
                    <span style="font-family:'宋体'; font-weight:bold">如何保护个人信息</span>
                </p>
            </div>
            <ol type="1" style="margin:0px; padding-left:0px">
                <li style="text-indent:21px; text-align:justify; widows:0; orphans:0; font-family:Tahoma; font-size:12px; list-style-position:inside; -aw-list-padding-sml:5.82px">
                    <span style="font:7px 'Times New Roman'; -aw-list-padding-sml:5.82px">&#xa0;&#xa0;&#xa0;</span>
                    <span style="font-family:'宋体'; font-size:10.5px">1.我们已使用</span>
                    <span style="font-family:'宋体'; font-size:10.5px">符合业界标准的安全防护措施保护您提供的个人信息，防止</span>
                    <span style="font-family:'宋体'; font-size:10.5px">您</span>
                    <span style="font-family:'宋体'; font-size:10.5px">的个人信息遭到未经授权访问、</span>
                    <span style="font-family:'宋体'; font-size:10.5px">使用</span>
                    <span style="font-family:'宋体'; font-size:10.5px">、修改、</span>
                    <span style="font-family:'宋体'; font-size:10.5px">公开</span>
                    <span style="font-family:'宋体'; font-size:10.5px">披露、损坏或丢失</span>
                    <span style="font-family:'宋体'; font-size:10.5px">。</span>
                    <span style="font-family:'宋体'; font-size:10.5px">我们</span>
                    <span style="font-family:'宋体'; font-size:10.5px">会</span>
                    <span style="font-family:'宋体'; font-size:10.5px">采取一切</span>
                    <span style="font-family:'宋体'; font-size:10.5px">合理可行</span>
                    <span style="font-family:'宋体'; font-size:10.5px">的措施，保护您的个人信息，比如：</span>
                </li>
            </ol>
            <p style="margin-top:0px; margin-bottom:0px; text-indent:18px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                <span style="font-family:'宋体'; font-size:9px; color:#333333">（</span>
                <span style="font-family:Arial; font-size:9px; color:#333333">1</span>
                <span style="font-family:'宋体'; font-size:9px; color:#333333">）</span>
                <span style="font:7px 'Times New Roman'">&#xa0;&#xa0;&#xa0;</span>
                <span style="font-family:'宋体'">我们设立</span>
                <span style="font-family:'宋体'">了</span>
                <span style="font-family:'宋体'">网络</span>
                <span style="font-family:'宋体'">安全</span>
                <span style="font-family:'宋体'">和</span>
                <span style="font-family:'宋体'">个人信息保护小组</span>
                <span style="font-family:'宋体'">，</span>
                <span style="font-family:'宋体'">专门负责</span>
                <span style="font-family:'宋体'">网络安全和</span>
                <span style="font-family:'宋体'">个人信息保护</span>
                <span style="font-family:'宋体'">事务</span>
                <span style="font-family:'宋体'">；</span>
            </p>
            <p style="margin-top:0px; margin-bottom:0px; text-indent:18px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                <span style="font-family:'宋体'; font-size:9px; color:#333333">（</span>
                <span style="font-family:Arial; font-size:9px; color:#333333">2</span>
                <span style="font-family:'宋体'; font-size:9px; color:#333333">）</span>
                <span style="font:7px 'Times New Roman'">&#xa0;&#xa0;&#xa0;</span>
                <span style="font-family:'宋体'">我们的网络服务采取了传输层安全协议等加密技术，通过</span>
                <span style="font-family:Tahoma">https</span>
                <span style="font-family:'宋体'">等方式提供浏览服务，确保用户数据在传输过程中的安全</span>
                <span style="font-family:'宋体'">；</span>
            </p>
            <p style="margin-top:0px; margin-bottom:0px; text-indent:18px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                <span style="font-family:'宋体'; font-size:9px; color:#333333">（</span>
                <span style="font-family:Arial; font-size:9px; color:#333333">3</span>
                <span style="font-family:'宋体'; font-size:9px; color:#333333">）</span>
                <span style="font:7px 'Times New Roman'">&#xa0;&#xa0;&#xa0;</span>
                <span style="font-family:'宋体'">我们采取</span>
                <span style="font-family:Tahoma">MD5</span>
                <span style="font-family:'宋体'">、</span>
                <span style="font-family:Tahoma">SHA256</span>
                <span style="font-family:'宋体'">等</span>
                <span style="font-family:'宋体'">加密技术对您的个人信息进行加密存储，增强个人信息在使用中的安全性</span>
                <span style="font-family:'宋体'">；</span>
            </p>
            <p style="margin-top:0px; margin-bottom:0px; text-indent:18px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                <span style="font-family:'宋体'; font-size:9px; color:#333333">（</span>
                <span style="font-family:Arial; font-size:9px; color:#333333">4</span>
                <span style="font-family:'宋体'; font-size:9px; color:#333333">）</span>
                <span style="font:7px 'Times New Roman'">&#xa0;&#xa0;&#xa0;</span>
                <span style="font-family:'宋体'">我们采用严格的数据访问权限控制和多重身份认证技术保护个人信息，避免数据被违规使用</span>
                <span style="font-family:'宋体'">；</span>
            </p>
            <p style="margin-top:0px; margin-bottom:0px; text-indent:18px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                <span style="font-family:'宋体'; font-size:9px; color:#333333">（</span>
                <span style="font-family:Arial; font-size:9px; color:#333333">5</span>
                <span style="font-family:'宋体'; font-size:9px; color:#333333">）</span>
                <span style="font:7px 'Times New Roman'">&#xa0;&#xa0;&#xa0;</span>
                <span style="font-family:'宋体'">我们采用代码安全检查、数据访问日志分析技术进行个人信息安全审计</span>
                <span style="font-family:'宋体'">；</span>
            </p>
            <p style="margin-top:0px; margin-bottom:0px; text-indent:18px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                <span style="font-family:'宋体'; font-size:9px; color:#333333">（</span>
                <span style="font-family:Arial; font-size:9px; color:#333333">6</span>
                <span style="font-family:'宋体'; font-size:9px; color:#333333">）</span>
                <span style="font:7px 'Times New Roman'">&#xa0;&#xa0;&#xa0;</span>
                <span style="font-family:'宋体'">我们</span>
                <span style="font-family:'宋体'">建立了</span>
                <span style="font-family:'宋体'">客户</span>
                <span style="font-family:'宋体'">信息</span>
                <span style="font-family:'宋体'">保护</span>
                <span style="font-family:'宋体'">管理</span>
                <span style="font-family:'宋体'">规定、客户</span>
                <span style="font-family:'宋体'">信息分级分类管理规定、</span>
                <span style="font-family:'宋体'">日常</span>
                <span style="font-family:'宋体'">操作规程等一系列</span>
                <span style="font-family:'宋体'">管理</span>
                <span style="font-family:'宋体'">制度来规范个人信息的存储和使用；</span>
            </p>
            <p style="margin-top:0px; margin-bottom:0px; text-indent:18px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                <span style="font-family:'宋体'; font-size:9px; color:#333333">（</span>
                <span style="font-family:Arial; font-size:9px; color:#333333">7</span>
                <span style="font-family:'宋体'; font-size:9px; color:#333333">）</span>
                <span style="font:7px 'Times New Roman'">&#xa0;&#xa0;&#xa0;</span>
                <span style="font-family:'宋体'">我们定期</span>
                <span style="font-family:'宋体'">举办信息安全和个人信息保护培训课程，加强员工对于个人信息保护重要性的认识；</span>
            </p>
            <p style="margin-top:0px; margin-bottom:0px; text-indent:18px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                <span style="font-family:'宋体'; font-size:9px; color:#333333">（</span>
                <span style="font-family:Arial; font-size:9px; color:#333333">8</span>
                <span style="font-family:'宋体'; font-size:9px; color:#333333">）</span>
                <span style="font:7px 'Times New Roman'">&#xa0;&#xa0;&#xa0;</span>
                <span style="font-family:'宋体'">我们与</span>
                <span style="font-family:'宋体'">所有可能</span>
                <span style="font-family:'宋体'">接触</span>
                <span style="font-family:'宋体'">个人信息的员工</span>
                <span style="font-family:'宋体'">签订了保密协议</span>
                <span style="font-family:'宋体'">，</span>
                <span style="font-family:'宋体'">对</span>
                <span style="font-family:'宋体'">关键岗位人员进行背景</span>
                <span style="font-family:'宋体'">审查</span>
                <span style="font-family:'宋体'">，并建立了</span>
                <span style="font-family:'宋体'">严格的访问权限控制、权限审批流程和监控</span>
                <span style="font-family:'宋体'">、</span>
                <span style="font-family:'宋体'">审计机制</span>
                <span style="font-family:'宋体'">；</span>
            </p>
            <p style="margin-top:0px; margin-bottom:0px; text-indent:18px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                <span style="font-family:'宋体'; font-size:9px; color:#333333">（</span>
                <span style="font-family:Arial; font-size:9px; color:#333333">9</span>
                <span style="font-family:'宋体'; font-size:9px; color:#333333">）</span>
                <span style="font:7px 'Times New Roman'">&#xa0;&#xa0;&#xa0;</span>
                <span style="font-family:'宋体'">我们与所有</span>
                <span style="font-family:'宋体'">可能接触</span>
                <span style="font-family:'宋体'">用户</span>
                <span style="font-family:'宋体'">个人信息的</span>
                <span style="font-family:'宋体'">合作</span>
                <span style="font-family:'宋体'">伙伴均签署了严格的保密协议</span>
                <span style="font-family:'宋体'">或</span>
                <span style="font-family:'宋体'">数据保护专用条款，</span>
                <span style="font-family:'宋体'">并要求</span>
                <span style="font-family:'宋体'">可能接触到您个人信息的所有人员履行相应的保密</span>
                <span style="font-family:'宋体'">和数据保护</span>
                <span style="font-family:'宋体'">义务。如果第三方</span>
                <span style="font-family:'宋体'">合作伙伴</span>
                <span style="font-family:'宋体'">未履行保密</span>
                <span style="font-family:'宋体'">和</span>
                <span style="font-family:'宋体'">数据保护义务，可能会被我们追究法律责任并被我们终止合作</span>
                <span style="font-family:'宋体'">。</span>
            </p>
            <ol start="2" type="1" style="margin:0px; padding-left:0px">
                <li style="text-indent:21px; text-align:justify; widows:0; orphans:0; font-family:Tahoma; font-size:10.5px; list-style-position:inside; -aw-list-padding-sml:7.09px">
                    <span style="font:7px 'Times New Roman'; -aw-list-padding-sml:7.09px">&#xa0;&#xa0;&#xa0;&#xa0;</span>
                    <span style="font-family:'宋体'">2.我们</span>
                    <span style="font-family:'宋体'">会采取一切合理可行的措施，确保未收集无关的个人信息。我们</span>
                    <span style="font-family:'宋体'">只会</span>
                    <span style="font-family:'宋体'">在达成本政策所述目的所需</span>
                    <span style="font-family:'宋体'">的</span>
                    <span style="font-family:'宋体'">期限内保留您的个人信息，除非需要延长保留期或者受到法律允许。</span>
                </li>
                <li style="text-indent:21px; text-align:justify; widows:0; orphans:0; font-family:Tahoma; font-size:10.5px; list-style-position:inside; -aw-list-padding-sml:7.09px">
                    <span style="font:7px 'Times New Roman'; -aw-list-padding-sml:7.09px">&#xa0;&#xa0;&#xa0;&#xa0;</span>
                    <span style="font-family:'宋体'; font-weight:bold; text-decoration:underline">3.互联网并非绝对安全的环境，而且电子邮件、即时通讯、社交软件等与其他用户的交流方式无法确定是否完全加密，我们</span>
                    <span style="font-family:'宋体'; font-weight:bold; text-decoration:underline">强烈</span>
                    <span style="font-family:'宋体'; font-weight:bold; text-decoration:underline">建议您不用通过此类方式发送个人信息。</span>
                    <span style="font-family:'宋体'">若</span>
                    <span style="font-family:'宋体'">确需使用，</span>
                    <span style="font-family:'宋体'">在</span>
                    <span style="font-family:'宋体'">使用此类工具时请使用复杂密码，并注意保护您的个人信息安全。我们将尽力保障您个人信息的安全性。如果我们的物理、技术、或管理防护设施遭到破坏，导致信息被非授权访问、公开披露、篡改、或毁坏，导致您的合法权益受损，我们将全力配合保护您的权益，并依法承担我们应承担的赔偿责任</span>
                    <span style="font-family:'宋体'">。</span>
                </li>
                <li style="text-indent:21px; text-align:justify; widows:0; orphans:0; font-family:Tahoma; font-size:10.5px; list-style-position:inside; -aw-list-padding-sml:7.09px">
                    <span style="font:7px 'Times New Roman'; -aw-list-padding-sml:7.09px">&#xa0;&#xa0;&#xa0;&#xa0;</span>
                    <span style="font-family:'宋体'">4.在不幸</span>
                    <span style="font-family:'宋体'">发生个人信息安全事件后，我们将按照法律法规的要求</span>
                    <span style="font-family:'宋体'">及时</span>
                    <span style="font-family:'宋体'">向您告知安全事件的基本情况和可能的影响、我们已采取</span>
                    <span style="font-family:'宋体'">或</span>
                    <span style="font-family:'宋体'">将</span>
                    <span style="font-family:'宋体'">采取</span>
                    <span style="font-family:'宋体'">的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们</span>
                    <span style="font-family:'宋体'">将</span>
                    <span style="font-family:'宋体'">及时将事件相关情况以邮件、</span>
                    <span style="font-family:'宋体'">信函</span>
                    <span style="font-family:'宋体'">、电话、推送通知等</span>
                    <span style="font-family:'宋体'">方式</span>
                    <span style="font-family:'宋体'">告知您，难以逐一告知</span>
                    <span style="font-family:'宋体'">时</span>
                    <span style="font-family:'宋体'">，我们会采取合理、有效的方式发布公告。</span>
                    <span style="font-family:'宋体'">同时</span>
                    <span style="font-family:'宋体'">，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。</span>
                </li>
            </ol>
            <p style="margin-top:0px; margin-left:21px; margin-bottom:0px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                <span style="font-family:Tahoma">&#xa0;</span>
            </p>
            <div style="margin-right:9.75px; background-color:#ffffff">
                <p style="margin-top:0px; margin-left:21px; margin-bottom:0px; text-indent:-21px; font-size:10.5px">
                    <span style="font-family:'宋体'; font-weight:bold">八、</span>
                    <span style="font-family:'宋体'; font-weight:bold">您</span>
                    <span style="font-family:'宋体'; font-weight:bold">的权利</span>
                </p>
            </div>
            <p style="margin-top:0px; margin-right:9.75px; margin-bottom:0px; text-indent:21px; font-size:10.5px; background-color:#ffffff">
                <span style="font-family:'宋体'">根据国家相关法律、法规、标准，我们保障您登陆“大数服务号”后，可对自己的个人信息行使以下权利：</span>
            </p>
            <ol type="1" style="margin:0px; padding-left:0px">
                <li style="margin-right:9.75px; margin-left:34.91px; padding-left:4.09px; font-family:Tahoma; font-size:10.5px; font-weight:bold; background-color:#ffffff">
                    <span style="font-family:'宋体'">1.访问您</span>
                    <span style="font-family:'宋体'">的个人信息</span>
                </li>
            </ol>
            <p style="margin-top:0px; margin-right:9.75px; margin-bottom:0px; text-indent:21px; font-size:10.5px; background-color:#ffffff">
                <span style="font-family:'宋体'">除</span>
                <span style="font-family:'宋体'">法律法规规定的例外情况外，</span>
                <span style="font-family:'宋体'">您</span>
                <span style="font-family:'宋体'">有权访问您的个人信息</span>
                <span style="font-family:'宋体'">。</span>
            </p>
            <p style="margin-top:0px; margin-right:9.75px; margin-bottom:0px; text-indent:21px; font-size:10.5px; background-color:#ffffff">
                <span style="font-family:'宋体'">您可</span>
                <span style="font-family:'宋体'">通过</span>
                <span style="font-family:Tahoma">“</span>
                <span style="font-family:'宋体'">我</span>
                <span style="font-family:'宋体'">的业务</span>
                <span style="font-family:Tahoma">——</span>
                <span style="font-family:'宋体'">业务</span>
                <span style="font-family:'宋体'">查询</span>
                <span style="font-family:'宋体'">”访问</span>
                <span style="font-family:'宋体'">您的</span>
                <span style="font-family:'宋体'">借款申请</span>
                <span style="font-family:'宋体'">信息</span>
                <span style="font-family:'宋体'">，可</span>
                <span style="font-family:'宋体'">通过</span>
                <span style="font-family:Tahoma">“</span>
                <span style="font-family:'宋体'">我</span>
                <span style="font-family:'宋体'">的业务</span>
                <span style="font-family:Tahoma">-</span>
                <span style="font-family:'宋体'">个人中心</span>
                <span style="font-family:Tahoma">”</span>
                <span style="font-family:'宋体'">访问您</span>
                <span style="font-family:'宋体'">的</span>
                <span style="font-family:'宋体'; font-weight:bold">实名资料</span>
                <span style="font-family:'宋体'">、</span>
                <span style="font-family:'宋体'; font-weight:bold">银行卡号</span>
                <span style="font-family:'宋体'">、</span>
                <span style="font-family:'宋体'; font-weight:bold">手机</span>
                <span style="font-family:'宋体'; font-weight:bold">号码</span>
                <span style="font-family:'宋体'">、</span>
                <span style="font-family:'宋体'; font-weight:bold">身份证</span>
                <span style="font-family:'宋体'; font-weight:bold">信息</span>
                <span style="font-family:'宋体'">，可通过</span>
                <span style="font-family:Tahoma">“</span>
                <span style="font-family:'宋体'">我</span>
                <span style="font-family:'宋体'">的</span>
                <span style="font-family:'宋体'">业务</span>
                <span style="font-family:Tahoma">-</span>
                <span style="font-family:'宋体'">还款计划</span>
                <span style="font-family:Tahoma">”</span>
                <span style="font-family:'宋体'">访问您</span>
                <span style="font-family:'宋体'">的</span>
                <span style="font-family:'宋体'">借款和</span>
                <span style="font-family:'宋体'">逾期信息</span>
                <span style="font-family:'宋体'">。</span>
            </p>
            <p style="margin-top:0px; margin-right:9.75px; margin-bottom:0px; text-indent:21px; font-size:10.5px; background-color:#ffffff">
                <span style="font-family:'宋体'">对于</span>
                <span style="font-family:'宋体'">您在使用我们的产品或服务过程中向我们提供或产生的其他信息，</span>
                <span style="font-family:'宋体'">只要</span>
                <span style="font-family:'宋体'">我们不需要过多投入，</span>
                <span style="font-family:'宋体'">我们</span>
                <span style="font-family:'宋体'">会向您提供</span>
                <span style="font-family:'宋体'">。</span>
                <span style="font-family:'宋体'">您</span>
                <span style="font-family:'宋体'">可以</span>
                <span style="font-family:'宋体'">通过拨打我们的客服电话</span>
                <span style="font-family:'宋体'">提出访问</span>
                <span style="font-family:'宋体'">申请，我们将</span>
                <span style="font-family:'宋体'">在</span>
                <span style="font-family:Tahoma">30</span>
                <span style="font-family:'宋体'">天</span>
                <span style="font-family:'宋体'">内</span>
                <span style="font-family:'宋体'">回复</span>
                <span style="font-family:'宋体'">您的访问</span>
                <span style="font-family:'宋体'">请求</span>
                <span style="font-family:'宋体'">。</span>
            </p>
            <ol start="2" type="1" style="margin:0px; padding-left:0px">
                <li style="margin-right:9.75px; margin-left:34.91px; padding-left:4.09px; font-family:Tahoma; font-size:10.5px; font-weight:bold; background-color:#ffffff">
                    <span style="font-family:'宋体'">2.更正您</span>
                    <span style="font-family:'宋体'">的个人信息</span>
                </li>
            </ol>
            <p style="margin-top:0px; margin-right:9.75px; margin-bottom:0px; text-indent:21px; font-size:10.5px; background-color:#ffffff">
                <span style="font-family:'宋体'">当您发现</span>
                <span style="font-family:'宋体'">我们处理的</span>
                <span style="font-family:'宋体'">您</span>
                <span style="font-family:'宋体'">的</span>
                <span style="font-family:'宋体'; font-weight:bold">手机号码</span>
                <span style="font-family:'宋体'">和</span>
                <span style="font-family:'宋体'; font-weight:bold">身份证信息</span>
                <span style="font-family:'宋体'">有误</span>
                <span style="font-family:'宋体'">或者您需要更正该等信息时，您可以通过</span>
                <span style="font-family:'宋体'">“我</span>
                <span style="font-family:'宋体'">的</span>
                <span style="font-family:'宋体'">业务</span>
                <span style="font-family:Tahoma">——</span>
                <span style="font-family:'宋体'">个人中心</span>
                <span style="font-family:'宋体'">”，或者联系人工客服（微信公众号</span>
                <span style="font-family:'宋体'">中回复</span>
                <span style="font-family:Tahoma">“0”</span>
                <span style="font-family:'宋体'">或者拨打客服热线）进行</span>
                <span style="font-family:'宋体'">修改或更正。</span>
                <span style="font-family:'宋体'">您</span>
                <span style="font-family:'宋体'">如果需要更正其他个人信息，可通过</span>
                <span style="font-family:'宋体'">联系人工客服向我们</span>
                <span style="font-family:'宋体'">提出更正申请。</span>
            </p>
            <ol start="3" type="1" style="margin:0px; padding-left:0px">
                <li style="margin-right:9.75px; margin-left:34.91px; padding-left:4.09px; font-family:Tahoma; font-size:10.5px; font-weight:bold; background-color:#ffffff">
                    <span style="font-family:'宋体'">3.删除您</span>
                    <span style="font-family:'宋体'">的个人信息</span>
                </li>
            </ol>
            <p style="margin-top:0px; margin-right:9.75px; margin-bottom:0px; text-indent:21px; font-size:10.5px; background-color:#ffffff">
                <span style="font-family:'宋体'">在</span>
                <span style="font-family:'宋体'">以下情形</span>
                <span style="font-family:'宋体'">中</span>
                <span style="font-family:'宋体'">，</span>
                <span style="font-family:'宋体'">您</span>
                <span style="font-family:'宋体'">可以向我们提出删除个人信息的请求：</span>
            </p>
            <div style="margin-right:9.75px; margin-left:21px; background-color:#ffffff">
                <p style="margin-top:0px; margin-left:28.65px; margin-bottom:0px; text-indent:-28.65px; font-size:10.5px">
                    <span style="font-family:'宋体'">（</span>
                    <span style="font-family:Tahoma">1</span>
                    <span style="font-family:'宋体'">）</span>
                    <span style="font:7px 'Times New Roman'"></span>
                    <span style="font-family:'宋体'">如果</span>
                    <span style="font-family:'宋体'">我们处理个人信息的行为违反</span>
                    <span style="font-family:'宋体'">了</span>
                    <span style="font-family:'宋体'">法律法规的强制性规定；</span>
                </p>
            </div>
            <p style="margin-top:0px; margin-right:9.75px; margin-bottom:0px; text-indent:21px; font-size:10.5px; background-color:#ffffff">
                <span style="font-family:'宋体'">（</span>
                <span style="font-family:Tahoma">2</span>
                <span style="font-family:'宋体'">）</span>
                <span style="font:7px 'Times New Roman'"></span>
                <span style="font-family:'宋体'">如果</span>
                <span style="font-family:'宋体'">我</span>
                <span style="font-family:'宋体'">们</span>
                <span style="font-family:'宋体'">收集、使用</span>
                <span style="font-family:'宋体'">您</span>
                <span style="font-family:'宋体'">的个人信息，却未征得您的同意（</span>
                <span style="font-family:'宋体'">依法无需</span>
                <span style="font-family:'宋体'">征得同意的情况除外）</span>
                <span style="font-family:'宋体'">；</span>
            </p>
            <p style="margin-top:0px; margin-right:9.75px; margin-bottom:0px; text-indent:21px; font-size:10.5px; background-color:#ffffff">
                <span style="font-family:'宋体'">（</span>
                <span style="font-family:Tahoma">3</span>
                <span style="font-family:'宋体'">）</span>
                <span style="font:7px 'Times New Roman'"></span>
                <span style="font-family:'宋体'">如果</span>
                <span style="font-family:'宋体'">我们处理个人信息的行为</span>
                <span style="font-family:'宋体'">违反了</span>
                <span style="font-family:'宋体'">与您的</span>
                <span style="font-family:'宋体'">约定</span>
                <span style="font-family:'宋体'">；</span>
            </p>
            <p style="margin-top:0px; margin-right:9.75px; margin-bottom:0px; text-indent:21px; font-size:10.5px; background-color:#ffffff">
                <span style="font-family:'宋体'">（</span>
                <span style="font-family:Tahoma">4</span>
                <span style="font-family:'宋体'">）</span>
                <span style="font:7px 'Times New Roman'"></span>
                <span style="font-family:'宋体'">如果</span>
                <span style="font-family:'宋体'">您不再使用我们的</span>
                <span style="font-family:'宋体'">产品</span>
                <span style="font-family:'宋体'">或服务，或您注销了账号；</span>
            </p>
            <p style="margin-top:0px; margin-right:9.75px; margin-bottom:0px; text-indent:21px; font-size:10.5px; background-color:#ffffff">
                <span style="font-family:'宋体'">（</span>
                <span style="font-family:Tahoma">5</span>
                <span style="font-family:'宋体'">）</span>
                <span style="font:7px 'Times New Roman'"></span>
                <span style="font-family:'宋体'">如果</span>
                <span style="font-family:'宋体'">我们不再为您提供产品或</span>
                <span style="font-family:'宋体'">服务</span>
                <span style="font-family:'宋体'">。</span>
            </p>
            <p style="margin-top:0px; margin-right:9.75px; margin-bottom:0px; text-indent:21px; font-size:10.5px; background-color:#ffffff">
                <span style="font-family:'宋体'">收到您的删除请求后，我们会根据您及相关法律法规的要求进行后续删除处理并向您反馈结果。若我们决定响应您的删除请求，我们还将同时通知从我们获得您的个人信息的实体，要求其及时删除，除非法律法规另有规定，或这些实体获得您的独立授权</span>
                <span style="font-family:'宋体'">。</span>
            </p>
            <p style="margin-top:0px; margin-right:9.75px; margin-bottom:0px; text-indent:21px; font-size:10.5px; background-color:#ffffff">
                <span style="font-family:'宋体'">当您从我们的服务中删除信息后，我们可能不会立即备份系统中删除相应的信息，但会在备份更新时删除这些信息</span>
                <span style="font-family:'宋体'">。</span>
            </p>
            <ol start="4" type="1" style="margin:0px; padding-left:0px">
                <li style="margin-right:9.75px; margin-left:34.91px; padding-left:4.09px; font-family:Tahoma; font-size:10.5px; font-weight:bold; background-color:#ffffff">
                    <span style="font-family:'宋体'">4.改变</span>
                    <span style="font-family:'宋体'">您授权同意的范围</span>
                </li>
            </ol>
            <p style="margin-top:0px; margin-right:9.75px; margin-bottom:0px; text-indent:21px; font-size:10.5px; background-color:#ffffff">
                <span style="font-family:'宋体'">（</span>
                <span style="font-family:Tahoma">1</span>
                <span style="font-family:'宋体'">）每</span>
                <span style="font-family:'宋体'">个业务功能需要一些基本的个人信息才能得以完成</span>
                <span style="font-family:'宋体'">。</span>
                <span style="font-family:'宋体'">对于</span>
                <span style="font-family:'宋体'">额外</span>
                <span style="font-family:'宋体'">收集的个人信息的收集和使用，您可随时给予或者收回您的授权同意。</span>
            </p>
            <p style="margin-top:0px; margin-right:9.75px; margin-bottom:0px; text-indent:21px; font-size:10.5px; background-color:#ffffff">
                <span style="font-family:'宋体'; font-weight:bold">当您</span>
                <span style="font-family:'宋体'; font-weight:bold">收回同意后，我们将不再处理相应的个人信息，但您收回同意的决定，不会</span>
                <span style="font-family:'宋体'; font-weight:bold">影响</span>
                <span style="font-family:'宋体'; font-weight:bold">此前</span>
                <span style="font-family:'宋体'; font-weight:bold">基于</span>
                <span style="font-family:'宋体'; font-weight:bold">您的授权而开展的个人信息处理</span>
                <span style="font-family:'宋体'; font-weight:bold">活动</span>
                <span style="font-family:'宋体'; font-weight:bold">。</span>
            </p>
            <p style="margin-top:0px; margin-right:9.75px; margin-bottom:0px; text-indent:21px; font-size:10.5px; background-color:#ffffff">
                <span style="font-family:'宋体'">（</span>
                <span style="font-family:Tahoma">2</span>
                <span style="font-family:'宋体'">）您可以</span>
                <span style="font-family:'宋体'">通过关闭系统权限的方式来撤回</span>
                <span style="font-family:'宋体'">您</span>
                <span style="font-family:'宋体'">原来的授权，但请您注意，此项</span>
                <span style="font-family:'宋体'">撤回不影响我们之前通过您的授权所收集的个人信息，同时，因您的某些授权是实现我们某些业务功能的必要权限，您撤回相应授权可能会影响您使用我们对应的部分业务功能</span>
                <span style="font-family:'宋体'">。</span>
            </p>
            <p style="margin-top:0px; margin-bottom:0px; text-indent:21px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                <span style="font-family:Tahoma">①</span>
                <span style="font:7px 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;</span>
                <span style="font-family:'宋体'">您可以</span>
                <span style="font-family:'宋体'">撤回系统中</span>
                <span style="font-family:'宋体'">对相机权限</span>
                <span style="font-family:'宋体'">的授权，</span>
                <span style="font-family:'宋体'">届时</span>
                <span style="font-family:'宋体'">，我们将无法使用您的摄像头拍摄照片</span>
                <span style="font-family:'宋体'">或</span>
                <span style="font-family:'宋体'">录制视频；</span>
                <span style="font-family:'宋体'"></span>
            </p>
            <p style="margin-top:0px; margin-bottom:0px; text-indent:21px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                <span style="font-family:Tahoma">②</span>
                <span style="font:7px 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;</span>
                <span style="font-family:'宋体'">您可以</span>
                <span style="font-family:'宋体'">撤回系统中</span>
                <span style="font-family:'宋体'">对相册权限</span>
                <span style="font-family:'宋体'">的授权，届时，我们将无法</span>
                <span style="font-family:'宋体'">获取</span>
                <span style="font-family:'宋体'">您的相册中的图片；</span>
                <span style="font-family:'宋体'"></span>
            </p>
            <p style="margin-top:0px; margin-bottom:0px; text-indent:21px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                <span style="font-family:Tahoma">③</span>
                <span style="font:7px 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;</span>
                <span style="font-family:'宋体'">您</span>
                <span style="font-family:'宋体'">可以撤回系统中对</span>
                <span style="font-family:'宋体'">麦克风</span>
                <span style="font-family:'宋体'">权限</span>
                <span style="font-family:'宋体'">的</span>
                <span style="font-family:'宋体'">授权，</span>
                <span style="font-family:'宋体'">届时</span>
                <span style="font-family:'宋体'">，我们将无法</span>
                <span style="font-family:'宋体'">使用</span>
                <span style="font-family:'宋体'">您的麦克风进行录音</span>
                <span style="font-family:'宋体'">或通话</span>
                <span style="font-family:'宋体'">；</span>
            </p>
            <p style="margin-top:0px; margin-bottom:0px; text-indent:21px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                <span style="font-family:Tahoma">④</span>
                <span style="font:7px 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;</span>
                <span style="font-family:'宋体'">您可以撤回系统中定位权限的授权，届时，我们将无法读取您的精确位置信息</span>
                <span style="font-family:'宋体'">。</span>
            </p>
            <ol start="5" type="1" style="margin:0px; padding-left:0px">
                <li style="margin-right:9.75px; margin-left:34.91px; padding-left:4.09px; font-family:Tahoma; font-size:10.5px; font-weight:bold; background-color:#ffffff">
                    <span style="font-family:'宋体'">5.注销您</span>
                    <span style="font-family:'宋体'">的</span>
                    <span style="font-family:'宋体'">账号</span>
                </li>
            </ol>
            <p style="margin-top:0px; margin-right:9.75px; margin-bottom:0px; text-indent:21px; font-size:10.5px; background-color:#ffffff">
                <span style="font-family:'宋体'">在您</span>
                <span style="font-family:'宋体'">已经结清全部</span>
                <span style="font-family:'宋体'">贷款及</span>
                <span style="font-family:'宋体'">担保费用，</span>
                <span style="font-family:'宋体'">确认不再使用</span>
                <span style="font-family:'宋体'">我们的服务，并且需要</span>
                <span style="font-family:'宋体'">注销</span>
                <span style="font-family:'宋体'">账户时，您可以通过</span>
                <span style="font-family:'宋体'">“我的业务——个人中心——账户注销”功能</span>
                <span style="font-family:'宋体'">向我们提出注销</span>
                <span style="font-family:'宋体'">该公众号中的</span>
                <span style="font-family:'宋体'">账号</span>
                <span style="font-family:'宋体'">的</span>
                <span style="font-family:'宋体'">申请。</span>
            </p>
            <p style="margin-top:0px; margin-right:9.75px; margin-bottom:0px; text-indent:21px; font-size:10.5px; background-color:#ffffff">
                <span style="font-family:'宋体'">在</span>
                <span style="font-family:'宋体'">您账户注销之后，我们将</span>
                <span style="font-family:'宋体'">停止</span>
                <span style="font-family:'宋体'">为您提供产品或服务，并对您的个人信息进行删除或匿名化处理，法律</span>
                <span style="font-family:'宋体'">法规</span>
                <span style="font-family:'宋体'">另有规定的除外。</span>
            </p>
            <ol start="6" type="1" style="margin:0px; padding-left:0px">
                <li style="margin-right:9.75px; margin-left:34.91px; padding-left:4.09px; font-family:Tahoma; font-size:10.5px; font-weight:bold; background-color:#ffffff">
                    <span style="font-family:'宋体'">6.获取</span>
                    <span style="font-family:'宋体'">个人信息副本</span>
                </li>
            </ol>
            <p style="margin-top:0px; margin-right:9.75px; margin-bottom:0px; text-indent:21px; font-size:10.5px; background-color:#ffffff">
                <span style="font-family:'宋体'">您</span>
                <span style="font-family:'宋体'">有权获取您的个人信息副本，</span>
                <span style="font-family:'宋体'">可通过</span>
                <span style="font-family:'宋体'">发送电子邮件</span>
                <span style="font-family:'宋体'">的</span>
                <span style="font-family:'宋体'">方式向我们提出申请。</span>
            </p>
            <p style="margin-top:0px; margin-right:9.75px; margin-bottom:0px; text-indent:21px; font-size:10.5px; background-color:#ffffff">
                <span style="font-family:'宋体'">在</span>
                <span style="font-family:'宋体'">技术可行的情况下，如数据接口</span>
                <span style="font-family:'宋体'">已</span>
                <span style="font-family:'宋体'">匹配，我们还可按照您的要求，直接将您的个人信息副本传输给您指定的第三方。</span>
            </p>
            <ol start="7" type="1" style="margin:0px; padding-left:0px">
                <li style="margin-right:9.75px; margin-left:34.91px; padding-left:4.09px; font-family:Tahoma; font-size:10.5px; font-weight:bold; background-color:#ffffff">
                    <span style="font-family:'宋体'">7.约束信息</span>
                    <span style="font-family:'宋体'">系统自动决策</span>
                </li>
            </ol>
            <p style="margin-top:0px; margin-right:9.75px; margin-bottom:0px; font-size:10.5px; background-color:#ffffff">
                <span style="font-family:'宋体'"></span>
                <span style="font-family:'宋体'">在</span>
                <span style="font-family:'宋体'">某些业务功能中，我们可能仅依据信息系统、算法在内的非人工自动决策机制作出决定</span>
                <span style="font-family:'宋体'">。</span>
                <span style="font-family:'宋体'">如果</span>
                <span style="font-family:'宋体'">这些</span>
                <span style="font-family:'宋体'">决定显著影响您的合法权益，您有权要求我们作出解释，我们也将提供适当的救济方式。</span>
            </p>
            <ol start="8" type="1" style="margin:0px; padding-left:0px">
                <li style="margin-right:9.75px; margin-left:34.91px; padding-left:4.09px; font-family:Tahoma; font-size:10.5px; font-weight:bold; background-color:#ffffff">
                    <span style="font-family:'宋体'">8.举报</span>
                    <span style="font-family:'宋体'">和投诉</span>
                </li>
            </ol>
            <p style="margin-top:0px; margin-right:9.75px; margin-bottom:0px; text-indent:21px; font-size:10.5px; background-color:#ffffff">
                <span style="font-family:'宋体'">如果</span>
                <span style="font-family:'宋体'">您</span>
                <span style="font-family:'宋体'">发现</span>
                <span style="font-family:'宋体'">您的</span>
                <span style="font-family:'宋体'">个人</span>
                <span style="font-family:'宋体'">信息可能被泄露，或者</span>
                <span style="font-family:'宋体'">我们</span>
                <span style="font-family:'宋体'">的工作人员</span>
                <span style="font-family:'宋体'">或</span>
                <span style="font-family:'宋体'">合作伙伴在</span>
                <span style="font-family:'宋体'">处理</span>
                <span style="font-family:'宋体'">您的个人信息</span>
                <span style="font-family:'宋体'">时</span>
                <span style="font-family:'宋体'">有任何</span>
                <span style="font-family:'宋体'">违法</span>
                <span style="font-family:'宋体'">违规行为，您可以通过拨打</span>
                <span style="font-family:'宋体'">客服</span>
                <span style="font-family:'宋体'">热线</span>
                <span style="font-family:'宋体'">或者</span>
                <span style="font-family:'宋体'">发送电子邮件</span>
                <span style="font-family:'宋体'">的</span>
                <span style="font-family:'宋体'">方式向我们进行举报和投诉。</span>
            </p>
            <ol start="9" type="1" style="margin:0px; padding-left:0px">
                <li style="margin-right:9.75px; margin-left:34.91px; padding-left:4.09px; font-family:Tahoma; font-size:10.5px; font-weight:bold; background-color:#ffffff">
                    <span style="font-family:'宋体'">9.响应</span>
                    <span style="font-family:'宋体'">您的上述请求</span>
                </li>
            </ol>
            <p style="margin-top:0px; margin-right:9.75px; margin-bottom:0px; text-indent:21px; font-size:10.5px; background-color:#ffffff">
                <span style="font-family:'宋体'">为了确保</span>
                <span style="font-family:'宋体'">上述请求的提出</span>
                <span style="font-family:'宋体'">系</span>
                <span style="font-family:'宋体'">您本人</span>
                <span style="font-family:'宋体'">操作</span>
                <span style="font-family:'宋体'">，</span>
                <span style="font-family:'宋体'">保障您</span>
                <span style="font-family:'宋体'">的个人信息安全，</span>
                <span style="font-family:'宋体'">我们会对</span>
                <span style="font-family:'宋体'">您</span>
                <span style="font-family:'宋体'">的身份</span>
                <span style="font-family:'宋体'">进行验证（</span>
                <span style="font-family:'宋体'">必要时</span>
                <span style="font-family:'宋体'">可能需要您提供书面请求）</span>
                <span style="font-family:'宋体'">，</span>
                <span style="font-family:'宋体'">在身份验证通过后，再处理您的请求</span>
                <span style="font-family:'宋体'">。</span>
            </p>
            <p style="margin-top:0px; margin-right:9.75px; margin-bottom:0px; text-indent:21px; font-size:10.5px; background-color:#ffffff">
                <span style="font-family:'宋体'">对于您</span>
                <span style="font-family:'宋体'">所提出的上述请求，我们将在</span>
                <span style="font-family:Tahoma">15</span>
                <span style="font-family:'宋体'">个</span>
                <span style="font-family:'宋体'">工作日内核实和处理</span>
                <span style="font-family:'宋体'">。</span>
            </p>
            <p style="margin-top:0px; margin-right:9.75px; margin-bottom:0px; text-indent:21px; font-size:10.5px; background-color:#ffffff">
                <span style="font-family:'宋体'">对于</span>
                <span style="font-family:'宋体'">您合理的请求，我们原则上不收取费用，但对于多次重复、超出合理限度的请求，我们将视情况收取一定的成本费用。对于</span>
                <span style="font-family:'宋体'">那些</span>
                <span style="font-family:'宋体'">无端重复、需要过多技术手段</span>
                <span style="font-family:'宋体'">（例如</span>
                <span style="font-family:'宋体'">，需要开发新系统或从根本上改变现行惯例</span>
                <span style="font-family:'宋体'">）、</span>
                <span style="font-family:'宋体'">给他人合法权益带来风险</span>
                <span style="font-family:'宋体'">或者</span>
                <span style="font-family:'宋体'">非常不切实际（</span>
                <span style="font-family:'宋体'">例如</span>
                <span style="font-family:'宋体'">，涉及</span>
                <span style="font-family:'宋体'">备份</span>
                <span style="font-family:'宋体'">磁带上存放的信息）</span>
                <span style="font-family:'宋体'">的</span>
                <span style="font-family:'宋体'">请求，我们可能会予以拒绝。</span>
            </p>
            <p style="margin-top:0px; margin-right:9.75px; margin-bottom:0px; text-indent:21px; font-size:10.5px; background-color:#ffffff">
                <span style="font-family:'宋体'; font-weight:bold">请您知悉</span>
                <span style="font-family:'宋体'; font-weight:bold">，在以下</span>
                <span style="font-family:'宋体'; font-weight:bold">情形中</span>
                <span style="font-family:'宋体'; font-weight:bold">，我们</span>
                <span style="font-family:'宋体'; font-weight:bold">将</span>
                <span style="font-family:'宋体'; font-weight:bold">无法响应您的请求：</span>
            </p>
            <div style="margin-right:9.75px; margin-left:21px; background-color:#ffffff">
                <p style="margin-top:0px; margin-left:36px; margin-bottom:0px; text-indent:-36px; font-size:10.5px">
                    <span style="font-family:'宋体'">（</span>
                    <span style="font-family:Tahoma">1</span>
                    <span style="font-family:'宋体'">）</span>
                    <span style="font:7px 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;</span>
                    <span style="font-family:'宋体'">与我们</span>
                    <span style="font-family:'宋体'">履行法律法规</span>
                    <span style="font-family:'宋体'">规定的</span>
                    <span style="font-family:'宋体'">义务</span>
                    <span style="font-family:'宋体'">相关</span>
                    <span style="font-family:'宋体'">的</span>
                    <span style="font-family:'宋体'">；</span>
                </p>
            </div>
            <div style="margin-right:9.75px; margin-left:21px; background-color:#ffffff">
                <p style="margin-top:0px; margin-left:36px; margin-bottom:0px; text-indent:-36px; font-size:10.5px">
                    <span style="font-family:'宋体'">（</span>
                    <span style="font-family:Tahoma">2</span>
                    <span style="font-family:'宋体'">）</span>
                    <span style="font:7px 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;</span>
                    <span style="font-family:'宋体'">与</span>
                    <span style="font-family:'宋体'">国家安全、国防安全直接相关的；</span>
                </p>
            </div>
            <div style="margin-right:9.75px; margin-left:21px; background-color:#ffffff">
                <p style="margin-top:0px; margin-left:36px; margin-bottom:0px; text-indent:-36px; font-size:10.5px">
                    <span style="font-family:'宋体'">（</span>
                    <span style="font-family:Tahoma">3</span>
                    <span style="font-family:'宋体'">）</span>
                    <span style="font:7px 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;</span>
                    <span style="font-family:'宋体'">与公共</span>
                    <span style="font-family:'宋体'">安全、公共卫生、重大公共利益直接相关的；</span>
                </p>
            </div>
            <div style="margin-right:9.75px; margin-left:21px; background-color:#ffffff">
                <p style="margin-top:0px; margin-left:36px; margin-bottom:0px; text-indent:-36px; font-size:10.5px">
                    <span style="font-family:'宋体'">（</span>
                    <span style="font-family:Tahoma">4</span>
                    <span style="font-family:'宋体'">）</span>
                    <span style="font:7px 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;</span>
                    <span style="font-family:'宋体'">与</span>
                    <span style="font-family:'宋体'">刑事侦查</span>
                    <span style="font-family:'宋体'">、</span>
                    <span style="font-family:'宋体'">起诉、</span>
                    <span style="font-family:'宋体'">司法</span>
                    <span style="font-family:'宋体'">调查、审判和执行判决等直接相关的；</span>
                </p>
            </div>
            <div style="margin-right:9.75px; margin-left:21px; background-color:#ffffff">
                <p style="margin-top:0px; margin-left:36px; margin-bottom:0px; text-indent:-36px; font-size:10.5px">
                    <span style="font-family:'宋体'">（</span>
                    <span style="font-family:Tahoma">5</span>
                    <span style="font-family:'宋体'">）</span>
                    <span style="font:7px 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;</span>
                    <span style="font-family:'宋体'">有充分</span>
                    <span style="font-family:'宋体'">证据</span>
                    <span style="font-family:'宋体'">表明</span>
                    <span style="font-family:'宋体'">您</span>
                    <span style="font-family:'宋体'">存在</span>
                    <span style="font-family:'宋体'">主观恶意或滥用</span>
                    <span style="font-family:'宋体'">权利</span>
                    <span style="font-family:'宋体'">的；</span>
                </p>
            </div>
            <p style="margin-top:0px; margin-right:9.75px; margin-bottom:0px; text-indent:21px; font-size:10.5px; background-color:#ffffff">
                <span style="font-family:'宋体'">（</span>
                <span style="font-family:Tahoma">6</span>
                <span style="font-family:'宋体'">）</span>
                <span style="font:7px 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;</span>
                <span style="font-family:'宋体'">出于</span>
                <span style="font-family:'宋体'">维护您或者其他个人的</span>
                <span style="font-family:'宋体'">生命</span>
                <span style="font-family:'宋体'">、财产等重大合法权益但</span>
                <span style="font-family:'宋体'">又</span>
                <span style="font-family:'宋体'">很难得到本人同意的；</span>
            </p>
            <div style="margin-right:9.75px; margin-left:21px; background-color:#ffffff">
                <p style="margin-top:0px; margin-left:36px; margin-bottom:0px; text-indent:-36px; font-size:10.5px">
                    <span style="font-family:'宋体'">（</span>
                    <span style="font-family:Tahoma">7</span>
                    <span style="font-family:'宋体'">）</span>
                    <span style="font:7px 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;</span>
                    <span style="font-family:'宋体'">响应</span>
                    <span style="font-family:'宋体'">您的请求将导致</span>
                    <span style="font-family:'宋体'">您或者</span>
                    <span style="font-family:'宋体'">其他个人、组织的合法权益收到严重损害的；</span>
                </p>
            </div>
            <div style="margin-right:9.75px; margin-left:21px; background-color:#ffffff">
                <p style="margin-top:0px; margin-left:36px; margin-bottom:0px; text-indent:-36px; font-size:10.5px">
                    <span style="font-family:'宋体'">（</span>
                    <span style="font-family:Tahoma">8</span>
                    <span style="font-family:'宋体'">）</span>
                    <span style="font:7px 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;</span>
                    <span style="font-family:'宋体'">涉及</span>
                    <span style="font-family:'宋体'">商业秘密的。</span>
                </p>
            </div>
            <p style="margin:0px 9.75px 0px 57px; font-size:10.5px; background-color:#ffffff">
                <span style="font-family:Tahoma">&#xa0;</span>
            </p>
            <div style="margin-right:9.75px; background-color:#ffffff">
                <p style="margin-top:0px; margin-left:21px; margin-bottom:0px; text-indent:-21px; font-size:10.5px">
                    <span style="font-family:'宋体'; font-weight:bold">九、</span>
                    <span style="font-family:'宋体'; font-weight:bold">我们</span>
                    <span style="font-family:'宋体'; font-weight:bold">如何处理</span>
                    <span style="font-family:'宋体'; font-weight:bold">未成年人</span>
                    <span style="font-family:'宋体'; font-weight:bold">的个人信息</span>
                </p>
            </div>
            <p style="margin-top:0px; margin-bottom:0px; text-indent:21px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                <span style="font-family:'宋体'">我们</span>
                <span style="font-family:'宋体'">非常重视未成年人的个人信息保护</span>
                <span style="font-family:'宋体'">，</span>
                <span style="font-family:'宋体'">我们的</span>
                <span style="font-family:'宋体'">产品和</span>
                <span style="font-family:'宋体'">服务均</span>
                <span style="font-family:'宋体'">面向</span>
                <span style="font-family:'宋体'">成年人，不以未成年人为目标客户。我们</span>
                <span style="font-family:'宋体'">不会</span>
                <span style="font-family:'宋体'">故意收集任何未成年人的个人信息，除非您主动提供</span>
                <span style="font-family:'宋体'">的</span>
                <span style="font-family:'宋体'">某些信息中不可避免的包含了某些未成年人</span>
                <span style="font-family:'宋体'">的</span>
                <span style="font-family:'宋体'">信息（</span>
                <span style="font-family:'宋体'">比如</span>
                <span style="font-family:'宋体'">您提供的房产信息</span>
                <span style="font-family:'宋体'">可能</span>
                <span style="font-family:'宋体'">包含未成年人</span>
                <span style="font-family:'宋体'">的</span>
                <span style="font-family:'宋体'">姓名、身份证号</span>
                <span style="font-family:'宋体'">和</span>
                <span style="font-family:'宋体'">房产份额信息）</span>
                <span style="font-family:'宋体'">。</span>
            </p>
            <p style="margin-top:0px; margin-bottom:0px; text-indent:21.1px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                <span style="font-family:'宋体'; font-weight:bold; text-decoration:underline">如果您</span>
                <span style="font-family:'宋体'; font-weight:bold; text-decoration:underline">是未成年人，请不要尝试注册大数</span>
                <span style="font-family:'宋体'; font-weight:bold; text-decoration:underline">合作</span>
                <span style="font-family:'宋体'; font-weight:bold; text-decoration:underline">平台，</span>
                <span style="font-family:'宋体'; font-weight:bold; text-decoration:underline">也不要</span>
                <span style="font-family:'宋体'; font-weight:bold; text-decoration:underline">以任何方式向我们提供您的任何个人信息。</span>
            </p>
            <p style="margin-top:0px; margin-bottom:0px; text-indent:21px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                <span style="font-family:'宋体'">如果</span>
                <span style="font-family:'宋体'">我们发现自己在未</span>
                <span style="font-family:'宋体'">事先</span>
                <span style="font-family:'宋体'">获得可证实的</span>
                <span style="font-family:'宋体'">父母同意</span>
                <span style="font-family:'宋体'">的情况下收集了</span>
                <span style="font-family:'宋体'">任何</span>
                <span style="font-family:'宋体'">未成年人</span>
                <span style="font-family:'宋体'">的</span>
                <span style="font-family:'宋体'">个人</span>
                <span style="font-family:'宋体'">信息</span>
                <span style="font-family:'宋体'">，我们会设法尽快删除</span>
                <span style="font-family:'宋体'">该等</span>
                <span style="font-family:'宋体'">信息。</span>
            </p>
            <p style="margin-top:0px; margin-bottom:0px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                <span style="font-family:Tahoma">&#xa0;</span>
            </p>
            <div style="margin-right:9.75px; background-color:#ffffff">
                <p style="margin-top:0px; margin-left:21px; margin-bottom:0px; text-indent:-21px; font-size:10.5px">
                    <span style="font-family:'宋体'; font-weight:bold">十、</span>
                    <span style="font-family:'宋体'; font-weight:bold">本政策</span>
                    <span style="font-family:'宋体'; font-weight:bold">如何更新</span>
                </p>
            </div>
            <p style="margin:0px 9.75px 0px 21px; font-size:10.5px; background-color:#ffffff">
                <span style="font-family:'宋体'">我们</span>
                <span style="font-family:'宋体'">的</span>
                <span style="font-family:'宋体'">个人</span>
                <span style="font-family:'宋体'">信息保护政策可能变更。</span>
            </p>
            <p style="margin-top:0px; margin-right:9.75px; margin-bottom:0px; text-indent:21px; font-size:10.5px; background-color:#ffffff">
                <span style="font-family:'宋体'">未经您</span>
                <span style="font-family:'宋体'">明确同意，我们不会削减您</span>
                <span style="font-family:'宋体'">在</span>
                <span style="font-family:'宋体'">本政策项下应享有的权利。</span>
                <span style="font-family:'宋体'">我们</span>
                <span style="font-family:'宋体'">会在本页面上发布对本政策所作的任何变更</span>
                <span style="font-family:'宋体'">。</span>
            </p>
            <p style="margin-top:0px; margin-right:9.75px; margin-bottom:0px; text-indent:21px; font-size:10.5px; background-color:#ffffff">
                <span style="font-family:'宋体'">对于</span>
                <span style="font-family:'宋体'">重大变更</span>
                <span style="font-family:'宋体'">，</span>
                <span style="font-family:'宋体'">我们还会提供更为显著的</span>
                <span style="font-family:'宋体'">通知</span>
                <span style="font-family:'宋体'">（</span>
                <span style="font-family:'宋体'">比如官方</span>
                <span style="font-family:'宋体'">公告</span>
                <span style="font-family:'宋体'">、</span>
                <span style="font-family:'宋体'">推送通知、</span>
                <span style="font-family:'宋体'">发送</span>
                <span style="font-family:'宋体'">短信或者电子邮件）</span>
                <span style="font-family:'宋体'">，并</span>
                <span style="font-family:'宋体'">在本政策更新后您首次登陆</span>
                <span style="font-family:'宋体'">时</span>
                <span style="font-family:'宋体'">再次获取您的明示同意</span>
                <span style="font-family:'宋体'">。</span>
                <span style="font-family:'宋体'; font-weight:bold">若您在本政策</span>
                <span style="font-family:'宋体'; font-weight:bold">更新</span>
                <span style="font-family:'宋体'; font-weight:bold">且接到我们的通知后，点击</span>
                <span style="font-family:'宋体'; font-weight:bold">同意</span>
                <span style="font-family:'宋体'; font-weight:bold">或下一步，这表示您已充分阅读、理解并接受修订后的本政策</span>
                <span style="font-family:'宋体'">。</span>
            </p>
            <p style="margin-top:0px; margin-right:9.75px; margin-bottom:0px; text-indent:21px; font-size:10.5px; background-color:#ffffff">
                <span style="font-family:'宋体'">本政策</span>
                <span style="font-family:'宋体'">所指的重大变更包括但不限于：</span>
            </p>
            <ol type="1" style="margin:0px; padding-left:0px">
                <li style="margin-right:9.75px; margin-left:34.91px; padding-left:4.09px; font-family:Tahoma; font-size:10.5px; background-color:#ffffff">
                    <span style="font-family:'宋体'">1.我们</span>
                    <span style="font-family:'宋体'">的服务模式发生重大变化，比如处理个人信息的</span>
                    <span style="font-family:'宋体'">类型</span>
                    <span style="font-family:'宋体'">、目的和方式</span>
                    <span style="font-family:'宋体'">等；</span>
                </li>
                <li style="margin-right:9.75px; text-indent:26px; font-family:Tahoma; font-size:10.5px; background-color:#ffffff; list-style-position:inside; -aw-list-padding-sml:7.09px">
                    <span style="font:7px 'Times New Roman'; -aw-list-padding-sml:7.09px">&#xa0;&#xa0;&#xa0;&#xa0;</span>
                    <span style="font-family:'宋体'">2.我们</span>
                    <span style="font-family:'宋体'">在所有权结构、组织架构等方面发生重大变化，比如业务调整、</span>
                    <span style="font-family:'宋体'">并购</span>
                    <span style="font-family:'宋体'">、破产等引起的所有者变更等</span>
                    <span style="font-family:'宋体'">；</span>
                </li>
                <li style="margin-right:9.75px; margin-left:34.91px; padding-left:4.09px; font-family:Tahoma; font-size:10.5px; background-color:#ffffff">
                    <span style="font-family:'宋体'">3.个人</span>
                    <span style="font-family:'宋体'">信息共享、转让或者公开披露的主要对象发生变化；</span>
                </li>
                <li style="margin-right:9.75px; margin-left:34.91px; padding-left:4.09px; font-family:Tahoma; font-size:10.5px; background-color:#ffffff">
                    <span style="font-family:'宋体'">4.您</span>
                    <span style="font-family:'宋体'">参与个人信息处理方面的权利</span>
                    <span style="font-family:'宋体'">及其行使</span>
                    <span style="font-family:'宋体'">方式发生重大变化；</span>
                </li>
                <li style="margin-right:9.75px; margin-left:34.91px; padding-left:4.09px; font-family:Tahoma; font-size:10.5px; background-color:#ffffff">
                    <span style="font-family:'宋体'">5.我们</span>
                    <span style="font-family:'宋体'">负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时；</span>
                </li>
                <li style="margin-right:9.75px; margin-left:34.91px; padding-left:4.09px; font-family:Tahoma; font-size:10.5px; background-color:#ffffff">
                    <span style="font-family:'宋体'">6.个人</span>
                    <span style="font-family:'宋体'">信息安全影响评估</span>
                    <span style="font-family:'宋体'">报告</span>
                    <span style="font-family:'宋体'">表明存在高</span>
                    <span style="font-family:'宋体'">风险</span>
                    <span style="font-family:'宋体'">时。</span>
                </li>
            </ol>
            <p style="margin:0px 9.75px 0px 21px; font-size:10.5px; background-color:#ffffff">
                <span style="font-family:'宋体'">我们</span>
                <span style="font-family:'宋体'">还会将本政策的旧版本存档，供您查阅。</span>
            </p>
            <p style="margin-top:0px; margin-right:9.75px; margin-bottom:0px; font-size:10.5px; background-color:#ffffff">
                <span style="font-family:Tahoma">&#xa0;</span>
            </p>
            <div style="margin-right:9.75px; background-color:#ffffff">
                <p style="margin-top:0px; margin-left:21px; margin-bottom:0px; text-indent:-21px; font-size:10.5px">
                    <span style="font-family:'宋体'; font-weight:bold">十一、</span>
                    <span style="font:7px 'Times New Roman'">&#xa0;&#xa0;</span>
                    <span style="font-family:'宋体'; font-weight:bold">如何</span>
                    <span style="font-family:'宋体'; font-weight:bold">联系我们</span>
                </p>
            </div>
            <ol type="1" style="margin:0px; padding-left:0px">
                <li style="text-indent:21px; text-align:justify; widows:0; orphans:0; font-family:Calibri; font-size:10.5px; list-style-position:inside; -aw-list-padding-sml:8.03px">
                    <span style="font:7px 'Times New Roman'; -aw-list-padding-sml:8.03px">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;</span>
                    <span style="font-family:'宋体'">1.我们</span>
                    <span style="font-family:'宋体'">设立</span>
                    <span style="font-family:'宋体'">了</span>
                    <span style="font-family:'宋体'">专门的个人信息保护部门</span>
                    <span>——</span>
                    <span style="font-family:'宋体'">网络</span>
                    <span style="font-family:'宋体'">安全和</span>
                    <span style="font-family:'宋体'">个人</span>
                    <span style="font-family:'宋体'">信息保护小组</span>
                    <span style="font-family:'宋体'">，如果您</span>
                    <span style="font-family:'宋体'">对</span>
                    <span style="font-family:'宋体'">本政策</span>
                    <span style="font-family:'宋体'">有任何疑问、意见或建议，可通过</span>
                    <span style="font-family:'宋体'">以下方式</span>
                    <span style="font-family:'宋体'">与</span>
                    <span style="font-family:'宋体'">我们</span>
                    <span style="font-family:'宋体'">联系：</span>
                </li>
            </ol>
            <p style="margin-top:0px; margin-left:57px; margin-bottom:0px; text-indent:-36px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                <span style="font-family:'宋体'">（</span>
                <span style="font-family:Calibri">1</span>
                <span style="font-family:'宋体'">）</span>
                <span style="font:7px 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;</span>
                <span style="font-family:'宋体'">拨打客服</span>
                <span style="font-family:'宋体'">热线电话</span>
                <span style="font-family:Tahoma;font-weight:bold">400-081-9969</span>
                <span style="font-family:'宋体'">；</span>
            </p>
            <p style="margin-top:0px; margin-left:57px; margin-bottom:0px; text-indent:-36px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                <span style="font-family:'宋体'">（</span>
                <span style="font-family:Calibri">2</span>
                <span style="font-family:'宋体'">）</span>
                <span style="font:7px 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;</span>
                <span style="font-family:'宋体'">发送电子邮件</span>
                <span style="font-family:'宋体'">至【</span>
                <span style="font-family:Calibri;font-weight:bold">privacy@dashuf.com</span>
                <span style="font-family:'宋体'">】</span>
                <span style="font-family:'宋体'">；</span>
            </p>
            <p style="margin-top:0px; margin-bottom:0px; text-indent:21px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                <span style="font-family:'宋体'">（</span>
                <span style="font-family:Calibri">3</span>
                <span style="font-family:'宋体'">）</span>
                <span style="font:7px 'Times New Roman'">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;</span>
                <span style="font-family:'宋体'">邮寄地址</span>
                <span style="font-family:'宋体'">：</span>
                <span style="font-family:'宋体'">深圳市前海深港合作区南山街道自贸西街</span>
                <span style="font-family:Calibri; font-weight:bold">18</span>
                <span style="font-family:'宋体'">号前海香缤大厦</span>
                <span style="font-family:Calibri; font-weight:bold">7</span>
                <span style="font-family:'宋体'">层，收件人</span>
                <span style="font-family:'宋体'">：【</span>
                <span style="font-family:'宋体'">网络安全和个人</span>
                <span style="font-family:'宋体'">信息保护小组】</span>
            </p>
            <p style="margin-top:0px; margin-bottom:0px; text-indent:21px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                <span style="font-family:'宋体'">我们</span>
                <span style="font-family:'宋体'">的客服部门将</span>
                <span style="font-family:'宋体'">会同</span>
                <span style="font-family:'宋体'">个人信息保护部门</span>
                <span style="font-family:Calibri; font-weight:bold">30</span>
                <span style="font-family:'宋体'">天</span>
                <span style="font-family:'宋体'">内进行回复</span>
                <span style="font-family:'宋体'">，</span>
                <span style="font-family:'宋体'">并协助解决您的问题。</span>
            </p>
            <ol start="2" type="1" style="margin:0px; padding-left:0px">
                <li style="text-indent:21px; text-align:justify; widows:0; orphans:0; font-family:Calibri; font-size:10.5px; list-style-position:inside; -aw-list-padding-sml:8.03px">
                    <span style="font:7px 'Times New Roman'; -aw-list-padding-sml:8.03px">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;</span>
                    <span style="font-family:'宋体'">2.如果</span>
                    <span style="font-family:'宋体'">您对我们的回复不满意，特别是我们的个人</span>
                    <span style="font-family:'宋体'">信息</span>
                    <span style="font-family:'宋体'">处理行为损害了您的合法权益，您还可以通过</span>
                    <span style="font-family:'宋体'">以下外部</span>
                    <span style="font-family:'宋体'">途径</span>
                    <span style="font-family:'宋体'">寻求</span>
                    <span style="font-family:'宋体'">解决方式：</span>
                    <span style="font-family:'宋体'">向</span>
                    <span style="font-family:'宋体'">深圳市大数融资担保</span>
                    <span style="font-family:'宋体'">有限公司所在地</span>
                    <span style="font-family:'宋体'">人民法院提起诉讼，或向网信、</span>
                    <span style="font-family:'宋体'">工商</span>
                    <span style="font-family:'宋体'">、公安等监管部门进行投诉或举报。</span>
                </li>
            </ol>
            <p style="margin-top:0px; margin-bottom:0px; font-size:10.5px">
                <br style="page-break-before:always; clear:both"/>
            </p>
            <ol start="3" type="1" style="margin:0px; padding-left:0px">
                <li style="text-indent:21px; text-align:justify; widows:0; orphans:0; font-family:Calibri; font-size:10.5px; list-style-position:inside; -aw-list-padding-sml:8.03px">
                    <span style="font:7px 'Times New Roman'; -aw-list-padding-sml:8.03px">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;</span>
                    <span>&#xa0;</span>
                </li>
            </ol>
            <h1 style="margin-top:14px; margin-bottom:14px; text-align:center; widows:0; orphans:0">
                <span style="font-family:'宋体'">E</span>
                <span style="font-family:'宋体'">数</span>
                <span style="font-family:'宋体'">通注册及服务协议</span>
            </h1>
            <p style="margin-top:14px; margin-bottom:14px; font-size:10px">
                <span style="font-family:'宋体'">欢迎您与深圳大数信科技术有限公司（简称“大数信科”）订立</span>
                <span style="font-family:'宋体'">本服务</span>
                <span style="font-family:'宋体'">协议（简称“本协议”）并</span>
                <span style="font-family:'宋体'">注册成为“E数通”会员</span>
                <span style="font-family:'宋体'">，并使用大数信科基于网络提供的技术服务（简称“本服务”）实现您的个人经营或消费贷款需求。</span>
            </p>
            <p style="margin-top:14px; margin-bottom:14px; font-size:10px">
                <span style="font-family:'宋体'; font-weight:bold">大数信</span>
                <span style="font-family:'宋体'; font-weight:bold">科</span>
                <span style="font-family:'宋体'; font-weight:bold">在此</span>
                <span style="font-family:'宋体'; font-weight:bold">特别提醒您：</span>
            </p>
            <p style="margin-top:14px; margin-bottom:14px; font-size:10px">
                <span style="font-family:'宋体'; font-weight:bold">在您决定成为会员前，请仔细阅读并完全理解本的全部内容，尤其是下文第四条的用户保证承诺、第九条的风险提示、第十二条的免责声明。您必须在接受本协议所包含的条款、条件和即时刊登的通告，并且遵守有关互联网及/或的相关法律、规定与规则的前提下，才能进入会员注册程序。您只有成功注册成为</span>
                <span style="font-family:'宋体'; font-weight:bold">E</span>
                <span style="font-family:'宋体'; font-weight:bold">数通会员</span>
                <span style="font-family:'宋体'; font-weight:bold">，才能使用我们提供的会员服务。如您不同意本协议的任意内容，请勿注册或使用</span>
                <span style="font-family:'宋体'; font-weight:bold">本</span>
                <span style="font-family:'宋体'; font-weight:bold">服务。如您通过进入注册程序</span>
                <span style="font-family:'宋体'; font-weight:bold">并勾选</span>
                <span style="font-family:'宋体'; font-weight:bold">"我同意"，即表示您与</span>
                <span style="font-family:'宋体'; font-weight:bold">深圳大数信科技术有限公司</span>
                <span style="font-family:'宋体'; font-weight:bold">已达成协议，自愿接受本协议的所有内容。此后，您不得以未阅读本协议内容作任何形式的抗辩。</span>
            </p>
            <h2 style="margin-top:10.5px; margin-bottom:10.5px">
                <span style="font-family:'宋体'; color:#353543">定义</span>
            </h2>
            <p style="margin-top:5px; margin-bottom:5px; line-height:21px">
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">1</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">大数信科：</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">指</span>
                <span style="font-family:'宋体'; font-size:10px">深圳大数信科技术有限公司及</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">大数信科</span>
                <span style="font-family:'宋体'; font-size:10px">关联方。</span>
            </p>
            <p style="margin-top:5px; margin-bottom:5px; line-height:21px">
                <span style="font-family:'宋体'; font-size:10px">2</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">大数信科</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">关联方</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">：深圳大数信科技术有限公司/深圳市大数融资担保有限公司/</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">武汉融生融资</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">担保有限公司</span>
            </p>
            <p style="margin-top:5px; margin-bottom:5px; line-height:21px">
                <span style="font-family:'宋体'; font-size:10px">3</span>
                <span style="font-family:'宋体'; font-size:10px"></span>
                <span style="font-family:'宋体'; font-size:10px">您、用户：指持有中国大陆身份证的（不包括中国香港、澳门及台湾地区）、年龄在18周岁以上且具有完全民事行为能力，通过</span>
                <span style="font-family:'宋体'; font-size:10px">本服务</span>
                <span style="font-family:'宋体'; font-size:10px">向贷款人提出借款申请，接受贷款人评估，独立承担还款义务与责任的自然人。</span>
            </p>
            <p style="margin-top:5px; margin-bottom:5px; line-height:21px">
                <span style="font-family:'宋体'; font-size:10px">4</span>
                <span style="font-family:'宋体'; font-size:10px"></span>
                <span style="font-family:'宋体'; font-size:10px">贷款人：指接受您的贷款申请，</span>
                <span style="font-family:'宋体'; font-size:10px">评估您</span>
                <span style="font-family:'宋体'; font-size:10px">的借款需求、风险和额度，与您订立贷款合同及向您提供贷款资金</span>
                <span style="font-family:'宋体'; font-size:10px">的适格放款</span>
                <span style="font-family:'宋体'; font-size:10px">主体。您同意</span>
                <span style="font-family:'宋体'; font-size:10px">本服务</span>
                <span style="font-family:'宋体'; font-size:10px">项下最终的贷款人可能为一家机构，也可能为多家机构。</span>
            </p>
            <p style="margin-top:5px; margin-bottom:5px; line-height:21px">
                <span style="font-family:'宋体'; font-size:10px">5 </span>
                <span style="font-family:'宋体'; font-size:10px">本服务：指大数信科作为服务方通过平台向您提供的个人消费/经营贷款产品项下页面</span>
                <span style="font-family:'宋体'; font-size:10px">展示及申贷</span>
                <span style="font-family:'宋体'; font-size:10px">、还款指令传递等金融技术服务。</span>
            </p>
            <p style="margin-top:5px; margin-bottom:5px; line-height:21px">
                <span style="font-family:'宋体'; font-size:10px">6 </span>
                <span style="font-family:'宋体'; font-size:10px">账户： 指您以自身名义申请注册的，用以接受</span>
                <span style="font-family:'宋体'; font-size:10px">本服务</span>
                <span style="font-family:'宋体'; font-size:10px">的注册账户。</span>
            </p>
            <p style="margin-top:5px; margin-bottom:5px; line-height:21px">
                <span style="font-family:'宋体'; font-size:10px">7 </span>
                <span style="font-family:'宋体'; font-size:10px">用户指令： 指用户以数据电文形式向大数信科和/或贷款人发出的意思表示，包括但不限于要求申请或取消服务的要求、承诺、请求或确认等。除非另有约定，</span>
                <span style="font-family:'宋体'; font-size:10px">您发出</span>
                <span style="font-family:'宋体'; font-size:10px">的所有指令及其内容一经</span>
                <span style="font-family:'宋体'; font-size:10px">作出</span>
                <span style="font-family:'宋体'; font-size:10px">即不可撤销或变更。</span>
            </p>
            <h2 style="margin-top:10.5px; margin-bottom:10.5px">
                <span style="font-family:'宋体'; color:#353543">第一条 服务确认和接纳</span>
            </h2>
            <p style="margin-top:5px; margin-bottom:5px; line-height:21px">
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">1.1 您一经</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">勾选同意</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">本协议并按照规定的会员注册程序开始注册，即表示您已充分阅读、理解并同意接受本协议的条款和条件，并自愿签署了本协议，本协议即在您和</span>
                <span style="font-family:'宋体'; font-size:10px">深圳大数信科技术有限公司</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">之间产生法律效力。</span>
            </p>
            <p style="margin-top:5px; margin-bottom:5px; line-height:21px">
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">1.2 本协议内容包括本协议全部条款及已经发布的或将来可能发布的各类规则、通告。所有规则、通告为本协议不可分割的一部分,与本协议正文具有同等法律效力。</span>
            </p>
            <p style="margin-top:5px; margin-bottom:5px; line-height:21px">
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">1.3 您一经注册即视为您同意在将来任何时刻有权根据公司业务需求、互联网的发展或中华人民共和国有关法律、法规的变化，不时地制定、修改会员服务条款或平台各类规则,并在</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">大数信科</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">平台上予以公布。经修订后的协议、规则一经公布，立即自动生效。会员的权利以及义务的表述，均以最新的服务条款为准。</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">大数信科</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">特别提醒您，应不时地关注本协议及附属规则的变更。若您在相关协议、规则内容公告变更后继续使用</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">本服务</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">的，表示您已充分阅读、理解并接受修改后的协议、规则；若您不同意相关变更, 您可以立即停止使用本服务。同时有权不经任何告知终止、中止本协议或者</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">限制您</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">进入的全部或者部分板块且不承担任何法律责任。但该终止、中止或限制行为并不能豁免您在已经进行的交易项下所应承担的义务。</span>
            </p>
            <p style="margin-top:5px; margin-bottom:5px; line-height:21px">
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">1.5当您使用</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">E</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">数通</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">服务</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">时，您的使用行为视为您对该单项服务的协议以及</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">大数信科</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">在该单项服务中发出的各类公告及/或规则的同意。</span>
            </p>
            <h2 style="margin-top:10.5px; margin-bottom:10.5px">
                <span style="font-family:'宋体'; color:#353543">第二条 服务内容</span>
            </h2>
            <p style="margin-top:5px; margin-bottom:5px; line-height:21px">
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">2.1</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">基于贷款产品的情况，向您提供相关信息展示的服务。为此大数信科将通过</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">本服务</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">页面向您展示必要的贷款产品信息，使您了解贷款产品和您的贷款情况；</span>
            </p>
            <p style="margin-top:5px; margin-bottom:5px; line-height:21px">
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">2.2基于您的申请，向贷款人及提供金融服务所必需的</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">其他第三</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">方机构</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">传递您</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">的贷款申请、身份验证信息、信用信息等，以便贷款人</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">评估您</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">的信用以及第三方机构提供服务，并将贷款人和第三方机构反馈的信息传递给您。</span>
            </p>
            <p style="margin-top:5px; margin-bottom:5px; line-height:21px">
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">2.3 </span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">基于您的贷款情况，通过本协议约定的通知方式向您提示资金到账、到期还款、运营活动等相关信息，以便您及时、便利地使用贷款服务。上述通知提醒以实际送达的为准。</span>
            </p>
            <p style="margin-top:5px; margin-bottom:5px; line-height:21px">
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">2.</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">4</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">为了提高服务质量和用户体验，大数信科作为技术服务提供方将负责数据分发,协助您与贷款人之间签署并保留贷款合同等法律文件，接受您的贷款咨询与投诉，协助贷款人做好贷后管理。</span>
            </p>
            <p style="margin-top:5px; margin-bottom:5px; line-height:21px">
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">2.</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">5</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">您在任</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">一</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">移动终端上首次使用</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">本服务</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">申请贷款时，在进行身份验证时，贷款人或银行或支付机构将向您在银行预留的手机号发送验证码进行身份验证。</span>
            </p>
            <p style="margin-top:5px; margin-bottom:5px; line-height:21px">
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">2</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">.</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">6</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">大数信科在任何时候均有权</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">验证您</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">的相关信息，并据此</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">评估您</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">的信用状况。大数信科有权基于自主判断拒绝向您提供</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">本服务</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">或拒绝您使用平台服务。</span>
            </p>
            <p style="margin-top:5px; margin-bottom:5px; line-height:21px">
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">2</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">.</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">7</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">用户通过使用嵌入E</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">数通服务</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">的平台及应用程序等多种渠道，均可访问并使用平台提供的信息及金融服务。大数信科有权不时调整</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">本服务</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">的营销名称及访问渠道。</span>
            </p>
            <p style="margin-top:5px; margin-bottom:5px; line-height:21px">
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">2.8 </span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">大数信科</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">保留在无须发出书面通知，仅在平台公示的情况下暂时或永久地更改或停止部分服务的权利。</span>
            </p>
            <h2 style="margin-top:10.5px; margin-bottom:10.5px">
                <span style="font-family:'宋体'; color:#353543">第三条 服务费用</span>
            </h2>
            <p style="margin-top:5px; margin-bottom:5px; line-height:21px">
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">3.1 当您使用</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">E</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">数通</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">服务</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">时，</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">大数信科暂</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">不向您收取相关服务费用。各项服务收费以您使用服务时平台上所公示之收费方式说明或双方另行签订的协议为准。</span>
                <span style="font-family:'宋体'; font-size:10.5px; font-weight:bold; color:#353543">大数信科</span>
                <span style="font-family:'宋体'; font-size:10.5px; font-weight:bold; color:#353543">保留单方面订定及调整服务收费的权利。</span>
                <span style="font-family:'宋体'; font-size:10.5px; font-weight:bold; color:#353543">如后续为了正常运营需要向您收取费用，将采用在</span>
                <span style="font-family:'宋体'; font-size:10.5px; font-weight:bold; color:#353543">本服务</span>
                <span style="font-family:'宋体'; font-size:10.5px; font-weight:bold; color:#353543">页面公告的方式向您告知，届时您可选择是否使用本服务；如您届时选择不再使用本服务，贷款人可能会要求您提前结清贷款。</span>
            </p>
            <p style="margin-top:5px; margin-bottom:5px; line-height:21px">
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">3.2 您在使用服务过程中可能需要向第三方（如银行或第三方支付公司等）支付一定的费用，具体收费标准详见第三方平台相关页面或平台的提示。您使用服务过程中进行的代收、代付指令传递及取现等服务涉及</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">大数信科</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">与银行、第三方支付机构等第三方的合作。</span>
                <span style="font-family:'宋体'; font-size:10.5px; font-weight:bold; color:#353543">您了解并同意，</span>
                <span style="font-family:'宋体'; font-size:10.5px; font-weight:bold; color:#353543">大数信科</span>
                <span style="font-family:'宋体'; font-size:10.5px; font-weight:bold; color:#353543">并不是银行或支付机构，不提供前述服务，不对前述服务的成功做任何承诺，也不承担与此相关的责任，您与第三方之间就费用支付等事项产生的争议或纠纷，与</span>
                <span style="font-family:'宋体'; font-size:10.5px; font-weight:bold; color:#353543">大数信科</span>
                <span style="font-family:'宋体'; font-size:10.5px; font-weight:bold; color:#353543">无关。</span>
            </p>
            <p style="margin-top:5px; margin-bottom:5px; line-height:21px">
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">3.3 您在</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">E</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">数通</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">进行</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">交易而与其他方签订协议的，其他方有权按照协议的约定向您收取相关费用。</span>
            </p>
            <p style="margin-top:5px; margin-bottom:5px; line-height:21px">
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">3.4 您因进行交易而发生的所有应纳税赋，以及相关硬件、软件、通讯、网络服务及其他方面的费用均由您自行承担。</span>
            </p>
            <h2 style="margin-top:10.5px; margin-bottom:10.5px">
                <span style="font-family:'宋体'; color:#353543">第四条 用户保证与承诺</span>
            </h2>
            <p style="margin-top:5px; margin-bottom:5px; line-height:21px">
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">4.1 保证严格遵守中国现行法律、法规、政府规章及其他应该遵守的规范性文件，不在</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">E</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">数通</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">从事</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">危害国家安全、洗钱、套现、传销等任何违法活动或者其他有违社会公共利益或公共道德的行为。</span>
            </p>
            <p style="margin-top:5px; margin-bottom:5px; line-height:21px">
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">4.2保证合法使用</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">大数信科</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">提供的资讯或服务，遵守所有与</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">大数信</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">科</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">服务</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">有关的协议、规则和程序</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">，</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">清楚了解互联网产品</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">，特别是个人消费贷款产品的使用方法和使用惯例，认可数据电文形式的合同效力。</span>
            </p>
            <p style="margin-top:5px; margin-bottom:5px; line-height:21px">
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">4.3未经</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">大数信科</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">事先书面授权，不使用任何非法手段擅自进入</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">大数信科</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">的未公开系统。保证不冒用、盗用或以其他未经授权方式使用他人资料进行注册或者冒用、盗用他人名义使用</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">E</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">数通</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">服务</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">。</span>
            </p>
            <p style="margin-top:5px; margin-bottom:5px; line-height:21px">
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">4.4 保证拥有合法的权利和资格在</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">大数信</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">科</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">发布</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">交易信息并进行交易，且保证前述行为</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">不</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">侵害任何第三方合法权益；保证自己的行为不会导致</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">大数信科</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">遭受任何第三方提起的索赔、诉讼或行政责任；保证若因自己的行为导致</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">大数信科</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">遭受任何第三方提起的索赔、诉讼或行政责任时自己将无条件先行承担相应责任并使</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">大数信科</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">免责。</span>
            </p>
            <p style="margin-top:5px; margin-bottom:5px; line-height:21px">
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">4.5承诺自己通过上传的信息</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">均真实</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">有效，自己向</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">大数信科</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">提交的任何资料均真实、有效、完整、详细、准确。</span>
            </p>
            <p style="margin-top:5px; margin-bottom:5px; line-height:21px">
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">4.6 承诺</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">E</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">数通</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">平台</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">所有内容和服务，包括但不限于平台的整体结构、网页设计、文字、图片、图表、软件、视频文件、音频文件、广告以及平台为您提供的其它信息或资料，其知识产权属</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">大数信科</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">平台或其他相关方所有，未经</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">大数信科</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">或其他相关方许可，不作任何商业目的的复制或者以其它方式进行非法使用。</span>
            </p>
            <p style="margin-top:5px; margin-bottom:5px; line-height:21px">
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">4.7 承诺在国家生效法律文书或行政处罚决定确认自己存在违法行为，或者有足够事实依据可以认定自己存在违法或违反本协议的行为，以及自己借款逾期未还的情况下，</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">大数信科</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">有权在任何形式的媒体上公布自己的违法、违约行为，并将相关信息计入任何与自己相关的信用资料，以及对自己的您账户采取暂停或关闭等措施。</span>
            </p>
            <h2 style="margin-top:10.5px; margin-bottom:10.5px">
                <span style="font-family:'宋体'; color:#353543">第五条 会员注册</span>
            </h2>
            <p style="margin-top:5px; margin-bottom:5px; line-height:21px">
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">5.1</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">大数信科</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">仅向符合中华人民共和国法律规定的具有完全民事权利能力和民事行为能力，能够独立承担民事责任的自然人和机构提供服务。若您不符合此等条件，请立即停止注册或停止使用本服务。若您违反前述限制注册使用</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">大数信科</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">的，您的监护人应对您的行为承担所有责任。</span>
            </p>
            <p style="margin-top:5px; margin-bottom:5px; line-height:21px">
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">5.2 您在注册</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">大数信科</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">时必须提供您本人真实、最新、有效及完整的信息资料，并保证电子邮件地址、联系电话、联系地址、邮政编码等内容的有效性及安全性，保证</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">大数信科</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">及其他可以通过</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">上述联系</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">方式与您进行联系。若您提供任何不真实、不准确、不完整或不能反映当前实际情况的资料，或</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">大数信科</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">有合理理由怀疑该等资料不真实、不准确、不完整或不能反映当前情况，</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">大数信科</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">有权拒绝您的申请或者</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">撤销您</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">的资格，并拒绝您在目前或将来以任何形式使用</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">大数</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">信科</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">您服务</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">，并不予任何赔偿或者退还任何已收取的服务费用。</span>
            </p>
            <p style="margin-top:5px; margin-bottom:5px; line-height:21px">
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">5.3如您代表一家公司或其他法律主体进行注册登记，则您声明和保证，您已经获得该公司或其他法律主体的充分、完整授权，该公司或其他法律主体自愿且无条件地接受本协议条款的约束。</span>
            </p>
            <p style="margin-top:5px; margin-bottom:5px; line-height:21px">
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">5.4您必须维持并及时</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">更新您</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">的资料，使其保持真实、准确、完整和反映当前情况，否则由此造成的权利不能全面有效地行使的责任由您自行承担，</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">大数信科</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">有权因此</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">取消您</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">的资格，并不予任何赔偿或者退还任何已收取的服务费用。</span>
            </p>
            <p style="margin-top:5px; margin-bottom:5px; line-height:21px">
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">5.5</span>
                <span style="font-family:'宋体'; font-size:10.5px; font-weight:bold; color:#353543">若您冒用、盗用或以其他未经授权方式使用他人资料进行注册登记的，由此引起的一切后果概由</span>
                <span style="font-family:'宋体'; font-size:10.5px; font-weight:bold; color:#353543">您独立</span>
                <span style="font-family:'宋体'; font-size:10.5px; font-weight:bold; color:#353543">承担。</span>
                <span style="font-family:'宋体'; font-size:10.5px; font-weight:bold; color:#353543">大数信科</span>
                <span style="font-family:'宋体'; font-size:10.5px; font-weight:bold; color:#353543">获悉或怀疑您未经授权使用他人资料注册的,可以采取暂停或者终止为您提供服务、立即注销您的账户等措施而无须承担任何责任。</span>
            </p>
            <p style="margin-top:5px; margin-bottom:5px; line-height:21px">
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">5.6您在注册，即视为您同意向</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">您注册</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">时填写的电子邮箱、手机号码发送与服务有关的电子邮件或短信。</span>
            </p>
            <h2 style="margin-top:10.5px; margin-bottom:10.5px">
                <span style="font-family:'宋体'; color:#353543">第六条 会员账户和密码</span>
            </h2>
            <p style="margin-top:5px; margin-bottom:5px; line-height:21px">
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">6.1您遵照注册提示，成功注册之后，即建立了自己的</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">E</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">数通</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">账户</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">，该账户具有唯一性、专有性，</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">您承诺</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">妥善保管自己的账户。您可以通过用户名和手机验证码登录账户，使用平台服务。</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">您注册</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">登记的手机号码就是您在</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">大数信科</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">的用户名。</span>
            </p>
            <p style="margin-top:5px; margin-bottom:5px; line-height:21px">
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">6.2您应妥善保管自己的用户名和</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">手机</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">验证码，确保账户及密码的机密安全。</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">您不得</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">将账户转让、赠与或授权给第三方使用。</span>
            </p>
            <p style="margin-top:5px; margin-bottom:5px; line-height:21px">
                <span style="font-family:'宋体'; font-size:10.5px; font-weight:bold; color:#353543">6.3如您发现有他人冒用或盗用您的账户及密码或任何其他未经合法授权之情形时，应立即以有效方式通知</span>
                <span style="font-family:'宋体'; font-size:10.5px; font-weight:bold; color:#353543">大数信科</span>
                <span style="font-family:'宋体'; font-size:10.5px; font-weight:bold; color:#353543">，要求暂停相关服务。同时，您理解</span>
                <span style="font-family:'宋体'; font-size:10.5px; font-weight:bold; color:#353543">大数信科</span>
                <span style="font-family:'宋体'; font-size:10.5px; font-weight:bold; color:#353543">对您的请求采取行动需要合理期限，而在</span>
                <span style="font-family:'宋体'; font-size:10.5px; font-weight:bold; color:#353543">大数信科</span>
                <span style="font-family:'宋体'; font-size:10.5px; font-weight:bold; color:#353543">采取实际行动之前，您应对</span>
                <span style="font-family:'宋体'; font-size:10.5px; font-weight:bold; color:#353543">任何或</span>
                <span style="font-family:'宋体'; font-size:10.5px; font-weight:bold; color:#353543">所有由未经授权人士使用此服务或此服务被用作未经授权用途负责，</span>
                <span style="font-family:'宋体'; font-size:10.5px; font-weight:bold; color:#353543">大数信科</span>
                <span style="font-family:'宋体'; font-size:10.5px; font-weight:bold; color:#353543">对已执行的指令及(或)所导致的您的损失不承担任何责任。</span>
            </p>
            <p style="margin-top:5px; margin-bottom:5px; line-height:21px">
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">6.5冒用或者盗用他人账户及密码的，</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">大数信科</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">及其合法授权主体保留追究实际使用人法律责任的权利。</span>
            </p>
            <p style="margin-top:5px; margin-bottom:5px; line-height:21px">
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">6.6</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">大数信</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">科</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">不会</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">通过电话、短信或电子邮件方式要求您提供您的账户、密码或其他安全信息，如果您收到声称来自</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">大数信科</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">的任何该等要求，您不应对该等要求</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">作出</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">任何回应。否则，由此造成的损失由您自行承担。</span>
            </p>
            <p style="margin-top:5px; margin-bottom:5px; line-height:21px">
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">6.8</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">您注册</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">成功之后系统将自动为您生成注册号，注册号是您在</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">大数信科</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">的永久身份标识，终生不变。为充分保障隐私，我们在交易过程中将以您的注册号替代您的姓名和/或用户名。</span>
            </p>
            <h2 style="margin-top:10.5px; margin-bottom:10.5px">
                <span style="font-family:'宋体'; color:#353543">第七条 账户注销、暂停、终止或限制访问</span>
            </h2>
            <p style="margin-top:5px; margin-bottom:5px; line-height:21px">
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">7.1您理解，需要定期或不定期地对提供服务的系统或相关的设备进行检修、维护，或对系统进行升级、改造。如因此类情况而造成服务在合理时间内的中断，大数信科无需为此承担任何责任。但大数信科应尽可能事先进行通告并根据情况在相应服务页面提前</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">作出</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">通知。</span>
            </p>
            <p style="margin-top:5px; margin-bottom:5px; line-height:21px">
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">7.2 您决定不再使用会员账户时，应首先清偿所有应付款项（包括但不限于借款本金、利息、罚息、违约金、服务费、管理费等），再将您账户下所对应的可用款项（如有）全部提现或者向</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">大数信科</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">发出其它合法的支付指令，并向</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">大数信科</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">申请注销（或永久冻结）该会员账户，经</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">大数信科</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">审核同意后可正式注销会员账户。</span>
            </p>
            <p style="margin-top:5px; margin-bottom:5px; line-height:150%; font-size:10.5px">
                <span style="font-family:'宋体'; color:#353543">7.3 会员账户和密码仅限于您本人使用，您不得以任何形式转让或出借、出租给他人使用，如果发现同一账户和密码在同一时间内被多人同时登录使用，</span>
                <span style="font-family:'宋体'; color:#353543">大数信科</span>
                <span style="font-family:'宋体'; color:#353543">有权暂停、终止或限制该用户访问直至取消该用户的会员资格，并不予任何赔偿或者退还任何已收取的服务费用。</span>
            </p>
            <p style="margin-top:0px; margin-bottom:0px; line-height:150%; font-size:10.5px">
                <span style="font-family:'宋体'; color:#353543">7.4</span>
                <span style="font-family:'宋体'; color:#353543">如发生下列任何一种情形，大数信科有权不经通知而中断或终止向您提供本协议项下的服务而无需对您或任何第三方承担任何责任：</span>
            </p>
            <p style="margin-top:0px; margin-bottom:0px; line-height:150%; font-size:10.5px">
                <span style="font-family:'宋体'; color:#353543">7.4.1</span>
                <span style="font-family:'宋体'; color:#353543">您连续</span>
                <span style="font-family:'宋体'; color:#353543">超过365天的时间内未以您的用户名和密码登录平台</span>
                <span style="font-family:'宋体'; color:#353543">；</span>
                <span style="font-family:'宋体'; color:#353543"></span>
            </p>
            <p style="margin-top:0px; margin-bottom:0px; line-height:150%; font-size:10.5px">
                <span style="font-family:'宋体'; color:#353543">7.4.2</span>
                <span style="font-family:'宋体'; color:#353543"></span>
                <span style="font-family:'宋体'; color:#353543">您的行为违反法律法规或者本协议的约定；</span>
            </p>
            <p style="margin-top:0px; margin-bottom:0px; line-height:150%; font-size:10.5px">
                <span style="font-family:'宋体'; color:#353543">7.4.3</span>
                <span style="font-family:'宋体'; color:#353543">按照法律规定或主管部门的要求</span>
                <span style="font-family:'宋体'; color:#353543">；</span>
            </p>
            <p style="margin-top:0px; margin-bottom:0px; line-height:150%; font-size:10.5px">
                <span style="font-family:'宋体'; color:#353543">7.4.4</span>
                <span style="font-family:'宋体'; color:#353543"></span>
                <span style="font-family:'宋体'; color:#353543">出于交易安全或其他必要情形；</span>
            </p>
            <p style="margin-top:5px; margin-bottom:5px; line-height:21px">
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">7.5</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">大数信科</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">有权基于反洗</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">钱及其</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">它防范利用平台侵害他人财产权利目的，对</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">您发出</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">的服务指令中明显违背常规逻辑的行为采取临时冻结措施且无需对您或任何第三方承担任何责任。您违背常规逻辑的行为包括但不限于：a、</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">在1个月内3次或以上申请借入资金并且均在1个月内提前偿还的</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">；b、其它违背常规逻辑的行为。</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">大数信科</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">将在冻结后一个工作日内通过预留电话与您沟通，经电话录音</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">确认您</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">操作的真实性后决定是否解冻及\或向公安机关报案。</span>
            </p>
            <h2 style="margin-top:10.5px; margin-bottom:10.5px">
                <span style="font-family:'宋体'; color:#353543">第八条 会员指示</span>
            </h2>
            <p style="margin-top:5px; margin-bottom:5px; line-height:21px">
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">8.1您使用用户名和密码登录</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">大数信科</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">平台后，可以按照相关服务流程和权限在网上向</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">大数信科</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">发出服务指示。有关此服务的指示，必须按</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">大数信科</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">规定的方式发出且经</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">大数信</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">科</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">实际</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">收到后，才视为已由</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">大数信科</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">收到。</span>
            </p>
            <p style="margin-top:5px; margin-bottom:5px; line-height:21px">
                <span style="font-family:'宋体'; font-size:10.5px; font-weight:bold; color:#353543">8.2</span>
                <span style="font-family:'宋体'; font-size:10.5px; font-weight:bold; color:#353543">大数信科</span>
                <span style="font-family:'宋体'; font-size:10.5px; font-weight:bold; color:#353543">通过用户名和密码来</span>
                <span style="font-family:'宋体'; font-size:10.5px; font-weight:bold; color:#353543">识别您</span>
                <span style="font-family:'宋体'; font-size:10.5px; font-weight:bold; color:#353543">的身份，您使用用户名和密码登录后在</span>
                <span style="font-family:'宋体'; font-size:10.5px; font-weight:bold; color:#353543">大数信科</span>
                <span style="font-family:'宋体'; font-size:10.5px; font-weight:bold; color:#353543">进行的一切行为或言论均视为您本人行为及真实意思表示，由此产生的法律后果由您本人承担。因黑客、病毒或密码被盗、泄露等非</span>
                <span style="font-family:'宋体'; font-size:10.5px; font-weight:bold; color:#353543">大数信</span>
                <span style="font-family:'宋体'; font-size:10.5px; font-weight:bold; color:#353543">科</span>
                <span style="font-family:'宋体'; font-size:10.5px; font-weight:bold; color:#353543">原因</span>
                <span style="font-family:'宋体'; font-size:10.5px; font-weight:bold; color:#353543">导致您账户遭他人非法使用等一切责任、损失概由您本人承担，</span>
                <span style="font-family:'宋体'; font-size:10.5px; font-weight:bold; color:#353543">大数信科</span>
                <span style="font-family:'宋体'; font-size:10.5px; font-weight:bold; color:#353543">不承担任何责任</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">。</span>
            </p>
            <p style="margin-top:5px; margin-bottom:5px; line-height:21px">
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">8.3您在使用用户名和密码登录</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">大数信科</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">平台后的任何指示，一经发出，在未经</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">大数信科</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">书面同意的情况下，一概不得取消或撤回。所有此等已发出的指示，不论由您本人或声称为您的任何其它人士发出，经</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">大数信科</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">按其诚信理解并执行后，即不可撤销，且对您有约束力。除核证您的用户名和密码外，</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">大数信科</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">并无任何责任核对任何发出此类指示的人士身份或权限，或核对此类指示的真实性。</span>
            </p>
            <p style="margin-top:5px; margin-bottom:5px; line-height:21px">
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">8.4若</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">大数信科</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">获悉或怀疑</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">您存在</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">不遵守本协议或使用服务存在不安全的情况或其它可疑情况，</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">大数信科</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">可以完全自由地酌情决定，拒绝执行或延期执行客户指示而无须承担任何责任。在该等情况下,</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">大数信科</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">将在可能的限度内，尽快通知客户。</span>
            </p>
            <p style="margin-top:5px; margin-bottom:5px; line-height:21px">
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">8.5</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">大数信科</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">仅执行</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">大数信科</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">认为合理且实际可行的指示，并将遵照一般业务惯例及程序处理。</span>
            </p>
            <h2 style="margin-top:10.5px; margin-bottom:10.5px">
                <span style="font-family:'宋体'; color:#353543">第九条 风险提示</span>
            </h2>
            <p style="margin-top:5px; margin-bottom:5px; line-height:21px">
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">9.1您了解并同意，任何通过</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">大数信科</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">进行的交易并不能必然避免以下风险的产生，</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">大数信科</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">没有义务为如下风险负责。您应依赖于个人独立判断进行交易，并对个人做出的判断承担全部责任：</span>
            </p>
            <p style="margin-top:5px; margin-bottom:5px; line-height:21px">
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">9.1.1 宏观经济风险：因宏观经济形势变化，可能引起价格等方面的异常波动，您有可能遭受的损失；</span>
            </p>
            <p style="margin-top:5px; margin-bottom:5px; line-height:21px">
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">9.1.2 政策风险：有关法律、法规及相关政策、规则发生变化，可能引起价格等方面异常波动，您有可能遭受的损失；</span>
            </p>
            <p style="margin-top:5px; margin-bottom:5px; line-height:21px">
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">9.1.3 利率风险：市场利率变化可能对购买或持有产品的实际收益产生的影响；</span>
            </p>
            <p style="margin-top:5px; margin-bottom:5px; line-height:21px">
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">9.1.4 不可抗力因素导致的风险；</span>
            </p>
            <p style="margin-top:5px; margin-bottom:5px; line-height:21px">
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">9.1.5 违约风险：因其他交易方无力或无意愿按时足额履约，您有可能遭受的损失；</span>
            </p>
            <p style="margin-top:5px; margin-bottom:5px; line-height:21px">
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">9.1.6 因您本人的过错导致的任何损失 ，该过错包括但不限于：决策失误、操作不当、遗忘或泄露密码、密码被他人破解、会员使用的计算机系统被第三方侵入、会员委托他人代理交易时他人恶意或不当操作而造成的损失。</span>
            </p>
            <p style="margin-top:5px; margin-bottom:5px; line-height:21px">
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">9.2 </span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">大数信科</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">不对任何个人会员及/或任何交易提供任何担保或条件，无论是明示、默示或法定的。</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">大数信</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">科</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">不能</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">完全保证平台内容的真实性、充分性、可靠性、准确性、完整性和有效性，也无需承担任何由此引起的法律责任。</span>
            </p>
            <p style="margin-top:5px; margin-bottom:5px; line-height:21px">
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">9.3 以上并不能揭示您通过</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">大数信科</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">进行交易的全部风险及市场的全部情形。您在做出交易决策前，应全面了解相关交易，根据自身的交易目标、风险承受能力和资产状况等谨慎决策，并自行承担全部风险。</span>
            </p>
            <h2 style="margin-top:10.5px; margin-bottom:10.5px">
                <span style="font-family:'宋体'; color:#353543">第十条 用户信息与隐私保护</span>
            </h2>
            <p style="margin-top:5px; margin-bottom:5px; line-height:21px">
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">10.1 </span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">基于对用户贷款资质综合情况的正确评估，E</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">数通可能</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">自行通过公开\私人资料来源\合作的第三方机构（包括公共网络、有权数据机构、获得用户授权的其他数据机构）收集用户信息和行为信息，并对收集结果根据本条款协议及有关文件进行查看、使用和留存操作。大数信</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">科承诺仅</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">收集“E数通”认为就此目的</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">及达成该目的</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">所必须的关于用户的信息，用户对此予以认可接受。</span>
            </p>
            <p style="margin-top:5px; margin-bottom:5px; line-height:21px">
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">10.2</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">基于对用户贷款资质综合情况的正确评估这一目的，用户同意并授权“E数通”可以自行或通过合作的第三方机构对用户提交或“</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">E</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">数通”搜集的用户基础隐私信息和其他隐私信息进行核实，并对获得的核实结果根据本协议本条款及有关文件进行查看、使用和留存操作。</span>
            </p>
            <p style="margin-top:5px; margin-bottom:5px; line-height:21px">
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">10</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">.</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">3</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">基于方便用户及时获取还款信息这一目的，用户授权并同意“E数通”可以获取、查询及导入用户在大数信科申请的贷款及贷款担保信息，为用户提供“还款计划”相关服务。</span>
            </p>
            <p style="margin-top:5px; margin-bottom:5px; line-height:21px">
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">10.4 大数信</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">科</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">对于</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">您提供的、</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">大数信科</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">自行收集的、经认证的</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">您信息</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">将按照本协议予以保护、使用或者披露。用户信息包括用户注册信息</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">、</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">个人信息</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">、</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">行为信息</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">、</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">联系人信息</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">、</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">贷款及担保信息</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">。</span>
            </p>
            <p style="margin-top:5px; margin-bottom:5px; line-height:21px">
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">10.5 </span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">大数信科</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">将依照国家有关法律法规，采取各种严格的措施确保您的信息安全，以防止未经合法授权的任何人、任何机构，包括本公司未经授权的员工或分支机构获取您的信息。但是，</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">鉴于技术</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">限制，</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">大数信</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">科</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">不能</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">确保您的全部私人通讯及其他个人资料不会被泄露出去。</span>
            </p>
            <p style="margin-top:5px; margin-bottom:5px; line-height:21px">
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">10.6 您同意，大数信科有权出于为您提供与</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">本服务</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">条款有关服务的目的，将本协议项下有关事务委托第三方处理，或将您的个人信息资料提供给大数信科认为必需的第三方，包括但不限于大数信科的关联公司、代理人、合作方、外包作业机构等。</span>
            </p>
            <p style="margin-top:5px; margin-bottom:5px; line-height:21px">
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">10.7 您同意并授权</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">大数信科</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">基于促成交易、履行协议、解决争议、调停纠纷、保障</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">大数信</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">科</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">您交易</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">安全等合法目的而</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">使用其您资料</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">（包括但不限于</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">大数信科</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">持有的有关您的档案中的资料，</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">大数信科</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">从您目前及以前在</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">大数</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">信科</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">上的</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">活动所获取的其他资料，以及</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">大数信科</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">通过其他合法方式自行收集的资料）。</span>
            </p>
            <p style="margin-top:5px; margin-bottom:5px; line-height:21px">
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">10.8 </span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">大数信科</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">可能通过公开及私人资料来源收集您的额外资料，以更好地了解您的需求，并为您度身订造</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">大数信科</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">服务、解决争议或确保在</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">大数信科</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">平台进行安全交易。</span>
            </p>
            <p style="margin-top:5px; margin-bottom:5px; line-height:21px">
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">10.9 为防止个别您通过</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">大数信科</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">从事欺诈、洗钱或其他违法犯罪活动，保护</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">大数信科</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">及</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">广大您</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">的合法权益，您同意并授权</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">大数</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">信科</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">可通过</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">人工或自动程序对您的个人信息资料进行评价。</span>
            </p>
            <p style="margin-top:5px; margin-bottom:5px; line-height:21px">
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">10.10 在不透露</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">单个您</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">隐私资料的前提下，</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">大数信科</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">有权对</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">整个您</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">数据库进行分析并对您数据库进行商业上的利用。</span>
            </p>
            <p style="margin-top:5px; margin-bottom:5px; line-height:21px">
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">10.11 </span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">您不得</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">在</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">大数信科</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">提供的交易活动中，要求</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">大数信科</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">提供其他您的个人资料。</span>
            </p>
            <p style="margin-top:5px; margin-bottom:5px; line-height:21px">
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">10.12司法机关、政府部门或其他监管机构根据有关法律、法规、规章及其他政府规范性文件的规定和程序，要求提供您的个人资料及交易信息的，有可能据此提供您的相关信息资料。</span>
            </p>
            <h2 style="margin-top:10.5px; margin-bottom:10.5px">
                <span style="font-family:'宋体'; color:#353543">第十一条 知识产权保护</span>
            </h2>
            <p style="margin-top:5px; margin-bottom:5px; line-height:21px">
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">11.1所有内容和服务，包括但不限于平台的整体结构、网页设计、文字、图片、图表、软件、视频文件、音频文件、广告以及为您提供的其它信息或资料，其知识产权属或其他相关方所有。</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">未经或</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">其他相关方许可，任何人不得为了商业目的进行复制或者以其它方式进行非法使用。</span>
            </p>
            <p style="margin-top:5px; margin-bottom:5px; line-height:21px">
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">11.2 任何未经授权许可而使用内容的行为均属于违法行为, </span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">大数信科</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">保留追究相关使用人法律责任的权利。</span>
            </p>
            <h2 style="margin-top:10.5px; margin-bottom:10.5px">
                <span style="font-family:'宋体'; color:#353543">第十二条 免责声明</span>
            </h2>
            <p style="margin-top:5px; margin-bottom:5px; line-height:21px">
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">12.1</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">大数信科不对</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">本服务</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">提供任何形式的保证，包括但不限于</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">本服务</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">符合您的需求，</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">本服务</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">不受干扰、及时提供或免于出错。</span>
            </p>
            <p style="margin-top:5px; margin-bottom:5px; line-height:21px">
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">12.2 </span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">对于本协议第七条造成的服务变更、中断或终止，大数信科不承担责任。</span>
            </p>
            <p style="margin-top:5px; margin-bottom:5px; line-height:21px">
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">12.3 </span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">您无法从大数信科获得借款的担保或允诺，无论是明示、默示的。大数信科向您提供的各种信息及资料不构成贷款的申请建议，请</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">您独立</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">判断做出决策。在借款过程中，您与贷款人之间发生的纠纷，由您与贷款人自行解决。</span>
            </p>
            <p style="margin-top:5px; margin-bottom:5px; line-height:21px">
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">12.4 </span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">您理解并同意贷款人有权自主决定是否向您授予额度或发放贷款，大数信科不</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">承诺您签署</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">本协议后一定会获得信用额度或贷款，是否获得信用额度或贷款以实际贷款人审核结果为准。</span>
            </p>
            <p style="margin-top:5px; margin-bottom:5px; line-height:21px">
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">12.5 </span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">您知晓并同意因业务需要（如贷款人资金不足或授</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">信政策</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">变化等），大数</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">信科可协调</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">已</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">给予您授信</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">的贷款人终止对您的授信，并安排您向其他贷款人申请授信和借款，您承诺</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">不</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">因此向大数信科或</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">各贷款</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">人提起抗辩。</span>
            </p>
            <p style="margin-top:5px; margin-bottom:5px; line-height:21px">
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">12.5 会员信息主要由您自行提供或发布，</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">您应</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">保证</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">所有您</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">提供的信息的真实、及时和完整，您应对</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">信息虚假、缺失和遗漏导致其他方的损失</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">承担全部责任</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">，大数信</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">科对此</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">不承担任何责任。</span>
            </p>
            <p style="margin-top:5px; margin-bottom:5px; line-height:21px">
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">12.6 任何</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">大数信科</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">之外的第三方机构或个人所提供的服务，其服务品质及内容由该第三方自行、独立负责。您享用相关服务时产生的争议、纠纷及损失，</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">大数信科</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">不承担任何责任。</span>
            </p>
            <p style="margin-top:5px; margin-bottom:5px; line-height:21px">
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">12.7 因不可抗力或服务器死机、网络故障、数据库故障、软件升级等问题造成的服务中断和对您个人数据及资料造成的损失，</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">大数信科</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">不承担任何责任，亦不予赔偿，但将尽力减少因此而给您造成的损失和影响。</span>
            </p>
            <p style="margin-top:5px; margin-bottom:5px; line-height:21px">
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">12.8 因黑客、病毒或密码被盗、泄露等非</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">大数信</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">科</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">原因</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">所造成损失概由您本人自行承担。</span>
            </p>
            <p style="margin-top:5px; margin-bottom:5px; line-height:21px">
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">12.9 </span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">您须安全使用账户，妥善保存</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">平台</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">的用户名、密码，对您保管不善造成的损失</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">大数信科</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">不承担责任。如您使用他人账户，须事先获得他人同意。一旦输入正确的用户名和密码，</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">即视您为</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">已获得他人同意。您与他人</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">之间因此</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">产生的任何纠纷与大数信科</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">无关，对您或他人的损失</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">大数信科不承担责任，并且如造成大数信</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">科损失</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">的，大数信科将保留追索的权利。</span>
            </p>
            <p style="margin-top:5px; margin-bottom:5px; line-height:21px">
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">12.10当司法机关、政府部门或其他监管机构根据有关法律、法规、规章及其他政府规范性文件的规定和程序，要求提供</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">您信息</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">资料，对据此</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">作出</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">的任何披露，概不承担责任。</span>
            </p>
            <p style="margin-top:5px; margin-bottom:5px; line-height:21px">
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">12.11除双方另有书面约定外，在任何情况下，</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">大数信科</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">对本协议所承担的违约赔偿责任总额不超过向您收取的当次</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">大数信科</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">服务费用总额。</span>
            </p>
            <h2 style="margin-top:10.5px; margin-bottom:10.5px">
                <span style="font-family:'宋体'; color:#353543">第十三条 赔偿</span>
            </h2>
            <p style="margin-top:5px; margin-bottom:5px; line-height:21px">
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">13.1您因违反本协议或本协议项下的其他文件，或违反了任何法律、法规的规定，给</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">大数信</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">科</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">造成</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">损失的，应予赔偿，赔偿范围包括但不限于</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">大数信科</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">的直接损失、间接损失以及维权费用等。</span>
            </p>
            <p style="margin-top:5px; margin-bottom:5px; line-height:21px">
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">13.2您因违反前款规定而侵害了第三方的权利，导致</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">大数信科</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">遭受任何第三方提起的索赔、诉讼或行政责任，</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">您承诺</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">无条件承担相应责任并使</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">大数信科</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">免责。若因此给</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">大数信</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">科</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">造成</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">损失的，应予赔偿，赔偿范围包括但不限于</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">大数信科</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">的维权费用、名誉损失以及</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">大数信科</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">向第三方支付的补偿金等。</span>
            </p>
            <h2 style="margin-top:10.5px; margin-bottom:10.5px">
                <span style="font-family:'宋体'; color:#353543">第十四条 签约与通知</span>
            </h2>
            <p style="margin-top:5px; margin-bottom:5px; line-height:21px">
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">14.1在平台上交易需订立的合同一律采用电子合同方式。您使用会员账户和密码登陆</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">大数信科</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">后，根据</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">大数信科</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">的相关规则，在平台上通过点击确认或类似方式签署的电子合同即视为您本人真实意愿并以会员本人名义签署的合同，具有法律效力</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">，</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">无需当面</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">验证您</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">的身份。您应妥善保管账户密码等账户信息，不得以账户密码等账户信息被盗用或其他理由否认已订立的合同的效力或不按照该等合同履行相关义务。</span>
            </p>
            <p style="margin-top:5px; margin-bottom:5px; line-height:21px">
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">14.2除非另有书面约定，</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">大数信科</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">向您个人发出的任何通知均以电子邮件或者手机短信形式发送到通知发出之时</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">您资料</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">所记载的电子邮件地址或/和手机号码，电子邮件或者短信一经发出即视为送达并产生相应法律效力。您应密切关注邮箱及手机信息。</span>
            </p>
            <p style="margin-top:5px; margin-bottom:5px; line-height:21px">
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">14.3本合同各方确认以本合同中预留的联络邮箱，作为双方之间往来及仲裁时仲裁机构送达相关材料的送达地址；并以预留的手机号码为短信通知号码。合同任何</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">一</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">方向对方及仲裁机构向双方发出的任何通知，以电子邮件或短信等形式发出，送至本合同约定邮箱或手机号码，即视为送达。如一方需要变更联络邮箱或手机号码的，应当与对方协商一致，并得到对方确认。</span>
            </p>
            <p style="margin-top:5px; margin-bottom:5px; line-height:21px">
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">14.4您同意</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">大数信</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">科</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">按照</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">通知发出之时</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">您资料</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">所记载的电子邮件或/和手机号码发出通知，</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">大数信科</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">不对您未能收到电子邮件或短信通知承担任何责任。</span>
            </p>
            <p style="margin-top:5px; margin-bottom:5px; line-height:21px">
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">14.5您确认并且同意自行主动及时登录我的账户或电子邮箱收取和查看每一份电子</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">帐单</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">/电子通知，以确定是否存在基于任何原因（包括但不限于伪造、变造、欺诈、无权限、或客户或任何其他人士的过失）所产生的任何错误、不一致等。</span>
            </p>
            <h2 style="margin-top:10.5px; margin-bottom:10.5px">
                <span style="font-family:'宋体'; color:#353543">第十五条 法律适用与争议解决</span>
            </h2>
            <p style="margin-top:5px; margin-bottom:5px; line-height:21px">
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">15.1本协议之效力、解释、变更、执行与争议解决均适用中华人民共和国法律，没有相关法律规定的，参照国际惯例和/或行业惯例。</span>
            </p>
            <p style="margin-top:5px; margin-bottom:5px; line-height:21px">
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">15.2凡因本协议产生的争议，双方应友好协商解决。协商不成的，任何一方均可向</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">深圳国际仲裁院</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">提出仲裁申请，按照仲裁时该会现行有效的网络仲裁规则进行网络仲裁并进行书面审理。仲裁裁决是终局的，对双方均有约束力。</span>
            </p>
            <h2 style="margin-top:10.5px; margin-bottom:10.5px">
                <span style="font-family:'宋体'; color:#353543">第十六条 修订与解释</span>
            </h2>
            <p style="margin-top:5px; margin-bottom:5px; line-height:21px">
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">16.1</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">大数信科</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">保留对本协议进行修订、增补和解释的权利。</span>
            </p>
            <p style="margin-top:5px; margin-bottom:5px; line-height:21px">
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">请仔细阅读以上条款，同意</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">注册请勾选</span>
                <span style="font-family:'宋体'; font-size:10.5px; color:#353543">"我同意"按钮。</span>
            </p>
            <p style="margin-top:0px; margin-bottom:0px; text-align:right; widows:0; orphans:0; font-size:12px">
                <span style="font-family:'宋体'; color:#353543">&#xa0;</span>
            </p>
            <p style="margin-top:0px; margin-bottom:0px; text-align:right; widows:0; orphans:0; font-size:12px">
                <span style="font-family:'宋体'; color:#353543">&#xa0;</span>
            </p>
            <p style="margin-top:0px; margin-bottom:0px; text-align:right; widows:0; orphans:0; font-size:12px">
                <span style="font-family:'宋体'; color:#353543">深圳大数信科技术有限公司</span>
            </p>
            <p style="margin-top:0px; margin-bottom:0px; text-align:right; widows:0; orphans:0; font-size:12px">
                <span style="font-family:'宋体'; color:#353543">20</span>
                <span style="font-family:'宋体'; color:#353543">22</span>
                <span style="font-family:'宋体'; color:#353543">/</span>
                <span style="font-family:'宋体'; color:#353543">08</span>
                <span style="font-family:'宋体'; color:#353543">/</span>
                <span style="font-family:'宋体'; color:#353543">18</span>
            </p>
            <p style="margin-top:0px; margin-bottom:0px; text-align:justify; widows:0; orphans:0; font-size:10.5px">
                <span style="font-family:'宋体'">&#xa0;</span>
            </p>
            <ol start="4" type="1" style="margin:0px; padding-left:0px">
                <li style="text-indent:21px; text-align:justify; widows:0; orphans:0; font-family:Calibri; font-size:10.5px; list-style-position:inside; -aw-list-padding-sml:8.03px">
                    <span style="font:7px 'Times New Roman'; -aw-list-padding-sml:8.03px">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;</span>
                    <span>&#xa0;</span>
                </li>
            </ol>
            <div style="-aw-headerfooter-type:footer-primary">
                <div style="-aw-sdt-tag:''">
                    <div style="-aw-sdt-tag:''">
                        <div style="-aw-sdt-tag:''">
                            <p style="margin-top:0px; margin-bottom:0px; text-align:center; widows:0; orphans:0; font-size:9px">
                                <span style="font-family:Calibri">&#xa0;</span>
                            </p>
                            <div style="-aw-sdt-tag:''">
                                <div style="-aw-sdt-tag:''">
                                    <p style="margin-top:0px; margin-bottom:0px; text-align:center; widows:0; orphans:0; font-size:9px">
                                        <span style="font-family:Calibri">&#xa0;</span>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <p style="margin-top:0px; margin-bottom:0px; widows:0; orphans:0; font-size:9px">
                    <span style="font-family:Calibri">&#xa0;</span>
                </p>
            </div>
        </div>
        <!-- <Button type="danger" text="同意"></Button> -->
      </div>
    </div>
  </div>
</template>
<script>
// import Button from '@/components/Button.vue';

export default {
  name: 'FeildTwo',
  data() {
    return {};
  },
  props: {
    hidePopup: {
      type: Function,
      default: null,
    },
  },
  mounted() {
  },
  methods: {
    close() {
      this.hidePopup();
    },
  },
};
</script>
<style scoped>
.base_color{
  width: 100%;
  height: 100%;
}
.crossBox{
  text-align: right;
}
.cross{
  font-size: 20px;
}
#container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #fff;
}
.clause{
  flex: 1;
  overflow: auto;
  background: #fff;
  background-size: contain;
}
* {
  /* width: 90%; */
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  font-size: 12px;
}
body {
  font-family: "微软雅黑";
}
.distance {
  text-align: left;

  /* margin-left: 14px; */
}
.distance_50 {
  letter-spacing: 0;
  text-align: left;
  /* text-indent: 6px; */
}
.distance_80 {
  text-align: left;

  /* margin-left: 14px; */
}
p {
  margin-bottom: 8px;
  text-align: left;
}
li, h2 {
  text-align: left;
}
#close {
  position: fixed;
  top: 0;
  left: 0;
  box-sizing: border-box;
  width: 100%;
  height: 30px;
  padding-right: 14px;
  color: white;
  font-size: 20px;
  line-height: 30px;
  text-align: right;
  background: #3d4145;
}
</style>
